import React, { useEffect, useMemo, useRef, useState } from "react";
import "./freight.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useSelector } from "react-redux";
import {
  useParams,
  useNavigate,
  Navigate,
  Link,
  useLocation,
} from "react-router-dom";
import IntlCurrencyInput from "react-intl-currency-input";
import InputMask from "react-input-mask";
import driverService from "../../service/driver.service";
import freightService from "../../service/freight.service";
import {
  Typography,
  Autocomplete,
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Popover,
  TextField,
  Chip,
  Snackbar,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import "@trendmicro/react-datepicker/dist/react-datepicker.css";
import firebase, { storage } from "../../config/firebase";
import {
  ref,
  getDownloadURL,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";
import ShipperDialog from "../../components/popup-shipper/insert-shipper";
import LoopIcon from "@mui/icons-material/Loop";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import TextArea from "antd/es/input/TextArea";
import BackButton from "../../components/backButton/BackButton";
import paymentService from "../../service/payment.service";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import notification from "../../service/sendMessage";
// import mdfeService from "../../service/mdfe.service";
import { Spin } from "antd";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InventoryIcon from "@mui/icons-material/Inventory";
import AlertDialogFreight from "./components/AlertDialogFreight";
import UploadInvoices from "./components/UploadInvoices";
import AddIcon from "@mui/icons-material/Add";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import FireTruckOutlinedIcon from "@mui/icons-material/FireTruckOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import GroupsIcon from "@mui/icons-material/Groups";
import GalleryDialog from "./components/GalleryDialog";
import FreightDriverNegotiationCard from "./components/FreightDriverNegotiationCard";
import ModernStepper from "./components/ProgressSteps";
import CancelFreightDialog from "./components/CancelFreightDialog";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import MenuIcon from "@mui/icons-material/Menu";
// import shipperService from "../../service/shipper.service";
import userService from "../../service/user.service";
import ModernAlertDialog from "./components/ModernAlertDialog";
import InvoiceList from "./components/invoiceList";
import ReceiptIcon from "@mui/icons-material/Receipt";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import stopPointMarkerIcon from "../../assets/icons/stop-point-marker.svg";

import theme from "../../theme";

import FreightEditedSuccessModal from "./components/FreightEditedSuccessModal";
import FreightCalculationLoadingModal from "./components/FreightCalculationLoadingModal";

import Utils from "../../util/utils";
import ProductTable, {
  extractSimulationFreightValue,
  isFreteProductRow,
  isFreightValueBelowProductsTotal,
  PRICING_TYPE_TON,
  resolvePricingType,
  sumPricingProductsTotal,
  syncPricingProductsWithFreightValue,
} from "../../components/Product-Table-Freight/ProductTable";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

import {
  FREIGHT_STATUS_CANCELABLE_CODES,
  FREIGHT_STATUS_CONTRACTED,
  FREIGHT_STATUS_PENDING_VALIDATION,
  STATUS_DESCRIBE_BY_CODE,
  getFreightPendingStatusByValidateAllSimulations,
  isFreightPendingValidationStatus,
  normalizeValidateAllSimulationsFlag,
  preservePendingValidationStatusIfNeeded,
  resolveFreightStatusForSave,
  applyDefaultStopStatuses,
  buildFreightAttachments,
  buildFreightCanhotos,
  calcularDistancia,
  formatName,
  geraNumeroColeta,
  getAttachmentsByStoppingPointId,
  getCanhotosByStoppingPointId,
  formatStopDocument,
  getStoppingPointDocuments,
  getStoppingPointStatusLabel,
  hasCargaOperation,
  hasDescargaOperation,
  isStopLockedForEdition,
  mergeAttachmentLists,
  mergeCanhotoLists,
  normalizeAttachmentsList,
  normalizeCanhotosList,
  normalizeStopDocuments,
  resolveStatusCode,
  resolveStatusDescribe,
  toDisplayNumeric,
  hydrateStopsCargoFromFreightSummary,
  resolveGlobalCargoValues,
  withoutMaskPhone,
  calculateFromFreightScreen,
  calculateGrossFreightProposedByShipperAction,
} from "./action/action";

import freightApi2 from "../../service/modules/freight.api";
import {
  cancelFreightById,
  getCancelFreightErrorMessage,
} from "../../util/freight/cancelFreight";
import { resolvePayingShipperFromForm } from "../../util/freight/resolvePayingShipper";
import { shouldHideDriverNegotiationFields } from "../../util/freight/freightOwnershipVisibility";

import {
  COLORS,
  SOFT_SHADOW,
  sxWrap,
  sxCard,
  sxIconBtn,
} from "./css/formFields";
import {
  cardIconSx,
  freightStopPointsThemeVars,
  freightVehicleThemeVars,
} from "../../theme/globalStyle/globalStyle";

import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import {
  freightHasCargaNFeAttached,
  getAllStoppingPointErrors,
  getAllStoppingPointErrorsForRelease,
  getStopDateOperationLabel,
  getStopImportButtonLabel,
  getStopTimeOperationLabel,
  hasPerStopCargoFreightFields,
  isFreightFormFieldRequired,
  isStopFieldRequired,
  normalizeStopOperation,
  parseStopNumericValue,
  resolveFreightAttachmentsForValidation,
  validateCargoFieldsForStops,
  validateEssentialBeforeCargaNFeAttachment,
} from "./util/stopValidation";
import {
  normalizeStoppingPointOrder,
  reorderStoppingPoints,
} from "./util/stopOrder";
import styled from "styled-components";

require("firebase/auth");

const TotalGeneralButton = styled(Button)`
  && {
    height: auto;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 16px;
    width: 100%;
    max-width: 190px;
    background-color: #012442;
    color: #ffffff;
    box-shadow: none;
  }

  &&:hover {
    border-color: #012443;
    color: #ffffff;
    background-color: #023d70;
  }
`;

const MERCHANDISE_TYPE_OPTIONS = [
  { value: "01", label: "01 - Granel Sólido" },
  { value: "02", label: "02 - Granel líquido" },
  { value: "03", label: "03 - Frigorificada" },
  { value: "04", label: "04 - Conteinerizada" },
  { value: "05", label: "05 - Carga Geral" },
  { value: "06", label: "06 - Neogranel" },
  { value: "07", label: "07 - Perigosa (granel sólido)" },
  { value: "08", label: "08 - Perigosa (granel líquido)" },
  { value: "09", label: "09 - Perigosa (carga frigorificada)" },
  { value: "10", label: "10 - Perigosa (conteinerizada)" },
  { value: "11", label: "11 - Perigosa (carga geral)" },
];

const WEIGHT_UNIT_OPTIONS = [
  { value: "kg", label: "Kilos" },
  { value: "ton", label: "Toneladas" },
];

const VEHICLE_AXLES_BY_NAME = {
  FIORINO: 2,
  "3/4": 2,
  TOCO: 2,
  VUC: 2,
  TRUCK: 3,
  "BI-TRUCK": 4,
  "CARRETA S": 5,
  "CARRETA LS": 6,
  VANDERLEIA: 6,
  "BI-TREM": 9,
  BITREM: 9,
  RODOTREM: 9,
};

const AXLE_OPTIONS = Array.from(new Set(Object.values(VEHICLE_AXLES_BY_NAME)))
  .sort((a, b) => a - b)
  .map((axles) => ({ label: `${axles} eixos`, value: String(axles) }));

function getSelectedVehicleNames(vehicleState) {
  if (!Array.isArray(vehicleState?.dados)) return [];

  return vehicleState.dados
    .filter((vehicle) => vehicle?.selected)
    .map((vehicle) => vehicle.name);
}

function getHighestAxleQuantity(vehicleState) {
  const selectedAxles = getSelectedVehicleNames(vehicleState)
    .map((vehicleName) => VEHICLE_AXLES_BY_NAME[vehicleName])
    .filter((axles) => Number.isFinite(axles));

  if (!selectedAxles.length) return "";

  return String(Math.max(...selectedAxles));
}

function getVehicleAxleOptions(vehicleNames) {
  if (!Array.isArray(vehicleNames) || !vehicleNames.length) return AXLE_OPTIONS;

  const selectedAxles = vehicleNames
    .map((vehicleName) => VEHICLE_AXLES_BY_NAME[vehicleName])
    .filter((axles) => Number.isFinite(axles));

  return Array.from(new Set(selectedAxles))
    .sort((a, b) => a - b)
    .map((vehicleAxles) => ({
      label: `${vehicleAxles} eixos`,
      value: String(vehicleAxles),
    }));
}

function sumCargoStopsNumber(formFields, field) {
  if (!Array.isArray(formFields)) return 0;
  return formFields.reduce((acc, form) => {
    if (!hasCargaOperation(form.operation)) return acc;
    const n = parseStopNumericValue(form[field]);
    if (!Number.isFinite(n)) return acc;
    return acc + n;
  }, 0);
}

function convertWeightValue(value, newUnit, oldUnit) {
  const numericValue = parseStopNumericValue(value);
  if (!Number.isFinite(numericValue) || newUnit === oldUnit) return value;
  return newUnit === "ton" ? numericValue / 1000 : numericValue * 1000;
}

function getWeightLabel(baseLabel, weightUnit) {
  return `${baseLabel} (${weightUnit === "ton" ? "Ton" : "Kg"})`;
}

function RequiredMark({ show, color = COLORS.danger }) {
  if (!show) return null;
  return (
    <>
      {" "}
      <span style={{ color }}>*</span>
    </>
  );
}

function ReadonlyField({
  id,
  label,
  value,
  config,
  currency = "BRL",
  className = "col-md-2 mb-4",
  required = false,
  isInvalidstyle = false,
}) {
  const safe =
    value === "" || value === undefined || value === null ? 0 : value;
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className="font-test"
        style={
          isInvalidstyle
            ? {
              color: COLORS.danger,
            }
            : undefined
        }
      >
        {label}
        <RequiredMark show={required} />
      </label>
      <IntlCurrencyInput
        id={id}
        disabled
        currency={currency}
        config={config}
        value={safe}
        className="form-control"
        style={{
          borderRadius: "10px",
          backgroundColor: "#f3f4f6",
          color: "#111827",
          opacity: 1,
        }}
      />
    </div>
  );
}

const normalizeClientSearchText = (value) =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

const getClientDocument = (client) =>
  String(client?.cnpj || client?.cpf || "").replace(/\D/g, "");

const getClientDisplayName = (client) =>
  String(client?.name || client?.nameFantasy || "").trim();

const getClientAddressLine = (client) => {
  const address = client?.address || {};
  const street = String(address.street || "").trim();
  const neighborhood = String(address.neighborhood || "").trim();
  const number = String(address.number || "").trim();
  const city = String(address.city || "").trim();
  const state = String(address.state || "").trim();

  return [
    [street, neighborhood].filter(Boolean).join(" - "),
    number,
    [city, state].filter(Boolean).join(" - "),
  ]
    .filter(Boolean)
    .join(", ");
};




const buildStopClientOptions = (clients) =>
  (clients || [])
    .map((client) => {
      const name = getClientDisplayName(client);
      const document = getClientDocument(client);
      const addressLine = getClientAddressLine(client);

      if (!name && !document) return null;

      return {
        id: client.id,
        label: name || document,
        searchText: normalizeClientSearchText(
          `${name} ${client?.nameFantasy || ""} ${document} ${addressLine}`,
        ),
        client,
        document,
        addressLine,
      };
    })
    .filter(Boolean);

const buildStopPatchFromClient = (client) => {
  const address = client?.address || {};
  const responsible = client?.responsible || {};
  const street = String(address.street || "").trim();
  const neighborhood = String(address.neighborhood || "").trim();

  return {
    name: getClientDisplayName(client),
    cpf_cnpj: getClientDocument(client),
    cep: address.cep || "",
    number: address.number || "",
    logradouro: [street, neighborhood].filter(Boolean).join(" - "),
    city: address.city || "",
    uf: address.state || "",
    latitude: client?.coordinates?.latitude || "",
    longitude: client?.coordinates?.longitude || "",
    responsible_phone: responsible.phoneResp || "",
    responsible_name: responsible.responsible || "",
  };
};

function FreightCopy() {


  let navigate = useNavigate();

  const location = useLocation();

  const { id, idFreight } = useParams();

  const [fromSimulation, setFromSimulation] = useState(
    location.state?.fromSimulation || false,
  );

  const user = useSelector((state) => state.user);
  const canViewFreightCoordinates =
    user?.permissoes?.freightStoppingPointLatLong?.isView === true;
  const canViewFreightPricing =
    user?.permissoes?.freightPricing?.isView === true;
  const canViewFreightDriver = user?.permissoes?.freightDriver?.isView === true;
  const canViewFreightViewEditDriver =
    user?.permissoes?.freightViewEditDriver?.isView === true;
  /** Card motorista: ativo se qualquer uma das duas permissões estiver ligada (são independentes). */
  const canViewFreightDriverNegotiationUI =
    canViewFreightViewEditDriver || canViewFreightDriver;
  const canViewFreightSection =
    user?.permissoes?.freightFreight?.isView === true;
  const canReleaseFreightByPermission =
    user?.permissoes?.freightCannotRelease?.isView === true ||
    user?.permissoes?.freightCannotRelease?.isEdit === true;
  /** Editar/selecionar motorista: permissão dedicada, ou perfil antigo sem a chave freightViewEditDriver (fallback freightDriver). */
  const canViewFreightDriverNegotiation =
    canViewFreightViewEditDriver ||
    (user?.permissoes?.freightViewEditDriver == null && canViewFreightDriver);
  const [loading, setLoading] = useState(false);

  // const [status, setStatus] = useState("Pendrente de contatação");
  const [status, setStatus] = useState("Pendente de contratação");
  const [code, setCode] = useState("01");

  const [numberSerial, setNumberSerial] = useState(Date.now());
  const [verifyPayment, setVerifyPayment] = useState(false);

  const [budgetDataSaved, setBudgetDataSaved] = useState(null);

  // Client Payment
  const [payingCustomer, setPayingCustomer] = useState("");
  const [cnpjPayingCustomer, setCnpjPayingCustomer] = useState("");

  //Veiculo
  const [occupation, setOccupation] = useState();
  const [axles, setAxles] = useState("");
  const [freeOfCharge, setFreeOfCharge] = useState();

  var nameUser = useSelector((state) => state?.user?.name);

  const [hasphoneRespContractFreigtage, setHasPhoneRespContractFreigtage] =
    useState(false);

  //Frete

  const [formFieldsOriginal, setFormFieldsOriginal] = useState("");
  const [freightOrigin, setFreightOrigin] = useState("");
  const [product, setProduct] = useState([]);
  const [operational, setOperational] = useState("");
  const [userConfirmDriverUid, setUserConfirmDriverUid] = useState("");
  const [seller, setSeller] = useState(nameUser || "");
  const [sellerId, setSellerId] = useState("");
  const [valueNF, setValueNF] = useState("");
  const [valueFreightage, setValueFreightage] = useState("");
  // Marca se o valor do frete veio de um cálculo/simulação (true) ou foi
  // inserido manualmente (false). Fretes calculados ficam bloqueados na edição
  // da precificação; os manuais podem ser alterados. Fretes antigos (sem o
  // campo) caem no default false → editáveis.
  const [pricingCalculated, setPricingCalculated] = useState(false);
  const [totalAmountRoute, setTotalAmountRoute] = useState("");
  const [weightCargo, setWeightCargo] = useState(0);
  const [weightUnit, setWeightUnit] = useState("kg");
  const [priceANTT, setPriceANTTState] = useState(0);
  const priceANTTRef = useRef(0);
  const setPriceANTT = (value) => {
    if (value === null || value === undefined || value === "") return;
    priceANTTRef.current = value;
    setPriceANTTState(value);
  };
  const [phoneRespContractFreigtage, setPhoneRespContractFreigtage] =
    useState("");
  const [valueDriverInitial, setValueDriverInitial] = useState(0);
  const [valueNegotiated, setValueNegotiated] = useState(0);
  const [paymentCondition, setPaymentCondition] = useState("");
  const [valueDriverFinal, setValueDriverFinal] = useState(0);
  const [uidDriver, setUidDriver] = useState("");
  const [observation, setObservation] = useState();
  const [internalObservations, setInternalObservations] = useState();
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [driversInFila, setDriversInFila] = useState([]);
  const [referenc, setReferenc] = useState("");
  const [driverChose, setDriverChose] = useState("");
  const [transport, setTransport] = useState({
    idTransport: "",
    name: "",
    assignedAt: "",
    assignedBy: "",
  });

  const [msgTipo, setMsgTipo] = useState();
  const [msg, setMsg] = useState();
  const [title, setTitle] = useState();

  const [carregando, setCarregando] = useState(0);
  const [freightCalculationLoading, setFreightCalculationLoading] =
    useState(false);
  const usuarioEmail = useSelector((state) => state.usuarioEmail);

  const users = useSelector((state) => state.user);
  const shippers = useSelector((state) => state.shipper);

  const [origem, setOrigem] = useState("");
  const [openOrigem, setOpenOrigem] = useState(false);
  const [openUploadInvoices, setOpenUploadInvoices] = useState(false);
  const [nfeImportNoticeOpen, setNfeImportNoticeOpen] = useState(false);
  const [openShipper, setOpenShipper] = useState(false);

  const [view, setOnlyView] = useState(location.state?.viewOnly || false);

  const isCopyFromQuery =
    new URLSearchParams(location.search).get("copy") != null;

  /**
   * Frete atribuído à transportadora logada: trava campos de carga/rota/precificação.
   * Não trava se o frete foi criado pela própria transportadora (createdByTransportId),
   * para usuários da mesma empresa (ex.: Gerar) poderem editar o que criaram.
   * viewALL nunca sofre esse lock.
   */
  const isCarrierManagedFreight = useMemo(() => {
    if (!id || isCopyFromQuery) return false;
    if (user?.viewALL === true || users?.viewALL === true) return false;
    const assignedId = String(transport?.idTransport || "").trim();
    const carrierId = String(
      users?.uidShipper || user?.uidShipper || "",
    ).trim();
    if (!assignedId || !carrierId || assignedId !== carrierId) return false;

    const createdByTransportId = String(
      freightOrigin?.createdByTransportId ?? "",
    ).trim();
    // Criado pela mesma transportadora → edição liberada entre usuários dela.
    if (createdByTransportId && createdByTransportId === carrierId) {
      return false;
    }

    return true;
  }, [
    id,
    isCopyFromQuery,
    transport?.idTransport,
    freightOrigin?.createdByTransportId,
    user?.uidShipper,
    user?.viewALL,
    users?.uidShipper,
    users?.viewALL,
  ]);

  const isViewerTransport = useMemo(() => {
    const shipperFlag =
      shippers?.isTransport === true ||
      shippers?.isTransport === 1 ||
      String(shippers?.isTransport ?? "").toLowerCase() === "true";
    return (
      shipperFlag ||
      user?.Transportadora === true ||
      user?.transportadora === true ||
      users?.Transportadora === true ||
      users?.transportadora === true
    );
  }, [shippers, user, users]);

  const isViewAllUser = useMemo(
    () => user?.viewALL === true || users?.viewALL === true,
    [user?.viewALL, users?.viewALL],
  );

  /** Embarcador em frete TRANSPORTADORA: esconde anunciado/sugerido/negociado/condição. */
  const hideDriverNegotiationForOwnership = useMemo(
    () =>
      shouldHideDriverNegotiationFields({
        freightOwnershipType: freightOrigin?.freightOwnershipType,
        viewALL: user?.viewALL === true || users?.viewALL === true,
        isViewerTransport,
      }),
    [
      freightOrigin?.freightOwnershipType,
      isViewerTransport,
      user?.viewALL,
      users?.viewALL,
    ],
  );

  const vehicleDisabled = view || isCarrierManagedFreight;

  const isFreightFinalized =
    code === "07" ||
    String(status || "")
      .trim()
      .toLowerCase() === "finalizado";

  /** Transportadora sem viewALL + frete finalizado: bloqueia Salvar/Finalizar. */
  const isCarrierSaveLocked = isCarrierManagedFreight && isFreightFinalized;

  const [nameButtonImport, setNameButtonImport] = useState("Importar Canhoto");
  const [coordinates, setCoordinates] = useState(false);

  const [currentOperationType, setCurrentOperationType] = useState("");

  const [uidShipperPayment, setUidShipperPayment] = useState("");

  const [sellersList, setSellersList] = useState([]);

  const [load, setLoad] = useState(false);
  const [loadVerify, setLoadVerify] = useState(false);
  const skipBudgetProductsSyncRef = useRef(false);
  const cargoLegacyHydratedRef = useRef(null);
  const fromSimulationRef = useRef(false);
  const simulationVehicleRef = useRef(null);

  const errosFreightCalculationRef = useRef([]);
  // Estado da seção "Grupos" (mesma lógica aplicada no frete principal).
  const [groups, setGroups] = useState([]);
  const prevHasNFeRef = useRef(null);
  const skipInitialNfeNoticeRef = useRef(true);
  // Lista exibida no card (ordem visual atual dos grupos do embarcador).
  const [shipperGroups, setShipperGroups] = useState([]);
  // Estrutura persistida no backend para manter a ordem oficial do embarcador/frete.
  const [shipperGroupOrder, setShipperGroupOrder] = useState([]);

  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const [openFreightEditedSuccessModal, setOpenFreightEditedSuccessModal] =
    useState({});
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [openReactivateDialog, setOpenReactivateDialog] = useState(false);
  const [actionsMenuAnchorEl, setActionsMenuAnchorEl] = useState(null);

  const shipperProposedGrossFreightCalculationUsersRef = useRef({
    uidUser: "",
    name: "",
    email: "",
    phone: "",
    priceANTT: "",
    proposedPrice: "",
    uidShipper: "",
    create_at: "",
  });



  const hasUsablePriceANTT = (value) => {
    if (value === null || value === undefined || value === "") return false;

    if (typeof value === "number") {
      return Number.isFinite(value) && value > 0;
    }

    const raw = String(value).trim();
    if (!raw) return false;

    const normalized =
      raw.includes(",")
        ? raw.replace(/[^\d,-]/g, "").replace(/\./g, "").replace(",", ".")
        : raw.replace(/[^\d.-]/g, "");

    return Number(normalized) > 0;
  };

  const resolvePriceANTTFromFreightDocument = (freightDocument) => {
    const candidates = [
      freightDocument?.priceANTT,
      freightDocument?.freight?.priceANTT,
      freightDocument?.shipperProposedGrossFreightCalculationUsers?.priceANTT,
      freightDocument?.driver?.valueInitial,
    ];

    return candidates.find(hasUsablePriceANTT);
  };

  const resolveCurrentPriceANTT = (...fallbacks) => {
    const candidates = [
      priceANTTRef.current,
      priceANTT,
      resolvePriceANTTFromFreightDocument(freightOrigin),
      ...fallbacks,
    ];

    return candidates.find(hasUsablePriceANTT);
  };

  /* ====> Codigo feito por Lucas */

  async function calculateGrossFreightProposedByShipper(grossFreightValue) {
    const parsedValue = Number(grossFreightValue);

    setValueFreightage(parsedValue);

    setFreightCalculationLoading(true);
    try {
      const data = await BuildDataFreight();
      if (!data) return;

      const originalPriceANTT = resolveCurrentPriceANTT(data.priceANTT);
      data.priceANTT = originalPriceANTT;
      data.freight.valueFreightage = parsedValue;

      setCarregando(3);
      const grossFreightResult =
        await calculateGrossFreightProposedByShipperAction(data);





      shipperProposedGrossFreightCalculationUsersRef.current = {
        uidUser: users.uid,
        name: users.name,
        email: users.email,
        phone: users.phone,
        priceANTT: originalPriceANTT,
        proposedPriceANTT:
          grossFreightResult.freight?.newProducts?.find(
            (item) => item.nameProducts === "Frete",
          )?.priceList || 0,
        uidShipper: users.uidShipper,
        create_at: new Date().toISOString(),
      };

      const stops = Array.isArray(grossFreightResult?.stopping_points)
        ? grossFreightResult.stopping_points
        : Array.isArray(grossFreightResult?.stops)
          ? grossFreightResult.stops
          : [];

      if (grossFreightResult) {
        applyFreteCopySimulationData(
          {
            ...grossFreightResult,
            priceANTT: originalPriceANTT,
          },
          stops,
        );
      }
    } catch (error) {
      console.error("[FreteCopy] Erro ao calcular frete:", error);
      showMessage("Não foi possível calcular o frete. Verifique a API.");
    } finally {
      setCarregando(0);
      setFreightCalculationLoading(false);
    }
  }

  const handleCalculateFreight = async ({ releaseFreight = false } = {}) => {
    setFreightCalculationLoading(true);

    const validateAllSimulations =
      await resolvePayingShipperValidateAllSimulationsForSave();
    const chosenStatus = resolveFreightStatusForSave({
      uidDriver,
      validateAllSimulations,
      releaseFreight,
      idTransport: transport?.idTransport,
    });

    const payingPayload = buildPayingShipperPayload();
    if (!payingPayload.uid) {
      setCarregando(0);
      setFreightCalculationLoading(false);
      showMessage("Selecione o Cliente Pagador (embarcador) antes de salvar.");
      return;
    }

    let customerPayment = payingPayload.customerPayment;

    let vehicle = buildVehiclePayload();

    let driverFreight = {
      uidDriver: uidDriver ? uidDriver : "",
    };

    if (uidDriver && payingPayload.uid) {
      handleDriverSaveUidShipper(uidDriver, payingPayload.uid);
    }

    let driver = {
      valueInitial: valueDriverInitial,
      valueFinal: valueDriverFinal,
      valueNegotiated: valueNegotiated,
      paymentCondition: paymentCondition,
    };

    //Ultima rota
    const orderedStops = [...formFields]
      .filter((item) => item.stop_order != null)
      .sort((a, b) => a.stop_order - b.stop_order);

    const primeiraRota = orderedStops[0];
    const ultimaRota = orderedStops[orderedStops.length - 1];

    var firstDelivery = {
      name: primeiraRota.name,
      cep: primeiraRota.cep,
      address: primeiraRota.logradouro,
      city: primeiraRota.city,
      uf:
        primeiraRota.uf.length > 2
          ? Utils.searchingState(primeiraRota.uf)
          : primeiraRota.uf,
      dateColeta: primeiraRota.date_operation,
      coordinates: {
        latitude: primeiraRota.latitude,
        longitude: primeiraRota.longitude,
      },
    };

    var lastDelivery = {
      name: ultimaRota?.name,
      cep: ultimaRota?.cep,
      address: ultimaRota?.logradouro,
      city: ultimaRota?.city,
      uf:
        ultimaRota?.uf.length > 2
          ? Utils.searchingState(ultimaRota.uf)
          : ultimaRota.uf,
      dateColeta: ultimaRota.date_operation,
      coordinates: {
        latitude: ultimaRota?.latitude,
        longitude: ultimaRota?.longitude,
      },
    };

    const payloadWeightCargo = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_weight_kg")
      : weightCargo;
    const payloadValueNF = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_value_nf")
      : valueNF;

    let freight = {
      product: "",
      axles: axles,
      newProducts: product?.length > 0 ? product : [],
      weightUnit,
      seller: seller,
      userConfirmDriver: operational ? operational : "",
      userConfirmDriverUid: userConfirmDriverUid ? userConfirmDriverUid : "",
      valueNF: payloadValueNF,
      weightCargo: payloadWeightCargo,
      valueFreightage: valueFreightage,
      pricingCalculated: pricingCalculated,
      totalAmountRoute: fromSimulation
        ? totalAmountRoute
        : calcularDistancia(
          primeiraRota.latitude,
          primeiraRota.longitude,
          ultimaRota?.latitude,
          ultimaRota?.longitude,
        ),
      observation: observation ? observation : "",
      internalObservations: internalObservations ? internalObservations : "",
      phoneRespContractFreigtage: withoutMaskPhone(phoneRespContractFreigtage),
      getDriverFreight: driverFreight,
    };

    let shipper = payingPayload.shipper;

    let user = {
      uid: users.uid,
      name: users.name,
    };

    let history = {
      initialDate: new Date(),
      initialDateContrate:
        chosenStatus.describe === "Contratado" ? new Date() : "",
      validationPendingDate:
        chosenStatus.describe === "Pendente de validação" ? new Date() : "",
      partiallyDate:
        chosenStatus.describe === "Pendente de contratação" ? new Date() : "",
      atAnaliseDate: status === "Em Analise de perfil" ? new Date() : "",
      atAnaliseDateDriver:
        status === "Em Analise do motorista" ? new Date() : "",
    };

    var data = {
      attachments: formFields.attachments,
      clientPayment: customerPayment,
      firstDelivery: firstDelivery,
      lastDelivery: lastDelivery,
      status: chosenStatus,
      numberSerial:
        id && !isCopyFromQuery && freightOrigin?.numberSerial != null
          ? freightOrigin.numberSerial
          : numberSerial,
      vehicle: vehicle,
      driver: driver,
      freight: freight,
      user: user,
      shipper: shipper,
      createUser: usuarioEmail,
      createData: new Date(),
      history: history,
      // Persiste a ordem dos grupos no próprio frete para manter rastreabilidade da negociação.
      groupOrder: shipperGroupOrder,
      transport: buildTransportPayload(transport),
      stoppingPoints: formFields,
      users: users,
    };

    try {
      setCarregando(1);
      const resultCalculateFromFreightScreen =
        await calculateFromFreightScreen(data);



      if (resultCalculateFromFreightScreen.success === false) {

        errosFreightCalculationRef.current =
          resultCalculateFromFreightScreen.errors;
        showMessage(resultCalculateFromFreightScreen.errors);
        return;
      }

      const stops = Array.isArray(
        resultCalculateFromFreightScreen?.stopping_points,
      )
        ? resultCalculateFromFreightScreen.stopping_points
        : Array.isArray(resultCalculateFromFreightScreen?.stops)
          ? resultCalculateFromFreightScreen.stops
          : [];

      if (resultCalculateFromFreightScreen) {
        applyFreteCopySimulationData(resultCalculateFromFreightScreen, stops);
      }
    } catch (error) {
      console.error("[FreteCopy] Erro ao calcular frete:", error);

      showMessage(error?.response.data?.message, "Ops! Erro ao calcular frete.");
    } finally {
      setCarregando(0);
      setFreightCalculationLoading(false);
    }
  };

  const BuildDataFreight = async ({ releaseFreight = false } = {}) => {
    const validateAllSimulations =
      await resolvePayingShipperValidateAllSimulationsForSave();
    const chosenStatus = resolveFreightStatusForSave({
      uidDriver,
      validateAllSimulations,
      releaseFreight,
      idTransport: transport?.idTransport,
    });

    const payingPayload = buildPayingShipperPayload();
    if (!payingPayload.uid) {
      setCarregando(0);
      showMessage("Selecione o Cliente Pagador (embarcador) antes de salvar.");
      return;
    }

    let customerPayment = payingPayload.customerPayment;

    let vehicle = buildVehiclePayload();

    let driverFreight = {
      uidDriver: uidDriver ? uidDriver : "",
    };

    if (uidDriver && payingPayload.uid) {
      handleDriverSaveUidShipper(uidDriver, payingPayload.uid);
    }

    let driver = {
      valueInitial: valueDriverInitial,
      valueFinal: valueDriverFinal,
      valueNegotiated: valueNegotiated,
      paymentCondition: paymentCondition,
    };

    //Ultima rota
    const orderedStops = [...formFields]
      .filter((item) => item.stop_order != null)
      .sort((a, b) => a.stop_order - b.stop_order);

    const primeiraRota = orderedStops[0];
    const ultimaRota = orderedStops[orderedStops.length - 1];

    var firstDelivery = {
      name: primeiraRota.name,
      cep: primeiraRota.cep,
      address: primeiraRota.logradouro,
      city: primeiraRota.city,
      uf:
        primeiraRota.uf.length > 2
          ? Utils.searchingState(primeiraRota.uf)
          : primeiraRota.uf,
      dateColeta: primeiraRota.date_operation,
      coordinates: {
        latitude: primeiraRota.latitude,
        longitude: primeiraRota.longitude,
      },
    };

    var lastDelivery = {
      name: ultimaRota?.name,
      cep: ultimaRota?.cep,
      address: ultimaRota?.logradouro,
      city: ultimaRota?.city,
      uf:
        ultimaRota?.uf.length > 2
          ? Utils.searchingState(ultimaRota.uf)
          : ultimaRota.uf,
      dateColeta: ultimaRota.date_operation,
      coordinates: {
        latitude: ultimaRota?.latitude,
        longitude: ultimaRota?.longitude,
      },
    };

    const payloadWeightCargo = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_weight_kg")
      : weightCargo;
    const payloadValueNF = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_value_nf")
      : valueNF;

    let freight = {
      product: "",
      axles: axles,
      newProducts: product?.length > 0 ? product : [],
      weightUnit,
      seller: seller,
      userConfirmDriver: operational ? operational : "",
      userConfirmDriverUid: userConfirmDriverUid ? userConfirmDriverUid : "",
      valueNF: payloadValueNF,
      weightCargo: payloadWeightCargo,
      valueFreightage: valueFreightage,
      pricingCalculated: pricingCalculated,
      totalAmountRoute: fromSimulation
        ? totalAmountRoute
        : calcularDistancia(
          primeiraRota.latitude,
          primeiraRota.longitude,
          ultimaRota?.latitude,
          ultimaRota?.longitude,
        ),
      observation: observation ? observation : "",
      internalObservations: internalObservations ? internalObservations : "",
      phoneRespContractFreigtage: withoutMaskPhone(phoneRespContractFreigtage),
      getDriverFreight: driverFreight,
    };

    let shipper = payingPayload.shipper;

    let user = {
      uid: users.uid,
      name: users.name,
    };

    let history = {
      initialDate: new Date(),
      initialDateContrate:
        chosenStatus.describe === "Contratado" ? new Date() : "",
      validationPendingDate:
        chosenStatus.describe === "Pendente de validação" ? new Date() : "",
      partiallyDate:
        chosenStatus.describe === "Pendente de contratação" ? new Date() : "",
      atAnaliseDate: status === "Em Analise de perfil" ? new Date() : "",
      atAnaliseDateDriver:
        status === "Em Analise do motorista" ? new Date() : "",
    };

    var data = {
      attachments: formFields.attachments,
      clientPayment: customerPayment,
      firstDelivery: firstDelivery,
      lastDelivery: lastDelivery,
      status: chosenStatus,
      numberSerial: numberSerial,
      vehicle: vehicle,
      driver: driver,
      freight: freight,
      user: user,
      shipper: shipper,
      createUser: usuarioEmail,
      createData: new Date(),
      history: history,
      // Persiste a ordem dos grupos no próprio frete para manter rastreabilidade da negociação.
      groupOrder: shipperGroupOrder,
      transport: buildTransportPayload(transport),
      stoppingPoints: formFields,
      users: users,
      priceANTT: resolveCurrentPriceANTT(priceANTT),
    };


    return data;
  };

  const getGroupName = (g) => g?.name || g?.nome || g?.descricao || "";

  // Monta o payload padronizado de groupOrder para salvar no shipper/frete.
  const buildGroupOrderToSave = (orderedGroups) => {
    const now = new Date().toISOString();

    return orderedGroups.map((g, index) => ({
      active: index === 0,
      idGroup: g.idGroup,
      date_includ: now,
      date_updated: now,
      name: getGroupName(g),
    }));
  };

  // Reordena grupos por drag-and-drop e persiste imediatamente no backend.
  const handleDragEndGroups = async (result) => {
    if (!result.destination) return;
    if (view) return;

    const items = Array.from(shipperGroups || []);
    if (items.length === 0) return;

    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);

    setShipperGroups(items);

    const groupOrder = buildGroupOrderToSave(items);

    try {
      if (selectedShipperId) {
        await db
          .collection("shipper")
          .doc(selectedShipperId)
          .update({
            groupOrder,
            groupVisualizer: items.map((g) => ({ uid: g.idGroup })),
          });
      }

      if (idFreight) {
        await db.collection("freight").doc(idFreight).update({
          groupOrder,
        });
      }

      setShipperGroupOrder(groupOrder);
    } catch (e) {
      console.error("Erro ao salvar groupOrder:", e);
    }
  };

  // Sincroniza grupos do embarcador selecionado.
  // Prioridade:
  // 1) groupOrder (quando já existe ordenação salva)
  // 2) groupVisualizer (legado) + busca dos grupos na tb_group
  const syncGroupsFromShipper = async (shipperData) => {
    if (!shipperData) {
      setShipperGroups([]);
      setShipperGroupOrder([]);
      return;
    }

    const groupOrder = Array.isArray(shipperData.groupOrder)
      ? shipperData.groupOrder.filter((group) => group?.idGroup)
      : [];

    if (groupOrder.length > 0) {
      setShipperGroups(groupOrder);
      setShipperGroupOrder(groupOrder);
      return;
    }

    const groupVisualizerIds = Array.isArray(shipperData.groupVisualizer)
      ? shipperData.groupVisualizer.map((group) => group?.uid).filter(Boolean)
      : [];

    if (groupVisualizerIds.length === 0) {
      setShipperGroups([]);
      setShipperGroupOrder([]);
      return;
    }

    try {
      const groupDocs = await Promise.all(
        groupVisualizerIds.map(async (groupId) => {
          const groupDoc = await db.collection("tb_group").doc(groupId).get();

          if (!groupDoc.exists) {
            return null;
          }

          return {
            idGroup: groupDoc.id,
            name: groupDoc.data()?.name || "",
            ...groupDoc.data(),
          };
        }),
      );

      const orderedGroups = groupDocs.filter(Boolean);

      setShipperGroups(orderedGroups);
      setShipperGroupOrder(buildGroupOrderToSave(orderedGroups));
    } catch (error) {
      console.error("Erro ao sincronizar grupos do embarcador:", error);
      setShipperGroups([]);
      setShipperGroupOrder([]);
    }
  };

  const getShipperDisplayName = (shipperData, fallback = "") => {
    const fantasyName = String(
      shipperData?.dataPersonal?.nameFantasy || "",
    ).trim();
    const socialName = String(
      shipperData?.dataPersonal?.socialName || "",
    ).trim();

    return fantasyName || socialName || fallback;
  };

  const getShipperOptionLabel = (option) => {
    if (typeof option === "string") return option;
    return getShipperDisplayName(option, "");
  };

  const normalizeShipperName = (value) =>
    String(value || "")
      .trim()
      .toLowerCase();

  const filterShipperByDisplayName = (options, { inputValue }) => {
    const normalizedInput = normalizeShipperName(inputValue);

    if (!normalizedInput) return options;

    return options.filter((option) =>
      normalizeShipperName(getShipperDisplayName(option)).includes(
        normalizedInput,
      ),
    );
  };

  async function findShipperByUID(uid) {
    if (!uid) return null;
    try {
      const doc = await db.collection("shipper").doc(uid).get();
      if (doc.exists) {
        return { id: doc.id, ...doc.data() };
      }
      return null;
    } catch (error) {
      console.error("Erro ao buscar shipper por UID:", error);
      return null;
    }
  }

  async function findShipperByNomeFantasia(nomeFantasia) {
    if (!nomeFantasia) return null;
    const normalized = String(nomeFantasia).trim();
    if (!normalized) return null;

    try {
      const query = await db
        .collection("shipper")
        .where("dataPersonal.nameFantasy", "==", normalized)
        .get();

      if (!query.empty) {
        const doc = query.docs[0];
        return { id: doc.id, ...doc.data() };
      }

      return null;
    } catch (error) {
      console.error("Erro ao buscar shipper por nome fantasia:", error);
      return null;
    }
  }

  const applyPayingCustomerFromShipper = (
    shipperData,
    { fallbackName = "", fallbackCnpj = "", fallbackUid = "" } = {},
  ) => {
    if (!shipperData) return;

    setPayingCustomer(getShipperDisplayName(shipperData, fallbackName));
    setCnpjPayingCustomer(
      shipperData?.dataPersonal?.documentNumber || fallbackCnpj || "",
    );
    setUidShipperPayment(shipperData?.id || fallbackUid || "");
    setListECShipper(shipperData);
  };

  const resolveAndApplyPaymentShipper = async (
    { name = "", cnpj = "", uid = "" } = {},
    { shouldSyncGroups = false } = {},
  ) => {
    let shipperData = null;

    if (uid) {
      shipperData = await findShipperByUID(uid);
    }

    if (!shipperData && name) {
      shipperData = await findShipperByNomeFantasia(name);
    }

    if (!shipperData) return false;

    applyPayingCustomerFromShipper(shipperData, {
      fallbackName: name,
      fallbackCnpj: cnpj,
      fallbackUid: uid,
    });

    if (shouldSyncGroups) {
      syncGroupsFromShipper(shipperData);
    }

    return true;
  };

  function normalizeTransportOptionName(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toUpperCase();
  }
  function mergeSelectionOptions(defaultState, incomingState) {
    const defaultItems = Array.isArray(defaultState?.dados)
      ? defaultState.dados
      : [];
    const incomingItems = Array.isArray(incomingState?.dados)
      ? incomingState.dados
      : Array.isArray(incomingState)
        ? incomingState
        : typeof incomingState === "string"
          ? [{ name: incomingState, selected: true }]
          : incomingState?.name
            ? [incomingState]
            : [];
    if (!incomingItems.length) return defaultState;
    const selectedNames = new Set(
      incomingItems
        .filter((item) => item?.selected === undefined || item.selected)
        .map((item) => normalizeTransportOptionName(item?.name || item)),
    );
    if (!selectedNames.size) return defaultState;

    return {
      ...defaultState,
      dados: defaultItems.map((item) => {
        const key = normalizeTransportOptionName(item.name);
        return {
          ...item,
          selected: selectedNames.has(key) ? true : Boolean(item.selected),
        };
      }),
    };
  }

  function applySimulationVehicle(vehicleData) {
    if (!vehicleData) return;

    if (vehicleData?.typeVehicle) {
      setTipoVeiculo((prev) =>
        mergeSelectionOptions(prev, vehicleData.typeVehicle),
      );
    }

    if (vehicleData?.typeBodywork) {
      setTypeBodyworkList((prev) =>
        mergeSelectionOptions(prev, vehicleData.typeBodywork),
      );
    }

    if (vehicleData?.occupation) {
      setOccupation(vehicleData.occupation);
    }

    if (vehicleData?.axles || vehicleData?.axis) {
      setAxles(String(vehicleData.axles || vehicleData.axis));
    }

    if (vehicleData?.freeOfCharge) {
      setFreeOfCharge(vehicleData.freeOfCharge);
    }
  }

  function normalizeSimulationStops(stops) {
    console.log('stops --->');
    if (!Array.isArray(stops)) return [];

    return stops.map((stop, index) => {
      const operation = Array.isArray(stop?.operation)
        ? stop.operation
        : stop?.operation
          ? [String(stop.operation)]
          : [];

      return {
        id: stop?.id || "",
        stop_order: stop?.stop_order ?? index + 1,
        name: stop?.name || "",
        cpf_cnpj: stop?.cpf_cnpj || "",
        operation,
        typeOperation: stop?.typeOperation || "",
        responsible_phone: stop?.responsible_phone || "",
        responsible_name: stop?.responsible_name || "",
        number_collect: stop?.number_collect || geraNumeroColeta(),
        date_operation: stop?.date_operation || "",
        time_operation: stop?.time_operation || "",
        type: stop?.type || "",
        descricao: stop?.descricao || "",
        cargo_weight_kg: stop?.cargo_weight_kg ?? "",
        cargo_value_nf: stop?.cargo_value_nf ?? "",
        canhoto: Array.isArray(stop?.canhoto) ? stop.canhoto : [],
        documents: normalizeStopDocuments(stop?.documents),
        invoices: normalizeStopDocuments(stop?.invoices),
        attachments: Array.isArray(stop?.attachments) ? stop.attachments : [],
        cep: stop?.cep || "",
        number: stop?.number || "",
        logradouro: stop?.logradouro || "",
        city: stop?.city || "",
        uf: stop?.uf || "",
        latitude: stop?.latitude || "",
        longitude: stop?.longitude || "",
        manualCoordinatesEnabled: Boolean(stop?.manualCoordinatesEnabled),
        verify: Boolean(stop?.verify),
        observation: stop?.observation || "",
        concluded: Boolean(stop?.concluded),
        typeCarga: Boolean(stop?.typeCarga),
        typeDescarga: Boolean(stop?.typeDescarga),
        checkItemLocation: Boolean(stop?.checkItemLocation),
        loadingStatus: operation.includes("carga")
          ? stop?.loadingStatus || "LOADING_PENDING"
          : stop?.loadingStatus || "",
        unloadingStatus: operation.includes("descarga")
          ? stop?.unloadingStatus || "UNLOADING_PENDING"
          : stop?.unloadingStatus || "",
      };
    });
  }

  const handleModalResult = (value) => {
    if (!value) return;
    setOpenSuccessModal(false);
    navigate("/freightlistCopy");
  };
  /**
   * Função que atualiza o nome do botão de importação de acordo com o tipo de operação.
   * Se o tipo for "carga", o nome do botão é "Importar Canhoto", caso contrário, o nome é "Importar imagems".
   * @param {string} index - tipo de operação.
   */
  function handleNameButtonImport(index) {
    if (index === "carga") {
      setNameButtonImport("Importar Documentos");
    } else if (index === "descarga") {
      setNameButtonImport("Importar Canhotos");
    } else {
      setNameButtonImport("Importar Documentos");
    }
  }

  /**
   * @author @Answercode2023
   * @param {*} event
   * @param {*} index
   * O código então verifica se o nome é "carga" ou "descarga"
   * e atualiza o array operation de acordo com o estado do checkbox.
   * Se a propriedade checked for verdadeira, ele define a propriedade operation como um array contendo o valor name.
   * Se for falsa, ele define operation como um array vazio.
   */
  const handleCheckBoxChange = (event, index) => {
    const { name, checked } = event.target;

    if (index < 0 || (name !== "carga" && name !== "descarga")) {
      return;
    }

    setFormFields((prev) => {
      if (index >= prev.length) return prev;

      const data = [...prev];
      const currentStop = { ...data[index] };
      const currentOperation = normalizeStopOperation(currentStop.operation);

      if (checked) {
        currentStop.operation = [name];
        if (name === "carga") {
          // Canhoto é exclusivo de descarga
          currentStop.canhoto = "";
        }
      } else {
        currentStop.operation = currentOperation.filter((op) => op !== name);
      }

      data[index] = currentStop;
      return data;
    });
  };

  const handleProductsChange = (newProducts) => {
    setProduct(newProducts);
    const total = sumPricingProductsTotal(newProducts);

    if (fromSimulationRef.current || location.state?.fromSimulation) {
      setValueFreightage(total);
      return;
    }

    if (skipBudgetProductsSyncRef.current) {
      skipBudgetProductsSyncRef.current = false;
      setLoad(true);
      setLoadVerify(true);
      return;
    }

    setValueFreightage(total);

    if (!load) {
      setLoad(true);
    }
  };

  useEffect(() => {
    /**
     * Atualiza os campos operation e phoneRespContractFreight com base nos dados do motorista
     *
     * @returns {void}
     */
    const setPhoneFields = () => {
      if (driverChose !== "") {
        if (!hasphoneRespContractFreigtage) {
          setPhoneRespContractFreigtage(users?.phoneNumber);
        }
      }
    };

    setPhoneFields();
  }, [driverChose, hasphoneRespContractFreigtage, users?.phoneNumber]);

  /**
   * Carrega vendedores (isSeller) do embarcador logado e afiliados.
   */
  async function loadingSellers() {
    try {
      const shipperIds = userService.getShipperIdsFromUser(users);
      const list = await userService.getSellersByShipperIds(shipperIds);

      setSellersList(list.filter((seller) => seller.isSeller === true));
    } catch (error) {
      console.error("Erro ao carregar vendedores:", error);
    }
  }

  useEffect(() => {
    if (!users?.uid) return;
    loadingSellers();
  }, [users?.uid, users?.uidShipper]);

  // Default seller to logged-in user once Redux name is available (new freight / race on mount).
  useEffect(() => {
    if (!nameUser) return;
    setSeller((prev) => (prev ? prev : nameUser));
  }, [nameUser]);

  // Resolve sellerId when we have seller name but no id (legacy freights / default user).
  useEffect(() => {
    if (sellerId || !seller || !sellersList?.length) return;
    const match = sellersList.find(
      (s) => String(s?.name || "").trim() === String(seller).trim(),
    );
    if (match?.id) {
      setSellerId(match.id);
    }
  }, [seller, sellerId, sellersList]);

  {
    /* ====> Codigo acima feito por Lucas */
  }

  const db = firebase.firestore();

  const [typeBodyworkList, setTypeBodyworkList] = useState({
    dados: [
      { name: "BAÚ", selected: false },
      { name: "BAÚ FRIGORIFICO", selected: false },
      { name: "BAÚ REFRIGERADO", selected: false },
      { name: "SIDER", selected: false },
      { name: "CAÇAMBA", selected: false },
      { name: "GRADE BAIXA", selected: false },
      { name: "GRANELEIRO", selected: false },
      { name: "PLATAFORMA", selected: false },
      { name: "PRANCHA", selected: false },
      { name: "APENAS CAVALO", selected: false },
      { name: "BUG PORTA CONTAINER", selected: false },
      { name: "CAVAQUEIRA", selected: false },
      { name: "CEGONHEIRO", selected: false },
      { name: "GAIOLA", selected: false },
      { name: "HOPPER", selected: false },
      { name: "MUNCK", selected: false },
      { name: "SILLO", selected: false },
      { name: "TANQUE", selected: false },
    ],
  });

  {
    /**formFields representa um ponto de parada*/
  }
  const [formFields, setFormFields] = useState([
    {
      id: "",
      stop_order: 1,
      name: "",
      cpf_cnpj: "",
      operation: ['carga'],
      typeOperation: "",
      responsible_phone: "",
      responsible_name: "",
      number_collect: geraNumeroColeta(),
      date_operation: "",
      time_operation: "",
      type: "5",
      descricao: "",
      cargo_weight_kg: "",
      cargo_value_nf: "",
      canhoto: "",
      documents: [],
      invoices: [],
      attachments: [],
      cep: "",
      number: "",
      logradouro: "",
      city: "",
      uf: "",
      latitude: "",
      longitude: "",
      manualCoordinatesEnabled: false,
      verify: false,
      observation: "",
      concluded: false,
      typeCarga: false,
      typeDescarga: false,
      checkItemLocation: false,
      loadingStatus: "LOADING_PENDING",
      unloadingStatus: "",
    },

    {
      id: "",
      stop_order: 2,
      name: "",
      cpf_cnpj: "",
      operation: [],
      typeOperation: "",
      responsible_phone: "",
      responsible_name: "",
      number_collect: geraNumeroColeta(),
      date_operation: "",
      time_operation: "",
      type: "",
      descricao: "",
      cargo_weight_kg: "",
      cargo_value_nf: "",
      canhoto: "",
      documents: [],
      invoices: [],
      attachments: [],
      cep: "",
      number: "",
      logradouro: "",
      city: "",
      uf: "",
      latitude: "",
      longitude: "",
      manualCoordinatesEnabled: false,
      verify: false,
      observation: "",
      concluded: false,
      typeCarga: false,
      typeDescarga: false,
      checkItemLocation: false,
      loadingStatus: "",
      unloadingStatus: "",
    },
  ]);

  const [isFormValid, setIsFormValid] = useState(false);

  const getFreightAttachmentsForValidation = () =>
    resolveFreightAttachmentsForValidation(
      formFields,
      freightOrigin?.attachments ?? [],
    );

  const getStopValidationContext = () => ({
    freightAttachments: getFreightAttachmentsForValidation(),
    canViewFreightSection,
    formFields,
    weightCargo,
    valueNF,
  });

  const addFields = () => {
    let object = {
      id: "",
      stop_order: formFields.length + 1,
      name: "",
      cpf_cnpj: "",
      operation: [],
      responsible_phone: "",
      responsible_name: "",
      number_collect: geraNumeroColeta(),
      date_operation: "",
      time_operation: "",
      type: "",
      descricao: "",
      cargo_weight_kg: "",
      cargo_value_nf: "",
      canhoto: "",
      documents: [],
      invoices: [],
      attachments: [],
      cep: "",
      number: "",
      logradouro: "",
      city: "",
      latitude: "",
      longitude: "",
      manualCoordinatesEnabled: false,
      verify: false,
      observation: "",
      concluded: false,
      typeCarga: "",
      typeDescarga: "",
      checkItemLocation: false,
      loadingStatus: "",
      unloadingStatus: "",
    };
    setFormFields([...formFields, object]);
  };

  const [tipoVeiculo, setTipoVeiculo] = useState({
    dados: [
      { name: "FIORINO", selected: false },
      { name: "3/4", selected: false },
      { name: "TOCO", selected: false },
      { name: "VUC", selected: false },
      { name: "TRUCK", selected: false },
      { name: "BI-TRUCK", selected: false },
      { name: "BI-TREM", selected: false },
      { name: "CARRETA S", selected: false },
      { name: "CARRETA LS", selected: false },
      { name: "RODOTREM", selected: false },
      { name: "VANDERLEIA", selected: false },
    ],
  });

  useEffect(() => {
    setAxles(getHighestAxleQuantity(tipoVeiculo));
  }, [tipoVeiculo]);

  function buildVehiclePayload() {
    const selectedVehicleAxles = getHighestAxleQuantity(tipoVeiculo);

    return {
      typeVehicle: tipoVeiculo,
      typeBodywork: typeBodyworkList,
      occupation,
      axles: selectedVehicleAxles || axles,
      freeOfCharge,
    };
  }

  const validateForm = () => {
    if (!cnpjPayingCustomer || !payingCustomer) return false;

    const stopContext = getStopValidationContext();
    const hasLinkedDriver = Boolean(uidDriver);
    const hasNFe = freightHasCargaNFeAttached(
      formFields,
      stopContext.freightAttachments,
    );

    if (hasNFe) {
      if (!occupation) return false;
      if (!axles) return false;
      if (!freeOfCharge) return false;
      if (canViewFreightSection && !seller) return false;
    }

    if (canViewFreightDriver && hasLinkedDriver) {
      if (
        !isCarrierManagedFreight &&
        !hideDriverNegotiationForOwnership &&
        !valueDriverInitial
      )
        return false;
      const isPendingContract =
        code === "01" || status === "Pendente de contratação";
      if (
        !isCarrierManagedFreight &&
        !hideDriverNegotiationForOwnership &&
        isPendingContract &&
        !valueDriverFinal
      ) {
        return false;
      }
      if (!hideDriverNegotiationForOwnership && !valueNegotiated) return false;
      if (!hideDriverNegotiationForOwnership && !paymentCondition) return false;
    }

    if (canViewFreightSection && hasNFe) {
      const perStopCargo = hasPerStopCargoFreightFields(formFields);
      if (perStopCargo) {
        if (!valueFreightage) return false;
        for (const stop of formFields) {
          if (!hasCargaOperation(stop.operation)) continue;
          const w = parseStopNumericValue(stop.cargo_weight_kg);
          const nf = parseStopNumericValue(stop.cargo_value_nf);
          if (!Number.isFinite(w) || w <= 0) return false;
          if (!Number.isFinite(nf) || nf <= 0) return false;
        }
      } else {
        const globalWeight = parseStopNumericValue(weightCargo);
        const globalValueNF = parseStopNumericValue(valueNF);
        if (!Number.isFinite(globalValueNF) || globalValueNF <= 0) return false;
        if (!Number.isFinite(globalWeight) || globalWeight <= 0) return false;
        if (!valueFreightage) return false;
      }
    }

    if (!formFields || formFields.length === 0) {
      return false;
    }

    if (hasNFe) {
      const hasSelectedVehicle = tipoVeiculo?.dados?.some((v) => v.selected);
      const hasSelectedBodywork = typeBodyworkList?.dados?.some(
        (v) => v.selected,
      );
      if (!hasSelectedVehicle || !hasSelectedBodywork) {
        return false;
      }
    }

    const stopErrors = getAllStoppingPointErrors(formFields, stopContext, {
      // Frete gerenciado pela transportadora tem paradas desabilitadas:
      // não cobrar a regra de primeiro ponto de Carga ao vincular motorista.
      hasLinkedDriver: hasLinkedDriver && !isCarrierManagedFreight,
    });
    if (stopErrors.length > 0) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    const isValid = validateForm();
    setIsFormValid(isValid);
  }, [
    cnpjPayingCustomer,
    payingCustomer,
    valueDriverInitial,
    valueDriverFinal,
    occupation,
    freeOfCharge,
    seller,
    operational,
    valueNF,
    weightCargo,
    valueFreightage,
    uidDriver,
    valueNegotiated,
    paymentCondition,
    formFields,
    coordinates,
    freightOrigin,
    tipoVeiculo,
    typeBodyworkList,
    isCarrierManagedFreight,
    hideDriverNegotiationForOwnership,
  ]);

  useEffect(() => {
    const freightAttachments = getFreightAttachmentsForValidation();
    const hasNFe = freightHasCargaNFeAttached(formFields, freightAttachments);

    if (skipInitialNfeNoticeRef.current) {
      prevHasNFeRef.current = hasNFe;
      skipInitialNfeNoticeRef.current = false;
      return;
    }

    if (hasNFe && prevHasNFeRef.current === false) {
      setNfeImportNoticeOpen(true);
    }

    prevHasNFeRef.current = hasNFe;
  }, [formFields, freightOrigin?.attachments]);

  useEffect(() => {
    if (!id) return undefined;

    const freightUnsub = db
      .collection("freight")
      .doc(id)
      .onSnapshot(
        (docSnap) => {
          const data = docSnap.data();
          if (!data) return;

          setFreightOrigin((prev) => {
            if (!prev || typeof prev !== "object") {
              return data;
            }
            return {
              ...prev,
              attachments: data.attachments ?? prev.attachments,
            };
          });
        },
        (error) => {
          // Transportadora pode não ter regra client no Firestore; load principal é via API.
          console.warn("[FreteCopy] snapshot freight ignorado:", error?.code || error);
        },
      );

    const stopsUnsub = db
      .collection("freight")
      .doc(id)
      .collection("stopping_points")
      .onSnapshot(
        (snapshot) => {
          if (snapshot.empty) return;

          setFormFields((prev) => {
            if (!prev?.length) return prev;

            return prev.map((stop) => {
              const pointDoc = snapshot.docs.find((doc) => doc.id === stop.id);
              if (!pointDoc) return stop;

              const pointData = pointDoc.data();
              const stopId = stop.id || pointDoc.id;

              return {
                ...stop,
                attachments: mergeAttachmentLists(
                  normalizeAttachmentsList(stop.attachments, stopId),
                  normalizeAttachmentsList(pointData.attachments, stopId),
                ),
                invoices: normalizeStopDocuments(pointData.invoices),
                documents: normalizeStopDocuments(pointData.documents),
              };
            });
          });
        },
        (error) => {
          console.warn(
            "[FreteCopy] snapshot stopping_points ignorado:",
            error?.code || error,
          );
        },
      );

    return () => {
      freightUnsub();
      stopsUnsub();
    };
  }, [id]);

  /**
   * Mapeia stopping_points (API ou Firestore) para o shape do formulário.
   */
  function buildFormFieldsFromStoppingPoints(
    stoppingPoints,
    freightData,
    isCopyMode,
  ) {
    const listResult = [];
    const freightSummary = freightData?.freight || {};
    const freightAttachments = normalizeAttachmentsList(freightData?.attachments);
    const freightCanhotos = normalizeCanhotosList(freightData?.canhoto);
    const stops = Array.isArray(stoppingPoints) ? stoppingPoints : [];

    stops.forEach((point) => {
      const pointData = point?.data && typeof point.data === "function"
        ? point.data()
        : point || {};
      const pointId = String(point?.id || pointData?.id || "").trim();
      const operation = normalizeStopOperation(pointData.operation);
      const canhotosFromMainDocument = getCanhotosByStoppingPointId(
        freightCanhotos,
        pointId,
      );
      const legacyStopCanhotos = normalizeCanhotosList(
        pointData.canhoto,
        pointId,
      );
      const stopCanhotos = mergeCanhotoLists(
        canhotosFromMainDocument,
        legacyStopCanhotos,
        pointId,
      );
      const attachmentsFromMainDocument = getAttachmentsByStoppingPointId(
        freightAttachments,
        pointId,
      );
      const legacyStopAttachments = normalizeAttachmentsList(
        pointData.attachments,
        pointId,
      );
      const stopAttachments = mergeAttachmentLists(
        attachmentsFromMainDocument,
        legacyStopAttachments,
      );

      if (isCopyMode === true) {
        const copyLoadingStatus = operation.includes("carga")
          ? "LOADING_PENDING"
          : "";
        const copyUnloadingStatus = operation.includes("descarga")
          ? "UNLOADING_PENDING"
          : "";

        listResult.push({
          unloadingStatus: copyUnloadingStatus,
          loadingStatus: copyLoadingStatus,
          id: pointId,
          stop_order: pointData.stop_order,
          name: pointData.name,
          cpf_cnpj: pointData.cpf_cnpj,
          operation,
          responsible_phone: pointData.responsible_phone,
          responsible_name: pointData.responsible_name,
          number_collect: pointData.number_collect,
          date_operation: "",
          time_operation: "",
          canhoto: [],
          documents: [],
          invoices: [],
          attachments: [],
          cep: pointData.cep,
          number: pointData.number,
          logradouro: pointData.logradouro,
          city: pointData.city,
          uf: pointData.uf,
          latitude: pointData.latitude,
          longitude: pointData.longitude,
          manualCoordinatesEnabled:
            pointData.manualCoordinatesEnabled || false,
          verify: false,
          observation: "",
          concluded: false,
          type: "",
          descricao: "",
          cargo_weight_kg: "",
          cargo_value_nf: "",
        });
        return;
      }

      const canShowStopCanhoto = hasDescargaOperation(operation);
      listResult.push({
        id: pointId,
        stop_order: pointData.stop_order,
        name: pointData.name,
        cpf_cnpj: pointData.cpf_cnpj,
        operation,
        responsible_phone: pointData.responsible_phone,
        responsible_name: pointData.responsible_name,
        number_collect: pointData.number_collect,
        date_operation: pointData.date_operation,
        time_operation: pointData.time_operation,
        canhoto: canShowStopCanhoto
          ? stopCanhotos.length > 0
            ? stopCanhotos
            : ""
          : "",
        documents: normalizeStopDocuments(pointData.documents),
        invoices: normalizeStopDocuments(pointData.invoices),
        attachments: stopAttachments,
        cep: pointData.cep,
        number: pointData.number,
        logradouro: pointData.logradouro,
        city: pointData.city,
        uf: pointData.uf,
        latitude: pointData.latitude,
        longitude: pointData.longitude,
        verify: pointData.verify,
        observation: pointData.observation,
        concluded: pointData.concluded,
        type: pointData.type,
        descricao: pointData.descricao,
        cargo_weight_kg: pointData.cargo_weight_kg ?? "",
        cargo_value_nf: pointData.cargo_value_nf ?? "",
        unloadingStatus: operation.includes("descarga")
          ? pointData.unloadingStatus || "UNLOADING_PENDING"
          : pointData.unloadingStatus || "",
        loadingStatus: operation.includes("carga")
          ? pointData.loadingStatus || "LOADING_PENDING"
          : pointData.loadingStatus || "",
      });
    });

    const hydratedListResult = hydrateStopsCargoFromFreightSummary(
      listResult,
      freightSummary,
    );

    return { hydratedListResult, freightSummary };
  }

  function applyStoppingPointsToForm(freightData, isCopyMode) {
    const { hydratedListResult, freightSummary } =
      buildFormFieldsFromStoppingPoints(
        freightData?.stopping_points,
        freightData,
        isCopyMode,
      );

    if (!hasPerStopCargoFreightFields(hydratedListResult)) {
      const resolvedCargo = resolveGlobalCargoValues(
        hydratedListResult,
        freightSummary,
      );
      setWeightCargo(resolvedCargo.weightCargo);
      setValueNF(resolvedCargo.valueNF);
    }

    if (hydratedListResult.length > 0) {
      const firstOp = hydratedListResult[0]?.operation?.[0];
      if (firstOp) handleNameButtonImport(firstOp);
    }

    setFormFieldsOriginal(hydratedListResult);
    setFormFields(hydratedListResult);
  }

  /** @deprecated Prefer loadFreightFromApi — mantido para compat. */
  const loadingPoints = (isCopyMode) => {
    if (!id) return [];
    // Fallback Firestore se chamado isolado (ex.: hot reload legado).
    db.collection("freight")
      .doc(id)
      .collection("stopping_points")
      .get()
      .then(async (result) => {
        const freightSnapshot = await db.collection("freight").doc(id).get();
        const freightData = {
          ...(freightSnapshot.data() || {}),
          stopping_points: result.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          })),
        };
        applyStoppingPointsToForm(freightData, isCopyMode);
        setCarregando(0);
      })
      .catch((error) => {
        setCarregando(0);
        console.error("Erro ao carregar pontos de parada:", error);
        setMsgTipo("erro");
        setTitle(" Ops!");
        setMsg(
          "Não foi possível carregar os pontos de parada do frete. Verifique suas permissões e tente novamente.",
        );
        setOpen(true);
      });
    return [];
  };

  const [listClient, setListClient] = useState([]);
  const [listECClient, setListECClient] = useState([]);

  const stopClientOptions = useMemo(
    () => buildStopClientOptions(listClient),
    [listClient],
  );

  const handleChangeClient = (event) => {
    applyPayingCustomerFromShipper(event);
    syncGroupsFromShipper(event);
  };

  const [listShipper, setListShipper] = useState([]);
  const [listECShipper, setListECShipper] = useState("Embarcador");

  const listTransportadoras = useMemo(
    () =>
      (Array.isArray(listShipper) ? listShipper : []).filter((shipperItem) =>
        Boolean(shipperItem?.isTransport),
      ),
    [listShipper],
  );

  const transportOptions = useMemo(() => {
    if (!transport?.idTransport) return listTransportadoras;

    const alreadyListed = listTransportadoras.some(
      (item) => item.id === transport.idTransport,
    );
    if (alreadyListed) return listTransportadoras;

    return [
      {
        id: transport.idTransport,
        companyNameFantasy: transport.name,
        dataPersonal: { companyNameFantasy: transport.name },
        isTransport: true,
      },
      ...listTransportadoras,
    ];
  }, [listTransportadoras, transport]);

  const selectedTransportOption = useMemo(() => {
    if (!transport?.idTransport) return null;

    const fromList = transportOptions.find(
      (item) => item.id === transport.idTransport,
    );
    if (fromList) return fromList;

    return {
      id: transport.idTransport,
      companyNameFantasy: transport.name,
      dataPersonal: { companyNameFantasy: transport.name },
      isTransport: true,
    };
  }, [transport, transportOptions]);

  const buildTransportPayload = (
    selectedTransport,
    previousTransport = null,
  ) => {
    const idTransport = selectedTransport?.idTransport || "";
    const name = selectedTransport?.name || "";

    if (!idTransport) {
      return {
        idTransport: "",
        name: "",
        assignedAt: "",
        assignedBy: "",
      };
    }

    const sameTransport =
      previousTransport?.idTransport &&
      previousTransport.idTransport === idTransport;
    const assignedAt = sameTransport
      ? previousTransport.assignedAt || new Date().toISOString()
      : new Date().toISOString();
    const assignedBy = sameTransport
      ? previousTransport.assignedBy || user?.uid || ""
      : user?.uid || "";

    return {
      idTransport,
      name,
      assignedAt,
      assignedBy,
    };
  };

  const handleTransportSelect = (value) => {
    if (!value?.id) {
      setTransport({
        idTransport: "",
        name: "",
        assignedAt: "",
        assignedBy: "",
      });
      return;
    }

    const nextId = value.id;
    const sameTransport = transport?.idTransport === nextId;

    setTransport({
      idTransport: nextId,
      name: getShipperDisplayName(value, transport?.name || ""),
      assignedAt: sameTransport ? transport?.assignedAt || "" : "",
      assignedBy: sameTransport ? transport?.assignedBy || "" : "",
    });
  };

  const clearTransportAssignment = () => {
    setTransport({
      idTransport: "",
      name: "",
      assignedAt: "",
      assignedBy: "",
    });
  };

  /** viewALL + motorista: preenche transportadora com o shipper do usuário logado. */
  const applyLoggedUserTransportForViewAll = () => {
    const carrierId = String(
      users?.uidShipper || user?.uidShipper || "",
    ).trim();
    if (!carrierId) {
      clearTransportAssignment();
      return;
    }

    const fromList =
      (Array.isArray(listShipper)
        ? listShipper.find((item) => item.id === carrierId)
        : null) ||
      (shippers?.id === carrierId || shippers?.uid === carrierId
        ? shippers
        : null);

    const name = fromList
      ? getShipperDisplayName(
          fromList,
          fromList?.companyNameFantasy ||
            fromList?.dataPersonal?.companyNameFantasy ||
            "",
        )
      : "";

    setTransport({
      idTransport: carrierId,
      name: name || transport?.name || "",
      assignedAt: "",
      assignedBy: user?.uid || users?.uid || "",
    });
  };

  /** viewALL: com motorista, garante transportadora do usuário logado (e o nome quando a lista carregar). */
  useEffect(() => {
    if (!isViewAllUser || view) return;
    if (!uidDriver) return;
    const carrierId = String(
      users?.uidShipper || user?.uidShipper || "",
    ).trim();
    if (!carrierId) return;
    const currentId = String(transport?.idTransport || "").trim();
    if (currentId && currentId !== carrierId) return;
    if (currentId === carrierId && String(transport?.name || "").trim()) return;
    applyLoggedUserTransportForViewAll();
  }, [
    isViewAllUser,
    view,
    uidDriver,
    users?.uidShipper,
    user?.uidShipper,
    listShipper,
    transport?.idTransport,
    transport?.name,
  ]);

  // uidShipperPayment pode vir como string (fluxo antigo) ou objeto (fluxo novo).
  const selectedShipperId = resolvePayingShipperFromForm({
    uidShipperPayment,
    listECShipper,
  });

  const getPayingShipperUid = () =>
    resolvePayingShipperFromForm({ uidShipperPayment, listECShipper });

  const findPayingShipperInList = () => {
    const payingUid = getPayingShipperUid();
    if (!payingUid || !Array.isArray(listShipper)) return null;
    return (
      listShipper.find((shipperItem) => shipperItem.id === payingUid) || null
    );
  };

  const resolvePayingShipperData = () => {
    const fromList = findPayingShipperInList();
    if (fromList) return fromList;
    if (
      listECShipper &&
      typeof listECShipper === "object" &&
      listECShipper.id
    ) {
      return listECShipper;
    }
    return null;
  };

  const buildPayingShipperPayload = () => {
    const payingUid = getPayingShipperUid();
    const payingShipper = resolvePayingShipperData();

    return {
      uid: payingUid,
      name: getShipperDisplayName(payingShipper, payingCustomer),
      customerPayment: {
        name: payingCustomer,
        cnpj: cnpjPayingCustomer,
        uid: payingUid,
      },
      shipper: {
        uid: payingUid,
        name: getShipperDisplayName(payingShipper, payingCustomer),
      },
    };
  };

  useEffect(() => {
    // Em edição / frete da transportadora: não sobrescrever o pagador do frete
    // com o único shipper da lista (geralmente a própria transportadora).
    if (id || isCarrierManagedFreight) return;
    if (listShipper.length !== 1) return;
    if (getPayingShipperUid()) return;

    const uniqueShipper = listShipper[0];
    if (!uniqueShipper || listECShipper?.id === uniqueShipper.id) return;
    // Não auto-selecionar transportadora como pagador — isso classificava o frete
    // como Fortio/TRANSPORTADORA mesmo sem transportadora atribuída.
    if (uniqueShipper?.isTransport === true) return;

    applyPayingCustomerFromShipper(uniqueShipper);
    syncGroupsFromShipper(uniqueShipper);
  }, [id, isCarrierManagedFreight, listShipper, listECShipper, uidShipperPayment]);

  const readValidateAllSimulationsFromShipper = (shipperData) =>
    normalizeValidateAllSimulationsFlag(
      shipperData?.financial?.validateAllSimulations,
    );

  const getPayingShipperValidateAllSimulations = () => {
    const fromList = findPayingShipperInList();
    if (fromList) {
      return readValidateAllSimulationsFromShipper(fromList);
    }

    const payingUid = getPayingShipperUid();
    if (
      payingUid &&
      (shippers?.id === payingUid || shippers?.uid === payingUid)
    ) {
      return readValidateAllSimulationsFromShipper(shippers);
    }

    return false;
  };

  async function resolvePayingShipperValidateAllSimulationsForSave() {
    const payingUid = getPayingShipperUid();
    if (!payingUid) return false;

    const fromList = findPayingShipperInList();
    if (fromList) {
      return readValidateAllSimulationsFromShipper(fromList);
    }

    if (shippers?.id === payingUid || shippers?.uid === payingUid) {
      if (shippers?.financial != null) {
        return readValidateAllSimulationsFromShipper(shippers);
      }
    }

    const shipperData = await findShipperByUID(payingUid);
    return readValidateAllSimulationsFromShipper(shipperData);
  }

  useEffect(() => {
    if (id) return;
    const pending = getFreightPendingStatusByValidateAllSimulations(
      getPayingShipperValidateAllSimulations(),
    );
    setStatus(pending.describe);
    setCode(pending.code);
  }, [id, uidShipperPayment, listECShipper, listShipper, shippers]);

  async function loadingShipper() {
    try {
      if (users?.viewALL) {
        // Se tem permissão para ver todos, busca todos os shippers
        const result = await db.collection("shipper").get();
        const shippers = [];

        result.docs.forEach((doc) => {
          shippers.push({
            id: doc.id,
            ...doc.data(),
          });
        });

        // TODO Esta tudo okay
        setListShipper(shippers);
        setCarregando(0);
      } else {
        // Verifica se há shippers afiliados
        if (
          users?.uidShipperAffiliates &&
          Array.isArray(users.uidShipperAffiliates)
        ) {
          const affiliateUids = Array.isArray(users?.uidShipperAffiliates)
            ? users.uidShipperAffiliates
            : [];
          const primaryUid = users?.uidShipper ? [users.uidShipper] : [];
          const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

          const shippers = [];

          // Busca cada shipper pelos IDs
          for (const uid of uids) {
            try {
              const docRef = db.collection("shipper").doc(uid);
              const docSnap = await docRef.get();

              if (docSnap.exists) {
                shippers.push({
                  id: docSnap.id,
                  ...docSnap.data(),
                });
              }
            } catch (err) {
              console.error(`Erro ao buscar shipper ${uid}:`, err);
            }
          }

          setListShipper(shippers);
          setCarregando(0);
        } else {
          // Busca apenas o shipper principal
          const result = await db
            .collection("shipper")
            .doc(users.uidShipper)
            .get();

          if (result.exists) {
            setListShipper([
              {
                id: result.id,
                ...result.data(),
              },
            ]);
          }
          setCarregando(0);
        }
      }
    } catch (error) {
      setCarregando(0);
      console.error("Erro ao buscar shippers:", error);
    }
  }

  async function loadingCustomer() {
    try {
      const activeUser = user;
      let documents = [];

      if (activeUser?.viewALL) {
        const result = await db.collection("client").get();
        documents = result.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      } else {
        const affiliateUids = Array.isArray(activeUser?.uidShipperAffiliates)
          ? activeUser.uidShipperAffiliates
          : [];
        const primaryUid = activeUser?.uidShipper
          ? [activeUser.uidShipper]
          : [];
        const shipperUids = Array.from(
          new Set([...affiliateUids, ...primaryUid]),
        ).filter(Boolean);

        if (shipperUids.length === 0) {
          documents = [];
        } else if (shipperUids.length === 1) {
          const result = await db
            .collection("client")
            .where("uidShipper", "==", shipperUids[0])
            .get();
          documents = result.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
        } else {
          const snapshots = await Promise.all(
            shipperUids
              .reduce((chunks, uid, index) => {
                const chunkIndex = Math.floor(index / 10);
                if (!chunks[chunkIndex]) chunks[chunkIndex] = [];
                chunks[chunkIndex].push(uid);
                return chunks;
              }, [])
              .map((chunk) =>
                db.collection("client").where("uidShipper", "in", chunk).get(),
              ),
          );

          const clientsById = new Map();
          snapshots.forEach((snapshot) => {
            snapshot.docs.forEach((doc) => {
              clientsById.set(doc.id, { id: doc.id, ...doc.data() });
            });
          });
          documents = Array.from(clientsById.values());
        }
      }

      setListClient(documents);
      setListECClient([]);
      setCarregando(0);
    } catch (error) {
      setCarregando(0);
      console.error(error);
    }
  }

  function loadingQueue() {
    const affiliateUids = Array.isArray(user?.uidShipperAffiliates)
      ? user.uidShipperAffiliates
      : [];
    const shipperUids = Array.from(
      new Set([
        ...affiliateUids,
        ...(user?.uidShipper ? [user.uidShipper] : []),
      ]),
    );

    driverService
      .getDriversByShipperAccess({
        viewAll: Boolean(user?.viewALL),
        shipperUids,
      })
      .then((result) => {
        const listDriverInFila = [];

        result.docs.forEach(async (doc) => {
          const driverData = {
            id: doc.id,
            ...doc.data(),
          };

          const allDataRef = db
            .collection("drivers_users")
            .doc(doc.id)
            .collection("documents")
            .doc("allData");

          const allDataSnapshot = await allDataRef.get();

          if (allDataSnapshot.exists) {
            const extraData = allDataSnapshot.data();

            // Usa optional chaining para evitar erro quando personalData não existe
            const personal = extraData?.personalData || {};

            // Sobrescrevemos ou adicionamos os campos que o Autocomplete usa
            driverData.name = personal.fullName || driverData.name || "";
            driverData.cpf = personal.documentCpf || driverData.cpf || "";
          }

          // Verifica se a coleção myFreightList existe
          const myFreightListRef = db
            .collection("drivers_users")
            .doc(doc.id)
            .collection("myFreightsList");

          const myFreightListSnapshot = await myFreightListRef.get();

          // Adiciona uma propriedade para priorizar quem possui myFreightList
          driverData.hasMyFreightList = !myFreightListSnapshot.empty;

          listDriverInFila.push(driverData);

          // Após verificar todos os motoristas, organiza a lista
          if (listDriverInFila.length === result.docs.length) {
            const sortedList = listDriverInFila.sort((a, b) => {
              return b.hasMyFreightList - a.hasMyFreightList;
            });

            const withMyFreightList = sortedList.filter(
              (driver) => driver.hasMyFreightList,
            );
            const withoutMyFreightList = sortedList.filter(
              (driver) => !driver.hasMyFreightList,
            );

            const separatedList = [
              {
                __separator: true,
                name: "",
                cpf: "",
                value: "",
                id: "__sep_queue_top__",
                uid: "",
              },
              ...withMyFreightList,
              {
                __separator: true,
                name: "",
                cpf: "",
                value: "",
                id: "__sep_queue_mid__",
                uid: "",
              },
              ...withoutMyFreightList,
            ];

            setDriversInFila(separatedList);
            setCarregando(0);
          }
        });
      })
      .catch((error) => {
        setCarregando(0);
        console.error("Error loading driver queue:", error);
      });
  }

  async function searchIdPayment(id) {
    try {
      const dataDadoPayment = await paymentService.getEspecifico(id);

      const verifyData = dataDadoPayment.filter(
        (item) =>
          item.status?.toLowerCase() === "pago" ||
          item.status?.toLowerCase() === "solicitar pagamento",
      );

      if (verifyData.length > 0) {
        setVerifyPayment(true);
      }
    } catch (error) {
      console.error("Erro ao buscar pagamento:", error);
    }
  }

  async function loadFreightFromApi(isCopyMode) {
    if (!id) {
      setCarregando(0);
      return;
    }

    setCarregando(1);

    try {
      const response = await freightApi2.getById(id, {
        uidShipper: users?.uidShipper || user?.uidShipper || "",
        idUser: users?.uid || user?.uid || "",
      });
      const freight = response?.data?.data ?? response?.data ?? null;

      if (!freight || typeof freight !== "object") {
        setCarregando(0);
        setMsgTipo("erro");
        setTitle(" Ops!");
        setMsg("Frete não encontrado.");
        setOpen(true);
        return;
      }

      const freightWithId = {
        ...freight,
        id: freight.id || id,
      };

      setFreightOrigin(freightWithId);

      const clientPayment = freightWithId.clientPayment || {};
      const vehicle = freightWithId.vehicle || {};
      const driver = freightWithId.driver || {};
      const freightTage = freightWithId.freight || {};

      if (isCopyMode === true) {
        setNumberSerial(numberSerial);
        setUidDriver("");
        setDriverChose("");
        setOperational("");
        setUserConfirmDriverUid("");
        setObservation("");
        setInternalObservations("");
      } else {
        const statusDescribeFromDb = resolveStatusDescribe(freightWithId?.status);
        const statusCodeFromDb = resolveStatusCode(
          freightWithId?.status,
          statusDescribeFromDb,
        );

        setNumberSerial(freightWithId.numberSerial);
        setStatus(
          statusDescribeFromDb ||
            STATUS_DESCRIBE_BY_CODE[statusCodeFromDb] ||
            "Pendente de contratação",
        );
        setCode(statusCodeFromDb || "01");

        const driverUid = String(
          freightTage?.getDriverFreight?.uidDriver ?? "",
        ).trim();
        setUidDriver(driverUid);

        setObservation(freightTage.observation || "");
        setInternalObservations(freightTage.internalObservations || "");

        if (driverUid) {
          try {
            const itemDriver = await driverService.getDriverAvailable(driverUid);
            if (itemDriver.exists) setDriverChose(itemDriver.data());
          } catch (erro) {
            console.error(erro);
          }
        }
      }

      setPriceANTT(resolvePriceANTTFromFreightDocument(freightWithId));

      setPayingCustomer(clientPayment.name || "");
      setCnpjPayingCustomer(clientPayment.cnpj || "");
      setUidShipperPayment(clientPayment.uid || "");
      const paymentShipperApplied = await resolveAndApplyPaymentShipper(
        {
          name: clientPayment.name || "",
          cnpj: clientPayment.cnpj || "",
          uid: clientPayment.uid || "",
        },
        { shouldSyncGroups: false },
      );
      if (!paymentShipperApplied && clientPayment.uid) {
        setListECShipper({
          id: clientPayment.uid,
          dataPersonal: {
            nameFantasy: clientPayment.name || "",
            socialName: clientPayment.name || "",
            documentNumber: clientPayment.cnpj || "",
          },
        });
      }

      if (isCopyMode === true) {
        const loggedInValidateAllSimulations =
          await resolvePayingShipperValidateAllSimulationsForSave();
        const copyPendingStatus = getFreightPendingStatusByValidateAllSimulations(
          loggedInValidateAllSimulations,
        );
        setStatus(copyPendingStatus.describe);
        setCode(copyPendingStatus.code);
      }

      const freightGroupOrder = Array.isArray(freightWithId?.groupOrder)
        ? freightWithId.groupOrder.filter((group) => group?.idGroup)
        : [];
      const hasFreightGroupOrder = freightGroupOrder.length > 0;

      if (hasFreightGroupOrder) {
        setShipperGroups(freightGroupOrder);
        setShipperGroupOrder(freightGroupOrder);
      }

      if (!hasFreightGroupOrder && clientPayment.uid) {
        try {
          const shipperDoc = await db
            .collection("shipper")
            .doc(clientPayment.uid)
            .get();
          if (shipperDoc.exists) {
            syncGroupsFromShipper({
              id: shipperDoc.id,
              ...shipperDoc.data(),
            });
          } else {
            setShipperGroups([]);
            setShipperGroupOrder([]);
          }
        } catch (error) {
          console.error("Erro ao sincronizar grupos do embarcador:", error);
          setShipperGroups([]);
          setShipperGroupOrder([]);
        }
      } else if (!hasFreightGroupOrder) {
        setShipperGroups([]);
        setShipperGroupOrder([]);
      }

      setTipoVeiculo((prev) =>
        mergeSelectionOptions(prev, vehicle.typeVehicle),
      );
      setTypeBodyworkList((prev) =>
        mergeSelectionOptions(prev, vehicle.typeBodywork),
      );
      setOccupation(vehicle.occupation);
      setAxles(vehicle.axles || vehicle.axis || "");
      setFreeOfCharge(vehicle.freeOfCharge);

      setValueDriverInitial(driver.valueInitial ?? 0);
      setValueDriverFinal(driver.valueFinal ?? 0);
      setValueNegotiated(driver.valueNegotiated ?? 0);
      setPaymentCondition(driver.paymentCondition || "");
      setTransport(
        isCopyMode
          ? {
              idTransport: "",
              name: "",
              assignedAt: "",
              assignedBy: "",
            }
          : {
              idTransport: freightWithId?.transport?.idTransport || "",
              name: freightWithId?.transport?.name || "",
              assignedAt: freightWithId?.transport?.assignedAt || "",
              assignedBy: freightWithId?.transport?.assignedBy || "",
            },
      );

        // Frete
        setProduct(
          freightTage?.newProducts?.length > 0 ? freightTage.newProducts : [],
        );
        setSeller(freightTage.seller || nameUser || "");
        setSellerId(freightTage.sellerId || "");
      setOperational(
        freightTage.userConfirmDriver || freightTage.operational || "",
      );
        setUserConfirmDriverUid(freightTage.userConfirmDriverUid || "");
        setHasPhoneRespContractFreigtage(
          freightTage.phoneRespContractFreigtage ? true : false,
        );
        
        setPhoneRespContractFreigtage(freightTage.phoneRespContractFreigtage || "");
        setWeightUnit(freightTage.weightUnit || "kg");
        const resolvedCargo = resolveGlobalCargoValues([], freightTage);
        setWeightCargo(resolvedCargo.weightCargo);
        setValueNF(resolvedCargo.valueNF);
        setValueFreightage(toDisplayNumeric(freightTage.valueFreightage, ""));
        // Fretes sem o campo (legado) são tratados como manuais → editáveis.
        setPricingCalculated(freightTage?.pricingCalculated === true);

        setLoad(true);

        // ???
        setTotalAmountRoute(freightTage.totalAmountRoute);

      applyStoppingPointsToForm(freightWithId, isCopyMode);

      setLoad(true);
      setCarregando(0);
    } catch (error) {
      console.error("[FreteCopy] Erro ao carregar frete via API:", error);
      setMsgTipo("erro");
      setCarregando(0);
      setTitle(" Ops!");
      setMsg(
        error?.response?.data?.message ||
          "Não foi possível carregar o frete no momento, por favor tente mais tarde.",
      );
      setOpen(true);
    }
  }

  /** Alias legado — preferir loadFreightFromApi. */
  function loadingInit(isCopyMode) {
    return loadFreightFromApi(isCopyMode);
  }

  const { search } = useLocation();

  const params = new URLSearchParams(search);
  var isCopy = params.get("copy") === null ? false : true;

  const [idVerify, setId] = useState(id);

  const clientScopeKey = [
    user?.viewALL,
    user?.uidShipper,
    ...(Array.isArray(user?.uidShipperAffiliates)
      ? user.uidShipperAffiliates
      : []),
  ].join("|");

  useEffect(() => {
    if (location.state?.fromSimulation) {
      loadingShipper();
      return;
    }

    let isCopyTemp = isCopy === false ? false : true;

    if (isCopyTemp === false) {
      if (idVerify) {
        loadFreightFromApi(false);
        searchIdPayment(idVerify);
      }
    } else {
      loadFreightFromApi(true);
      setId(null);
    }

    loadingShipper();
  }, [idVerify, isCopy]);

  useEffect(() => {
    if (!user?.uid) return;
    loadingCustomer();
  }, [clientScopeKey, user?.uid]);

  useEffect(() => {
    cargoLegacyHydratedRef.current = null;
  }, [idVerify]);

  useEffect(() => {
    const summary = freightOrigin?.freight;
    if (!summary || !idVerify || cargoLegacyHydratedRef.current === idVerify) {
      return;
    }
    if (!Array.isArray(formFields) || formFields.length === 0) return;

    const hydrated = hydrateStopsCargoFromFreightSummary(formFields, summary);
    const stopsChanged =
      JSON.stringify(hydrated) !== JSON.stringify(formFields);

    if (stopsChanged) {
      setFormFields(hydrated);
      setFormFieldsOriginal(hydrated);
    }

    const fieldsForResolve = stopsChanged ? hydrated : formFields;

    if (!hasPerStopCargoFreightFields(fieldsForResolve)) {
      const resolved = resolveGlobalCargoValues(fieldsForResolve, summary);
      setWeightCargo(resolved.weightCargo);
      setValueNF(resolved.valueNF);
    }

    cargoLegacyHydratedRef.current = idVerify;
  }, [freightOrigin, formFields, idVerify]);

  useEffect(() => {
    if (!location.state?.fromBudget || !location.state?.budgetData) return;

    const budgetData = location.state.budgetData;
    const stops = location.state.stops || [];

    setBudgetDataSaved({
      budgetId: location.state.budgetId,
      budgetData,
      stops,
    });

    if (budgetData.clientPayment) {
      setPayingCustomer(budgetData.clientPayment.name || "");
      setCnpjPayingCustomer(budgetData.clientPayment.cnpj || "");
      setUidShipperPayment(budgetData.clientPayment.uid || "");
      setListECShipper(budgetData.clientPayment.name || "");

      resolveAndApplyPaymentShipper(
        {
          name: budgetData.clientPayment.name || "",
          cnpj: budgetData.clientPayment.cnpj || "",
          uid: budgetData.clientPayment.uid || "",
        },
        { shouldSyncGroups: true },
      )
        .then((appliedBudgetPaymentShipper) => {
          if (!appliedBudgetPaymentShipper) {
            setListECShipper(budgetData.clientPayment.name || "");
            setShipperGroups([]);
            setShipperGroupOrder([]);
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar shipper:", error);
          setListECShipper(budgetData.clientPayment.name || "");
          setShipperGroups([]);
          setShipperGroupOrder([]);
        });
    }

    if (budgetData.vehicle) {

      setTipoVeiculo((prev) =>
        mergeSelectionOptions(prev, budgetData.vehicle.typeVehicle),
      );
      setTypeBodyworkList((prev) =>
        mergeSelectionOptions(prev, budgetData.vehicle.typeBodywork),
      );
      setOccupation(budgetData.vehicle.occupation || "");
      setAxles(budgetData.vehicle.axles || budgetData.vehicle.axis || "");
      setFreeOfCharge(budgetData.vehicle.freeOfCharge || "");
    }

    if (budgetData.pricing?.products) {
      skipBudgetProductsSyncRef.current = true;
      setProduct(budgetData.pricing.products || []);
    }

    if (budgetData.summary) {
      setSeller(budgetData.summary.seller || "");
      setSellerId(budgetData.summary.sellerId || "");
      setWeightUnit(budgetData.summary.weightUnit || "kg");
      setWeightCargo(toDisplayNumeric(budgetData.summary.weightCargo, 0));
      setValueNF(toDisplayNumeric(budgetData.summary.valueNF, ""));
      setValueFreightage(
        toDisplayNumeric(budgetData.summary.valueFreightage, ""),
      );
      setPaymentCondition(budgetData.summary.paymentCondition || "");
      setObservation(budgetData.summary.observation || "");
    }

    if (budgetData.numberSerial) {
      setNumberSerial(budgetData.numberSerial);
    }

    if (stops.length > 0) {
      const normalizedStops = stops.map((stop) => ({
        ...stop,
        operation: normalizeStopOperation(stop?.operation),
      }));
      setFormFields(normalizedStops);
      setFormFieldsOriginal(normalizedStops);
    }

    window.history.replaceState({}, document.title);
  }, [location.state]);

  function applyFreteCopySimulationData(
    simulationData,
    simulationStops = [],
    { shouldReplaceHistory = false } = {},
  ) {


    if (!simulationData) return;
    fromSimulationRef.current = true;
    // Valor derivado de cálculo/simulação → precificação bloqueada na edição.
    setPricingCalculated(true);

    const clientPayment =
      simulationData?.clientPayment || simulationData?.client_payment || {};
    const vehicle = simulationData?.vehicle || {};
    const freightData = simulationData?.freight || {};
    simulationVehicleRef.current = vehicle;

    if (clientPayment?.name || clientPayment?.cnpj || clientPayment?.uid) {
      setPayingCustomer(clientPayment.name || "");
      setCnpjPayingCustomer(clientPayment.cnpj || "");
      setUidShipperPayment(clientPayment.uid || "");

      resolveAndApplyPaymentShipper(
        {
          name: clientPayment.name || "",
          cnpj: clientPayment.cnpj || "",
          uid: clientPayment.uid || "",
        },
        { shouldSyncGroups: true },
      ).catch((error) => {
        console.error("Erro ao aplicar pagador da simulação:", error);
      });
    }

    applySimulationVehicle(vehicle);



    if (hasUsablePriceANTT(simulationData?.priceANTT)) {
      setPriceANTT(simulationData.priceANTT);
    }

    setSeller(freightData?.seller || nameUser || "");
    setSellerId(freightData?.sellerId || "");
    setWeightUnit(freightData?.weightUnit || "kg");

    if (freightData?.weightCargo !== undefined) {
      setWeightCargo(freightData.weightCargo);
    }

    if (freightData?.valueNF !== undefined) {
      setValueNF(freightData.valueNF);
    }

    if (freightData?.paymentCondition) {
      setPaymentCondition(freightData.paymentCondition);
    }

    if (freightData?.observation) {
      setObservation(freightData.observation);
    }

    // Em edição de frete existente, nunca trocar o numberSerial pelo Date.now() da simulação
    const existingSerial = freightOrigin?.numberSerial;
    const isEditingExistingFreight = Boolean(
      id && !isCopyFromQuery && existingSerial != null && existingSerial !== "",
    );
    if (simulationData?.numberSerial && !isEditingExistingFreight) {
      setNumberSerial(simulationData.numberSerial);
    }

    if (simulationData?.driver?.valueFinal) {
      setValueDriverFinal(simulationData?.driver.valueFinal);

    }

    if (simulationData?.driver?.valueNegotiated) {
      setValueNegotiated(simulationData?.driver?.valueNegotiated);
    }

    if (simulationData?.driver?.valueInitial) {
      setValueDriverInitial(simulationData?.driver?.valueInitial);
    }

    if (simulationData?.freight?.internalObservations !== undefined) {
      setInternalObservations(simulationData.freight.internalObservations);
    }

    if (simulationData?.freight?.totalAmountRoute !== undefined) {
      setTotalAmountRoute(simulationData.freight.totalAmountRoute);
    }



    const simulationFreightValue =
      extractSimulationFreightValue(simulationData);

    if (simulationFreightValue !== undefined) {
      setValueFreightage(simulationFreightValue);
    }

    const simulationProducts = syncPricingProductsWithFreightValue(
      simulationData?.freight?.newProducts || freightData?.newProducts || [],
      simulationFreightValue,
    );

    if (simulationFreightValue !== undefined || simulationProducts.length > 0) {
      setProduct(simulationProducts);
    }

    const simulationWeightCargo = parseStopNumericValue(
      freightData?.weightCargo,
    );
    const simulationValueNF = parseStopNumericValue(freightData?.valueNF);

    if (Number.isFinite(simulationWeightCargo)) {
      setWeightCargo(simulationWeightCargo);
    }

    if (Number.isFinite(simulationValueNF)) {
      setValueNF(simulationValueNF);
    }

    const normalizedStops = normalizeSimulationStops(simulationStops);


    let simulationCargoApplied = false;
    const stopsWithSimulationCargo = normalizedStops.map((stop) => {
      if (simulationCargoApplied || !hasCargaOperation(stop.operation)) {
        return stop;
      }

      simulationCargoApplied = true;

      return {
        ...stop,
        cargo_weight_kg:
          stop.cargo_weight_kg !== undefined &&
            stop.cargo_weight_kg !== null &&
            stop.cargo_weight_kg !== ""
            ? stop.cargo_weight_kg
            : Number.isFinite(simulationWeightCargo)
              ? simulationWeightCargo
              : stop.cargo_weight_kg,
        cargo_value_nf:
          stop.cargo_value_nf !== undefined &&
            stop.cargo_value_nf !== null &&
            stop.cargo_value_nf !== ""
            ? stop.cargo_value_nf
            : Number.isFinite(simulationValueNF)
              ? simulationValueNF
              : stop.cargo_value_nf,
      };
    });

    if (stopsWithSimulationCargo.length > 0) {
      setFormFields(stopsWithSimulationCargo);
      setFormFieldsOriginal(stopsWithSimulationCargo);
      handleNameButtonImport(stopsWithSimulationCargo[0]?.operation?.[0]);
    }

    if (shouldReplaceHistory) {
      window.history.replaceState({}, document.title);
    }
  }

  useEffect(() => {
    if (!location.state?.fromSimulation || !location.state?.simulationData) {
      return;
    }

    const simulationData = location.state.simulationData || {};
    const simulationStops = Array.isArray(location.state?.stops)
      ? location.state.stops
      : Array.isArray(simulationData?.stopping_points)
        ? simulationData.stopping_points
        : Array.isArray(simulationData?.stops)
          ? simulationData.stops
          : [];

    applyFreteCopySimulationData(simulationData, simulationStops, {
      shouldReplaceHistory: true,
    });
  }, [location.state]);

  /**
   * Monitora a variável users e chama loadingQueue() quando users.uidShipper estiver disponível.
   */
  useEffect(() => {
    if (users && users.uidShipper) {
      loadingQueue();
    }
  }, [users]);

  /**
   * Busca os dados do shipper baseado no ID armazenado no Redux (users.uidShipper).
   */
  useEffect(() => {
    if (idVerify || id) return;
    if (getPayingShipperUid()) return;
    // Quando o frete nasce de um orcamento aprovado, preservamos o pagador vindo do orcamento.
    if (location.state?.fromBudget || budgetDataSaved) return;

    /**
     * Busca os dados do shipper baseado no ID armazenado no Redux (users.uidShipper)
     * e atualiza o estado com os dados encontrados.
     * Se o shipper for encontrado, seta o estado com o nome da empresa e o CNPJ.
     * Caso contr rio, n o realiza nenhuma a o.
     */
    const searchForShipper = async () => {
      try {
        const fretesEncontrados = await freightService.getShipperById(
          users.uidShipper,
        );
        applyPayingCustomerFromShipper(fretesEncontrados, {
          fallbackUid: users.uidShipper,
        });
        syncGroupsFromShipper(fretesEncontrados);
      } catch (error) {
        console.error("Erro ao buscar fretes:", error);
      }
    };

    searchForShipper();
  }, [users, location.state, budgetDataSaved, id, idVerify, uidShipperPayment]);

  async function handleDriverSaveUidShipper(uidDriver, uidShipperFreight) {
    try {
      const driverRef = await driverService.getDriverDocumentsUID(uidDriver);

      if (!driverRef || driverRef.empty) {
        console.error("Motorista não encontrado para o UID:", uidDriver);
        return;
      }

      const driverData = driverRef.docs[0].data();

      let currentList;

      if (Array.isArray(driverData.uidShipper)) {
        currentList = driverData.uidShipper; // já é array mantém
      } else if (typeof driverData.uidShipper === "string") {
        currentList = [driverData.uidShipper]; // string vira array
      } else {
        currentList = []; // undefined/null []
      }

      if (currentList.includes(uidShipperFreight)) {
        return;
      }

      // Atualiza no serviço
      await driverService.updateDriverUidShipper(
        uidDriver,
        uidShipperFreight,
        currentList,
      );


    } catch (error) {
      console.error("Erro ao salvar UID do embarcador:", error);
    }
  }

  async function save({ releaseFreight = false } = {}) {
    setMsgTipo("erro");
    setCarregando(1);

    if (!validInput()) return;

    const validateAllSimulations =
      await resolvePayingShipperValidateAllSimulationsForSave();
    const chosenStatus = resolveFreightStatusForSave({
      uidDriver,
      validateAllSimulations,
      releaseFreight,
      idTransport: transport?.idTransport,
    });

    const payingPayload = buildPayingShipperPayload();
    if (!payingPayload.uid) {
      setCarregando(0);
      showMessage("Selecione o Cliente Pagador (embarcador) antes de salvar.");
      return;
    }

    let customerPayment = payingPayload.customerPayment;

    let vehicle = buildVehiclePayload();

    let driverFreight = {
      uidDriver: uidDriver ? uidDriver : "",
    };

    if (uidDriver && payingPayload.uid) {
      handleDriverSaveUidShipper(uidDriver, payingPayload.uid);
    }

    let driver = {
      valueInitial: valueDriverInitial,
      valueFinal: valueDriverFinal,
      valueNegotiated: valueNegotiated,
      paymentCondition: paymentCondition,
    };

    //Ultima rota
    const orderedStops = [...formFields]
      .filter((item) => item.stop_order != null)
      .sort((a, b) => a.stop_order - b.stop_order);

    const primeiraRota = orderedStops[0];
    const ultimaRota = orderedStops[orderedStops.length - 1];

    var firstDelivery = {
      name: primeiraRota.name,
      cep: primeiraRota.cep,
      address: primeiraRota.logradouro,
      city: primeiraRota.city,
      uf:
        primeiraRota.uf.length > 2
          ? Utils.searchingState(primeiraRota.uf)
          : primeiraRota.uf,
      dateColeta: primeiraRota.date_operation,
      coordinates: {
        latitude: primeiraRota.latitude,
        longitude: primeiraRota.longitude,
      },
    };

    var lastDelivery = {
      name: ultimaRota?.name,
      cep: ultimaRota?.cep,
      address: ultimaRota?.logradouro,
      city: ultimaRota?.city,
      uf:
        ultimaRota?.uf.length > 2
          ? Utils.searchingState(ultimaRota.uf)
          : ultimaRota.uf,
      dateColeta: ultimaRota.date_operation,
      coordinates: {
        latitude: ultimaRota?.latitude,
        longitude: ultimaRota?.longitude,
      },
    };

    const payloadWeightCargo = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_weight_kg")
      : weightCargo;
    const payloadValueNF = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_value_nf")
      : valueNF;

    let freight = {
      product: "",
      axles: axles,
      newProducts: product?.length > 0 ? product : [],
      weightUnit,
      seller: seller || nameUser || "",
      sellerId: sellerId || users?.uid || "",
      userConfirmDriver: operational ? operational : "",
      userConfirmDriverUid: userConfirmDriverUid ? userConfirmDriverUid : "",
      valueNF: payloadValueNF,
      weightCargo: payloadWeightCargo,
      valueFreightage: valueFreightage,
      pricingCalculated: pricingCalculated,
      totalAmountRoute: fromSimulation
        ? totalAmountRoute
        : calcularDistancia(
          primeiraRota.latitude,
          primeiraRota.longitude,
          ultimaRota?.latitude,
          ultimaRota?.longitude,
        ),
      observation: observation ? observation : "",
      internalObservations: internalObservations ? internalObservations : "",
      phoneRespContractFreigtage: withoutMaskPhone(phoneRespContractFreigtage),
      getDriverFreight: driverFreight,
    };

    let shipper = payingPayload.shipper;

    let user = {
      uid: users.uid,
      name: users.name,
    };

    let history = {
      initialDate: new Date(),
      initialDateContrate:
        chosenStatus.describe === "Contratado" ? new Date() : "",
      validationPendingDate:
        chosenStatus.describe === "Pendente de validação" ? new Date() : "",
      partiallyDate:
        chosenStatus.describe === "Pendente de contratação" ? new Date() : "",
      atAnaliseDate: status === "Em Analise de perfil" ? new Date() : "",
      atAnaliseDateDriver:
        status === "Em Analise do motorista" ? new Date() : "",
    };

    var data = {
      attachments: formFields.attachments,
      clientPayment: customerPayment,
      firstDelivery: firstDelivery,
      lastDelivery: lastDelivery,
      status: chosenStatus,
      numberSerial: numberSerial,
      vehicle: vehicle,
      driver: driver,
      freight: freight,
      user: user,
      shipper: shipper,
      createUser: usuarioEmail,
      createData: new Date(),
      history: history,
      // Persiste a ordem dos grupos no próprio frete para manter rastreabilidade da negociação.
      groupOrder: shipperGroupOrder,
      transport: buildTransportPayload(transport),
      priceANTT: resolveCurrentPriceANTT(priceANTT),
    };

    const savedBudgetId = budgetDataSaved?.budgetId || location.state?.budgetId;
    const savedBudgetData =
      budgetDataSaved?.budgetData || location.state?.budgetData;

    if (budgetDataSaved || (location.state?.fromBudget && savedBudgetId)) {
      data.fromBudget = true;
      data.budgetId = savedBudgetId;
      if (savedBudgetData?.numberSerial) {
        data.numberSerial = savedBudgetData.numberSerial;
      }
    }

    // return;

    if (!ultimaRota.date_operation) {
      showMessage("O data de coleta precisa ser preenchido");
      document.getElementById("datacoleta").focus();
    } else {


      const payload = {
        ...data,
        canhoto: buildFreightCanhotos(formFields),
        attachments: buildFreightAttachments(formFields),
        stopping_points: applyDefaultStopStatuses(formFields),
        shipperProposedGrossFreightCalculationUsers:
          data.priceANTT !==
            data.freight?.newProducts?.find(
              (item) => item.nameProducts === "Frete",
            )?.priceList
            ? shipperProposedGrossFreightCalculationUsersRef.current
            : null,
      };



      try {
        const res = await freightApi2.create(payload, releaseFreight);

        const persistedFreight = res.data?.data;



        const dataMsg = {
          isSave: true,
          freightNumber: persistedFreight.existing
            ? persistedFreight.numberSerial
            : numberSerial,
          date: new Date(),
          msg: `O frete  foi salvo com sucesso.`,
          firstDelivery: {
            name: firstDelivery.name,
            city: firstDelivery.city,
            uf: firstDelivery.uf,
          },
          lastDelivery: {
            name: lastDelivery.name,
            city: lastDelivery.city,
            uf: lastDelivery.uf,
          },
          existing: persistedFreight.existing,
        };

        setOpenFreightEditedSuccessModal(dataMsg);

        setOpenSuccessModal(true);

        // setCarregando(0);
        // navigate("/freightlist");
      } catch (err) {
        console.error(err);
        setCarregando(0);
        showMessage("Não foi possível criar o frete. Verifique a API.");
      }
    }
  }

  async function sendNotificationWithoutChoose(idFreight, idDriver) {

    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    const queueSnapshot = await db
      .collection("freight")
      .doc(idFreight)
      .collection("queue")
      .get();

    const queueData = queueSnapshot.docs.map((doc) => doc.data());
    const queueDataFiltered = queueData.filter(
      (item) => item.driver_user !== idDriver,
    );

    //Enviar notificação para todos os motoristas que não sejam o escolhido
    queueDataFiltered.forEach(async (item) => {
      const driverData = await driverService.getDriverAvailable(
        item.driver_user,
      );
      const driverUser = driverData.data();

      var title = "";
      var msg = "";

      title = "🚛 Quase lá!";
      msg =
        `Olá! ${driverUser.name}! 🎉\n\n` +
        `Você se candidatou ao frete #${numberSerial}, mas ele acabou sendo confirmado com outro motorista desta vez.\n` +
        `👀 Continue de olho no app — novos fretes estão chegando e a próxima pode ser sua!\n` +
        `Obrigado por estar com a gente.`;

      const freightData = {
        freightNumber: numberSerial,
        date: formattedDate,
        type: "new_freight",
      };

      notification.sendNotification(
        driverUser.idNotification,
        msg,
        title,
        freightData,
      );
    });
  }

  async function getDataPayment(value, driver, status, index) {
    var data = {
      idFreight: id,
      driver: uidDriver,
      order: numberSerial,
      value: (driver.valueNegotiated * parseInt(value)) / 100,
      type: index == 1 ? "Saldo" : "Adiantamento",
      status: status,
    };

    await paymentService.save(data);
  }

  // Função para verificar alterações
  async function update(isFinalize, isCopy, { releaseFreight = false } = {}) {
    setMsgTipo("erro");
    setCarregando(1);
    if (!validInput()) return;

    const validateAllSimulations =
      await resolvePayingShipperValidateAllSimulationsForSave();
    const defaultPendingStatus =
      getFreightPendingStatusByValidateAllSimulations(validateAllSimulations);

    const resolvedDescribe =
      resolveStatusDescribe({ describe: status, code }, code) ||
      resolveStatusDescribe(freightOrigin?.status, code) ||
      defaultPendingStatus.describe;

    const resolvedCode =
      resolveStatusCode(
        { describe: resolvedDescribe, code },
        resolvedDescribe,
      ) || defaultPendingStatus.code;

    let chosenStatus = { describe: resolvedDescribe, code: resolvedCode };

    const payingPayload = buildPayingShipperPayload();
    if (!payingPayload.uid) {
      setCarregando(0);
      showMessage("Selecione o Cliente Pagador (embarcador) antes de salvar.");
      return;
    }

    let customerPayment = payingPayload.customerPayment;

    let user = {
      uid: users.uid,
      name: users.name,
    };

    let shipper = payingPayload.shipper;

    // Cálculo da primeira e última rota
    const orderedStops = [...formFields]
      .filter((item) => item.stop_order != null)
      .sort((a, b) => a.stop_order - b.stop_order);

    const primeiraRota = orderedStops[0];
    const ultimaRota = orderedStops[orderedStops.length - 1];

    let firstDelivery = {
      name: primeiraRota?.name,
      cep: primeiraRota?.cep,
      address: primeiraRota?.logradouro,
      city: primeiraRota?.city,
      uf:
        primeiraRota?.uf.length > 2
          ? Utils.searchingState(primeiraRota.uf)
          : primeiraRota.uf,
      dateColeta: primeiraRota?.date_operation,
      coordinates: {
        latitude: primeiraRota?.latitude,
        longitude: primeiraRota?.longitude,
      },
    };

    let lastDelivery = {
      name: ultimaRota?.name,
      cep: ultimaRota?.cep,
      address: ultimaRota?.logradouro,
      city: ultimaRota?.city,
      uf:
        ultimaRota?.uf.length > 2
          ? Utils.searchingState(ultimaRota.uf)
          : ultimaRota.uf,
      dateColeta: ultimaRota?.date_operation,
      coordinates: {
        latitude: ultimaRota?.latitude,
        longitude: ultimaRota?.longitude,
      },
    };

    const payloadWeightCargo = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_weight_kg")
      : weightCargo;
    const payloadValueNF = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_value_nf")
      : valueNF;

    // Dados organizados
    let freight = {
      product: "",
      axles: axles,
      newProducts: product?.length > 0 ? product : [],
      weightUnit,
      seller: seller || nameUser || "",
      sellerId: sellerId || users?.uid || "",
      userConfirmDriver: operational ? operational : "",
      userConfirmDriverUid: userConfirmDriverUid ? userConfirmDriverUid : "",
      valueNF: payloadValueNF,
      weightCargo: payloadWeightCargo,
      valueFreightage,
      pricingCalculated: pricingCalculated,
      totalAmountRoute: totalAmountRoute
        ? totalAmountRoute
        : calcularDistancia(
          primeiraRota.latitude,
          primeiraRota.longitude,
          ultimaRota?.latitude,
          ultimaRota?.longitude,
        ),
      observation: observation || "",
      internalObservations: internalObservations || "",
      phoneRespContractFreigtage,
      getDriverFreight: { uidDriver: uidDriver || "" },
    };

    let vehicle = buildVehiclePayload();

    let driver = {
      valueInitial: valueDriverInitial,
      valueFinal: valueDriverFinal,
      valueNegotiated: valueNegotiated,
      paymentCondition: paymentCondition,
    };

    if (uidDriver && payingPayload.uid) {
      handleDriverSaveUidShipper(uidDriver, payingPayload.uid);
    }

    let history = {
      dateFinished: isCopy ? "" : isFinalize ? new Date() : "",
      dateUpdate: new Date(),
    };

    // numberSerial imutável no update — prioriza o do frete carregado (não o Date.now do state)
    const stableNumberSerial =
      freightOrigin?.numberSerial ?? numberSerial;

    if (
      freightOrigin?.numberSerial != null &&
      freightOrigin.numberSerial !== numberSerial
    ) {
      setNumberSerial(freightOrigin.numberSerial);
    }

    let data = {
      attachments: formFields.attachments,
      numberSerial: Number(stableNumberSerial),
      clientPayment: customerPayment,
      firstDelivery: firstDelivery,
      lastDelivery: lastDelivery,
      freight,
      vehicle,
      driver,
      user,
      shipper,
      createUser: usuarioEmail,
      createData: new Date(),
      history,
      status: chosenStatus,
      // Mantém no update a mesma estrutura de groupOrder para não perder a ordem dos grupos.
      groupOrder: shipperGroupOrder,
      transport: buildTransportPayload(transport, {
        idTransport: transport?.idTransport,
        assignedAt: transport?.assignedAt,
        assignedBy: transport?.assignedBy,
      }),
      priceANTT: resolveCurrentPriceANTT(priceANTT),
    };

    const savedBudgetId = budgetDataSaved?.budgetId || location.state?.budgetId;
    const savedBudgetData =
      budgetDataSaved?.budgetData || location.state?.budgetData;

    if (budgetDataSaved || (location.state?.fromBudget && savedBudgetId)) {
      data.fromBudget = true;
      data.budgetId = savedBudgetId;
      // Não sobrescrever numberSerial com o do orçamento no update
    }

    if (!ultimaRota.date_operation) {
      showMessage("O data de coleta precisa ser preenchido");
      document.getElementById("datacoleta").focus();
      return;
    }

    // Só exige condição de pagamento com motorista vinculado
    // (freightDriver.isView). Sem essa permissão o campo não aparece na tela.
    if (
      canViewFreightDriver &&
      Boolean(uidDriver) &&
      (status === "Contratado" || status === "Em transito") &&
      !hideDriverNegotiationForOwnership &&
      !paymentCondition
    ) {
      showMessage(
        "A Condição de Pagamento é obrigatória ao vincular um motorista.",
      );
      document.getElementById("paymentCondition")?.focus();
      return;
    }

    // Verificar alterações nos campos críticos
    const originalFreight = {
      // product,
      seller,
      sellerId: sellerId || "",
      weightUnit,
      operational,
      valueNF: payloadValueNF,
      weightCargo: payloadWeightCargo,
      valueFreightage,
      totalAmountRoute: totalAmountRoute || "",
      observation: observation || "",
      internalObservations: internalObservations || "",
      phoneRespContractFreigtage,
      getDriverFreight: { uidDriver: uidDriver || "" },
    };

    // Comparar rotas originais e atuais
    const originalRoutes = JSON.stringify(formFieldsOriginal); // Salva a versão original das rotas antes da edição
    const currentRoutes = JSON.stringify(formFields);

    const fieldsChanged =
      hasFieldsChanged(originalFreight, freightOrigin.freight) ||
      JSON.stringify(vehicle) !== JSON.stringify(data.vehicle) ||
      JSON.stringify(driver) !== JSON.stringify(data.driver) ||
      originalRoutes !== currentRoutes;

    if (isFinalize) {
      if (code === "04" || code === "05" || code === "06") {
        //Status em transito ou entregue pode ser finalizado

        if (
          formFields.every(
            (field) =>
              normalizeCanhotosList(field.canhoto, field.id || "").length === 0,
          )
        ) {
          showMessage(
            "Atenção: É necessário preencher os conhotos de entrega antes de finalizar o frete",
          );
          return;
        }

        chosenStatus = {
          describe: "Finalizado",
          code: "07",
        };

        // Atualiza o campo 'concluded' para true
        formFields.forEach((field) => {
          field.verify = true;
          field.concluded = true;
        });

        // atualizar o status da fila dentro do motorista
        driverService.saveStatusMyFreight(uidDriver, id, "finished");
        // atualizar o status da fila dentro do frete
        freightService.saveStatusQueueFreight(id, uidDriver, "finished");
        // exluir o frete da fila do myFrete
        driverService.deleteStatusMyFreight(uidDriver, id);
      }

      if (status === "Finalizado" && !fieldsChanged) {
        chosenStatus = { describe: "Finalizado", code: "07" };
      }
    }

    if (status === "Finalizado" && fieldsChanged) {
      chosenStatus = { describe: "Em transito", code: "05" };
    }

    const originalStatusCode = resolveStatusCode(
      freightOrigin?.status ?? {
        describe: resolvedDescribe,
        code: resolvedCode,
      },
      resolvedDescribe,
    );

    if (releaseFreight) {
      chosenStatus = resolveFreightStatusForSave({
        uidDriver,
        validateAllSimulations: false,
        currentStatusCode: originalStatusCode,
        releaseFreight: true,
        idTransport: transport?.idTransport,
      });
    } else {
      // Com transportadora atribuída, o frete é Contratado (mesmo sem motorista).
      // Sem transportadora e sem motorista + alteração → pendente (00/01).
      const hasTransport = Boolean(
        String(transport?.idTransport || "").trim(),
      );
      const isAdvancedStatus = ["05", "06", "07"].includes(originalStatusCode);

      if (fieldsChanged && !uidDriver) {
        if (hasTransport) {
          if (!isAdvancedStatus) {
            chosenStatus = { ...FREIGHT_STATUS_CONTRACTED };
          }
        } else {
          chosenStatus = getFreightPendingStatusByValidateAllSimulations(
            validateAllSimulations,
          );
        }
      } else if (
        hasTransport &&
        !isAdvancedStatus &&
        ["00", "01", "02", "03"].includes(
          resolveStatusCode(chosenStatus, chosenStatus.describe),
        )
      ) {
        // Evita gravar pendente se já há transportadora (ex.: vencido em Lances).
        chosenStatus = { ...FREIGHT_STATUS_CONTRACTED };
      }

      // Embarcador logado sem validação de simulações: nunca manter P. Validação (00).
      if (
        !uidDriver &&
        !validateAllSimulations &&
        !isFreightPendingValidationStatus(
          freightOrigin?.status ?? { describe: status, code },
          status,
        )
      ) {
        const chosenCode = resolveStatusCode(
          chosenStatus,
          chosenStatus.describe,
        );
        if (chosenCode === "00") {
          chosenStatus = hasTransport
            ? { ...FREIGHT_STATUS_CONTRACTED }
            : getFreightPendingStatusByValidateAllSimulations(false);
        }
      }
    }

    chosenStatus = preservePendingValidationStatusIfNeeded({
      chosenStatus,
      currentStatusValue: freightOrigin?.status ?? { describe: status, code },
      fallbackDescribe: status,
      releaseFreight,
      isFinalize,
    });

    // Save comum de edição não deve promover para Entregue/Finalizado.
    // (O back também bloqueia; isto evita o front pedir 06/07 sem finalize.)
    if (!isFinalize && !releaseFreight) {
      const nextCode = resolveStatusCode(chosenStatus, chosenStatus.describe);
      if (
        (nextCode === "06" || nextCode === "07") &&
        !["06", "07"].includes(originalStatusCode)
      ) {
        chosenStatus = {
          describe:
            resolveStatusDescribe(
              freightOrigin?.status ?? { describe: status, code },
              status,
            ) ||
            STATUS_DESCRIBE_BY_CODE[originalStatusCode] ||
            status,
          code: originalStatusCode || code,
        };
      }
    }

    // Frete cancelado pode voltar ao fluxo normal na edição.

    // Atualização no banco
    const payload = {
      ...data,
      canhoto: buildFreightCanhotos(formFields, freightOrigin?.canhoto),
      status: chosenStatus,
      attachments: buildFreightAttachments(
        formFields,
        Array.isArray(freightOrigin?.attachments)
          ? freightOrigin.attachments
          : [],
      ),
      stopping_points: applyDefaultStopStatuses(formFields),

      shipperProposedGrossFreightCalculationUsers:
        data.priceANTT !==
          data.freight?.newProducts?.find((item) => item.nameProducts === "Frete")
            ?.priceList
          ? shipperProposedGrossFreightCalculationUsersRef.current
          : null,
    };



    try {

      await freightApi2.update(id, payload, isFinalize, releaseFreight);



      if (releaseFreight) {
        setStatus(chosenStatus.describe);
        setCode(chosenStatus.code);
        setFreightOrigin((prev) =>
          prev ? { ...prev, status: chosenStatus } : prev,
        );
      }

      // mantém as regras de pagamentos/notificações do jeito que já está
      setCarregando(0);

      const dataMsg = {
        isSave: false,
        freightNumber: stableNumberSerial,
        date: new Date(),
        msg: `O frete  foi atualizado com sucesso.`,
        firstDelivery: {
          name: firstDelivery.name,
          city: firstDelivery.city,
          uf: firstDelivery.uf,
        },
        lastDelivery: {
          name: lastDelivery.name,
          city: lastDelivery.city,
          uf: lastDelivery.uf,
        },
      };

      setOpenFreightEditedSuccessModal(dataMsg);

      setOpenSuccessModal(true);

      // navigate("/freightlistCopy");
    } catch (err) {
      console.error(err);
      setCarregando(0);
      showMessage("Não foi possível atualizar o frete. Verifique a API.");
    }
  }

  function hasFieldsChanged(original, updated) {
    return Object.keys(original).some(
      (key) => JSON.stringify(original[key]) !== JSON.stringify(updated[key]),
    );
  }

  // Função para lidar com a seleção ou remoção de um motorista
  const handleDriver = (event, isCopy) => {
    const selectedDriverId = event?.id || "";
    // Chama a função addDriverVerify com o ID do motorista (ou string vazia na remoção)
    addDriverVerify(selectedDriverId);

    // Verifica se o parâmetro `isCopy` é "true" ou se o parâmetro `event` é nulo/indefinido
    if (isCopy === "true" || !selectedDriverId) {
      setUidDriver("");
      setDriverChose("");
      setOperational("");
      setUserConfirmDriverUid("");
      if (isViewAllUser) {
        clearTransportAssignment();
      }
    } else {
      const hasDriverChanged = uidDriver !== selectedDriverId;
      setUidDriver(selectedDriverId);
      setDriverChose(event ? event : "");
      if (hasDriverChanged || !operational || !userConfirmDriverUid) {
        setOperational(users?.name || usuarioEmail || "");
        setUserConfirmDriverUid(users?.uid || "");
      }
      if (isViewAllUser) {
        applyLoggedUserTransportForViewAll();
      }
    }
  };

  //------------- Validações -----------------

  function validInput() {
    if (!getPayingShipperUid()) {
      showMessage("O campo Cliente Pagador precisa ser selecionado");
      document.getElementById("payingCustomer")?.focus();
      return false;
    }
    if (!cnpjPayingCustomer) {
      showMessage(
        "O campo CNPJ da cessão Cliente Pagador precisa ser preenchido",
      );
      document.getElementById("cnpjPayingCustomer").focus();
      return false;
    }
    if (!payingCustomer) {
      showMessage(
        "O campo Cliente da cessão Cliente Pagador precisa ser preenchido",
      );
      document.getElementById("payingCustomer").focus();

      return false;
    }

    const stopContext = getStopValidationContext();
    const hasLinkedDriver = Boolean(uidDriver);
    const hasNFe = freightHasCargaNFeAttached(
      formFields,
      stopContext.freightAttachments,
    );

    if (canViewFreightDriver && hasLinkedDriver) {
      if (
        !isCarrierManagedFreight &&
        !hideDriverNegotiationForOwnership &&
        !valueDriverInitial
      ) {
        showMessage(
          "O campo Valor Sugerido precisa ser preenchido ao vincular um motorista",
        );
        document.getElementById("valueDriverInitial")?.focus();
        return false;
      }
      const isPendingContract =
        code === "01" || status === "Pendente de contratação";
      if (
        !isCarrierManagedFreight &&
        !hideDriverNegotiationForOwnership &&
        isPendingContract &&
        !valueDriverFinal
      ) {
        showMessage(
          "O campo Valor Anunciado precisa ser preenchido quando o frete está em P. Contratação",
        );
        document.getElementById("valueDriverFinal")?.focus();
        return false;
      }
      if (!hideDriverNegotiationForOwnership && !valueNegotiated) {
        showMessage(
          "O campo Valor Negociado precisa ser preenchido ao vincular um motorista",
        );
        document.getElementById("valueNegotiated").focus();
        return false;
      }
      if (!hideDriverNegotiationForOwnership && !paymentCondition) {
        showMessage(
          "O campo Condição de Pagamento precisa ser preenchido ao vincular um motorista",
        );
        document.getElementById("paymentCondition").focus();
        return false;
      }
    }

    if (hasNFe) {
      if (!occupation) {
        showMessage(
          "O campo Ocupação da cessão Veículo precisa ser preenchido",
        );
        document.getElementById("occupation").focus();
        return false;
      }
      if (!axles) {
        showMessage(
          "O campo Quantidade de eixos da cessão Veículo precisa ser preenchido",
        );
        document.getElementById("axles").focus();
        return false;
      }
      if (!freeOfCharge) {
        showMessage(
          "O campo Livre de Carga e descarga da cessão Veículo precisa ser preenchido",
        );
        document.getElementById("freeOfCharge").focus();
        return false;
      }
      if (canViewFreightSection && !seller) {
        showMessage(
          "O campo Vendedor e descarga da cessão Frete precisa ser preenchido",
        );
        document.getElementById("seller").focus();
        return false;
      }
      const cargoValidation = validateCargoFieldsForStops(stopContext);
      if (!cargoValidation.valid) {
        showMessage(cargoValidation.message);
        if (cargoValidation.focusId) {
          const el = document.getElementById(cargoValidation.focusId);
          if (el) el.focus();
        }
        return false;
      }
    }

    const stopErrors = getAllStoppingPointErrors(formFields, stopContext, {
      // Frete gerenciado pela transportadora tem paradas desabilitadas:
      // não cobrar a regra de primeiro ponto de Carga ao vincular motorista.
      hasLinkedDriver: hasLinkedDriver && !isCarrierManagedFreight,
    });
    if (stopErrors.length > 0) {
      const stageHint = hasLinkedDriver
        ? "Com motorista vinculado, preencha os campos obrigatórios"
        : hasNFe
          ? "Após o anexo da NF-e, preencha os campos obrigatórios"
          : "Na criação inicial, informe ao menos cidade e estado de origem e destino";
      showMessage(`${stageHint}: ${stopErrors[0]}`);
      return false;
    }

    if (hasNFe && canViewFreightSection && !valueFreightage) {
      showMessage(
        "O campo Valor do Frete e descarga da cessão Frete precisa ser preenchido",
      );
      document.getElementById("valueFreightage").focus();
      return false;
    }

    if (canViewFreightPricing) {
      const getPricingFieldLabels = (prod) => {
        const isTonFrete =
          isFreteProductRow(prod) &&
          resolvePricingType(prod) === PRICING_TYPE_TON;
        return {
          amount: isTonFrete ? "peso estimado (Ton)" : "quantidade",
          price: isTonFrete ? "valor por Ton" : "valor unitário",
        };
      };

      for (const prod of product) {
        const labels = getPricingFieldLabels(prod);
        if (prod.nameProducts && (!prod.amount || !prod.priceList)) {
          showMessage(
            `Preencha todos os campos do produto: nome, ${labels.amount} e ${labels.price}.`,
          );
          return false;
        }
        if (prod.amount && (!prod.nameProducts || !prod.priceList)) {
          showMessage(
            `Preencha todos os campos do produto: nome, ${labels.amount} e ${labels.price}.`,
          );
          return false;
        }
        if (prod.priceList && (!prod.nameProducts || !prod.amount)) {
          showMessage(
            `Preencha todos os campos do produto: nome, ${labels.amount} e ${labels.price}.`,
          );
          return false;
        }
      }
    }
    return true;
  }

  function showMessage(msg, title ) {
    setMsgTipo("erro");
    setCarregando(0);
    setTitle(title || "Campos obrigatórios!");
    setMsg(msg);
    setOpen(true);
    return;
  }

  const handleClickOpen = (id, operationType) => {
    setOpenOrigem(true);
    setReferenc(id);
    setCurrentOperationType(operationType || "");
  };

  const handleOpenUploadInvoices = (stopId, operationType, stopIndex) => {
    const resolvedIndex =
      typeof stopIndex === "number" && stopIndex >= 0
        ? stopIndex
        : formFields.findIndex((field) => field.id && field.id === stopId);
    const stop = resolvedIndex >= 0 ? formFields[resolvedIndex] : null;

    if (!stop) {
      showMessage("Ponto de parada não encontrado para importar a NF-e.");
      return;
    }

    const essentialCheck = validateEssentialBeforeCargaNFeAttachment({
      stop,
      stopIndex: resolvedIndex,
      context: getStopValidationContext(),
      tipoVeiculo,
      typeBodyworkList,
    });

    if (!essentialCheck.valid) {
      showMessage(essentialCheck.message);
      return;
    }

    setReferenc(stopId);
    setCurrentOperationType(operationType || "");
    setOrigem("Invoices");
    setOpenUploadInvoices(true);
  };

  const isFreightCanceled = Boolean(
    resolveStatusCode(freightOrigin?.status, status) === "08" ||
    freightOrigin?.cancel_reason ||
    freightOrigin?.canceled ||
    freightOrigin?.cancelled ||
    freightOrigin?.canceled_at,
  );

  const canceledTimelineStatusCode = resolveStatusCode(
    freightOrigin?.status_before_cancel ||
    freightOrigin?.statusBeforeCancel ||
    freightOrigin?.canceled_step_status ||
    freightOrigin?.status_before_cancellation || { code },
    status,
  );

  const timelineStatusCode =
    isFreightCanceled && canceledTimelineStatusCode !== "08"
      ? canceledTimelineStatusCode
      : isFreightCanceled
        ? "04"
        : code;

  const canDeleteFreight =
    user?.permissoes?.freight?.isDelete === true ||
    user?.permissoes?.frete?.excluir === true;

  const canShowCancelButton =
    Boolean(id) &&
    !view &&
    !isFreightCanceled &&
    canDeleteFreight &&
    FREIGHT_STATUS_CANCELABLE_CODES.includes(
      resolveStatusCode({ describe: status, code }, status),
    );

  const pickupOrderUrl =
    freightOrigin?.pickupOrderUrl || freightOrigin?.freight?.pickupOrderUrl;

  const canShowActionsMenu =
    Boolean(pickupOrderUrl) ||
    canShowCancelButton ||
    (Boolean(id) && !view && isFreightCanceled);

  const handleOpenActionsMenu = (event) => {
    setActionsMenuAnchorEl(event.currentTarget);
  };

  const handleCloseActionsMenu = () => {
    setActionsMenuAnchorEl(null);
  };

  const handleOpenCancelDialogFromMenu = () => {
    handleCloseActionsMenu();
    setOpenCancelDialog(true);
  };

  const handleOpenReactivateDialogFromMenu = () => {
    handleCloseActionsMenu();
    setOpenReactivateDialog(true);
  };

  const handleReactivateFreight = async () => {
    try {
      setCarregando(1);

      const reactivatedStatus = {
        describe: "Pendente de contratação",
        code: "01",
      };

      const currentFreight =
        freightOrigin && typeof freightOrigin === "object" ? freightOrigin : {};

      const payload = {
        ...currentFreight,
        status: reactivatedStatus,
        freight: {
          ...(currentFreight.freight || {}),
          getDriverFreight: {
            ...(currentFreight.freight?.getDriverFreight || {}),
            uidDriver: "",
          },
          userConfirmDriver: "",
          userConfirmDriverUid: "",
        },
        driver: {
          ...(currentFreight.driver || {}),
          valueNegotiated: 0,
          paymentCondition: "",
        },
        cancel_reason: null,
        canceled: false,
        cancelled: false,
        canceled_at: null,
        status_before_cancel: null,
        status_before_cancellation: null,
        canceled_step_status: null,
      };

      await freightApi2.update(id, payload, false);

      setStatus("Pendente de contratação");
      setCode("01");
      setUidDriver("");
      setDriverChose("");
      setValueNegotiated(0);
      setPaymentCondition("");
      setFreightOrigin((prev) =>
        prev
          ? {
            ...prev,
            ...payload,
          }
          : prev,
      );
      setTitle("Frete reativado");
      setMsg("Frete reativado para Pendente de contratação.");
      setOpenReactivateDialog(false);
      setOpen(true);
    } catch (error) {
      console.error("Erro ao reativar frete:", {
        id,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });

      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.msg ||
        error?.message ||
        "Não foi possível reativar o frete. Verifique a API.";

      setMsgTipo("erro");
      setTitle("Atenção");
      setMsg(apiMessage);
      setOpenReactivateDialog(false);
      setOpen(true);
    } finally {
      setCarregando(0);
    }
  };

  const handleCancelFreight = async (reason) => {
    try {
      setCarregando(1);

      const canceledStatus = { describe: "Cancelado", code: "08" };
      const statusBeforeCancel = {
        describe:
          resolveStatusDescribe({ describe: status, code }, code) ||
          STATUS_DESCRIBE_BY_CODE[code] ||
          "Pendente de contratação",
        code: resolveStatusCode({ describe: status, code }, status),
      };

      await cancelFreightById(id, reason, {
        idUser: user?.uid,
        viewAll: Boolean(user?.viewALL),
      });

      setStatus("Cancelado");
      setCode("08");
      setFreightOrigin((prev) =>
        prev
          ? {
            ...prev,
            status: canceledStatus,
            cancel_reason: reason,
            canceled: true,
            canceled_at: new Date().toISOString(),
            status_before_cancel: statusBeforeCancel,
            canceled_step_status: statusBeforeCancel,
          }
          : prev,
      );
      setOpenCancelDialog(false);
      setTitle("Cancelamento realizado");
      setMsg("Frete cancelado com sucesso.");
      setOpen(true);
    } catch (error) {
      console.error("Erro ao cancelar frete:", {
        id,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });

      setMsgTipo("erro");
      setTitle("Atenção");
      setMsg(getCancelFreightErrorMessage(error, "Verifique a API."));
      setOpen(true);
    } finally {
      setCarregando(0);
    }
  };

  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const weightConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "decimal",
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        },
      },
    },
  };

  const currencyConfigKm = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          //   style: "Km",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  async function buscaAPISecondario(input, form, index, data) {
    setLoading(true);

    try {
      // Tenta primeiro a API local
      const fallbackData = await fetchLocalAPI(input);
      await processarDadosAPI(fallbackData, form, index, "local");
    } catch (error) {
      console.error("Erro na API local, tentando API externa:", error);
      try {
        // Fallback para API externa
        const fallbackData = await fetchExternalAPI(input);
        await processarDadosAPI(fallbackData, form, index, "external");
      } catch (externalError) {
        console.error("Erro na API Externa 1:", externalError);
        try {
          // Segunda Tentativa API Externa
          const fallbackData = await fetchExternalAPI2(input);
          await processarDadosAPI(fallbackData, form, index, "external2");
        } catch (externalError2) {
          console.error("Erro na API Externa 2:", externalError2);
          alert(externalError2);
          return null;
        }
      }
    } finally {
      setLoading(false);
    }
  }

  // Função para buscar na API local
  async function fetchLocalAPI(cnpj) {
    const response = await fetch(`http://localhost:4000/consulta/cnpj/${cnpj}`);
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição local: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  // Função para buscar na API externa
  async function fetchExternalAPI(cnpj) {
    const response = await fetch(`https://open.cnpja.com/office/${cnpj}`);
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição externa: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  //Funcção para buscar na API Externa 2
  async function fetchExternalAPI2(cnpj) {
    const response = await fetch(
      `https://publica.cnpj.ws/cnpj/${Number(cnpj)}`,
    );
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição externa: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  // Função para processar dados e obter coordenadas
  async function processarDadosAPI(fallbackData, form, index, apiType) {
    if (apiType === "local") {
      processarDadosLocal(fallbackData, form, index);
    } else if (apiType === "external") {
      processarDadosExterno(fallbackData, form, index);
    } else {
      processarDadosExterno2(fallbackData, form, index);
    }

    // Obter coordenadas
    await obterCoordenadas(form, index);

    // Salvar cliente
    await salvarCliente(form, index, fallbackData, apiType);

    setFormFields(form);
  }

  // Processar dados da API local
  function processarDadosLocal(data, form, index) {
    form[index]["name"] = data?.nome_fantasia;
    form[index]["cpf_cnpj"] = data?.cnpj;
    form[index]["cep"] = data?.endereco?.cep;
    form[index]["number"] = data?.endereco?.numero;
    form[index]["logradouro"] =
      `${data?.endereco?.logradouro} - ${data?.endereco?.bairro}`;
    form[index]["city"] = data?.endereco?.municipio?.descricao;
    form[index]["uf"] = data?.endereco?.uf;
    form[index]["responsible_phone"] =
      `${data?.telefones?.ddd}${data?.telefones?.numero}`;
  }

  // Processar dados da API externa
  function processarDadosExterno(data, form, index) {
    form[index]["name"] = data?.company?.name || "";
    form[index]["cpf_cnpj"] = data?.taxId || "";
    form[index]["cep"] = data?.address?.zip || "";
    form[index]["number"] = data?.address?.number || "";
    form[index]["logradouro"] = `${data?.address?.street || ""} - ${data?.address?.district || ""
      }`;
    form[index]["city"] = data?.address?.city || "";
    form[index]["uf"] = data?.address?.state || "";
    form[index]["responsible_phone"] = `${data?.phones?.area || ""}${data?.phones?.number || ""
      }`;
  }

  // Processar dados da API externa
  function processarDadosExterno2(data, form, index) {
    form[index]["name"] = data?.razao_social || "";
    form[index]["cpf_cnpj"] = data?.estabelecimento?.cnpj || "";
    form[index]["cep"] = data?.estabelecimento?.cep || "";
    form[index]["number"] = data?.estabelecimento?.numero || "";
    form[index]["logradouro"] =
      data?.estabelecimento?.logradouro + data?.estabelecimento?.complemento;
    form[index]["city"] = data?.estabelecimento?.cidade?.nome || "";
    form[index]["uf"] = data?.estabelecimento?.estado?.nome || "";
    form[index]["responsible_phone"] =
      `${data?.estabelecimento?.ddd1 || ""}${data?.estabelecimento?.telefone1 || ""
      }` ||
      `${data?.estabelecimento?.ddd2 || ""}${data?.estabelecimento?.telefone2
      }` ||
      `${data?.estabelecimento?.ddd_fax || ""}${data?.estabelecimento?.fax || ""
      }`;
  }

  // Função para obter coordenadas
  async function obterCoordenadas(form, index) {
    try {
      const cep = form[index]["cep"];
      const numero = form[index]["number"];

      if (!cep || !numero) {
        console.warn("CEP ou número não disponível para obter coordenadas");
        return;
      }

      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${cep},${numero}&key=${key}`,
        { mode: "cors" },
      );

      const data = await response.json();

      if (data.status === "OK" && data.results.length > 0) {
        const address = data.results[0];
        form[index]["latitude"] = Number(address.geometry.location.lat);
        form[index]["longitude"] = Number(address.geometry.location.lng);
      } else {
        console.warn("CEP não encontrado no Google Maps");
      }
    } catch (error) {
      console.error("Erro ao obter coordenadas:", error);
    }
  }

  // Função para salvar cliente
  async function salvarCliente(form, index, fallbackData, apiType) {
    let clientData;

    switch (apiType) {
      case "local":
        clientData = criarDadosClienteLocal(fallbackData, form, index);
        break;
      case "external":
        clientData = criarDadosClienteExterno(fallbackData, form, index);
        break;
      case "external2":
        clientData = criarDadosClienteExterno2(fallbackData, form, index);
        break;
      default:
        throw new Error(`API type desconhecido: ${apiType}`);
    }

    try {
      await driverService.saveClient(clientData);
    } catch (err) {
      console.error("Erro ao salvar cliente:", err);
      throw err; // Propaga o erro para tratamento superior
    }
  }

  // Criar dados do cliente para API local
  function criarDadosClienteLocal(data, form, index) {
    return {
      name: data?.razao_social || data?.nome_fantasia,
      nameFantasy: data?.nome_fantasia,
      cnpj: data?.cnpj,
      address: {
        cep: data?.endereco?.cep,
        city: data?.endereco?.municipio?.descricao,
        complement: data?.endereco?.complemento,
        neighborhood: data?.endereco?.bairro,
        number: data?.endereco?.numero,
        state: data?.endereco?.uf,
        street: data?.endereco?.logradouro,
      },
      coordinates: {
        latitude: form[index]["latitude"],
        longitude: form[index]["longitude"],
      },
      telefone: `${data?.telefones?.ddd}${data?.telefones?.numero}`,
      typePerson: 2,
      uidShipper: getPayingShipperUid() || user.uidShipper,
    };
  }

  // Criar dados do cliente para API externa
  function criarDadosClienteExterno(data, form, index) {
    return {
      name: data?.company?.name,
      nameFantasy: data?.company?.name,
      cnpj: data?.taxId,
      address: {
        cep: data?.address?.zip,
        city: data?.address?.city,
        complement: `${data?.address?.street} - ${data?.address?.district}`,
        neighborhood: data?.address?.district,
        number: data?.address?.number,
        state: data?.address?.state,
        street: data?.address?.street,
      },
      coordinates: {
        latitude: form[index]["latitude"],
        longitude: form[index]["longitude"],
      },
      telefone: `${data?.phones?.area}${data?.phones?.number}`,
      typePerson: 2,
      uidShipper: getPayingShipperUid() || user.uidShipper,
    };
  }

  // Criar dados do cliente para API externa 2
  function criarDadosClienteExterno2(data, form, index) {
    return {
      name: data?.razao_social,
      nameFantasy: data?.estabelecimento?.nome_fantasia,
      cnpj: data?.estabelecimento?.cnpj,
      address: {
        cep: data?.estabelecimento?.cep,
        city: data?.estabelecimento?.cidade?.nome,
        complement:
          data?.estabelecimento?.logradouro +
          data?.estabelecimento?.complemento,
        neighborhood: data?.estabelecimento?.bairro,
        number: data?.estabelecimento?.numero,
        state: data?.estabelecimento?.estado?.nome,
        street: data?.estabelecimento?.logradouro,
      },
      coordinates: {
        latitude: form[index]["latitude"],
        longitude: form[index]["longitude"],
      },
      telefone:
        `${data?.estabelecimento?.ddd1 || ""}${data?.estabelecimento?.telefone1 || ""
        }` ||
        `${data?.estabelecimento?.ddd2 || ""}${data?.estabelecimento?.telefone2
        }` ||
        `${data?.estabelecimento?.ddd_fax || ""}${data?.estabelecimento?.fax || ""
        }`,
      typePerson: 2,
      uidShipper: getPayingShipperUid() || user.uidShipper,
    };
  }

  //Função para consultar CNPJ
  function buscarCNPJBancoClient(input, index) {
    if (input.length < 14) {
      return;
    } else if (input.length === 14) {
      db.collection("client")
        .where("cnpj", "==", input)
        .get()
        .then((result) => {
          if (result.empty) {
            buscaAPISecondario(input, [...formFields], index); // Passamos uma cópia fresca
          } else {
            const data = result.docs[0].data();
            setFormFields((prev) => {
              const newForm = [...prev];
              newForm[index] = {
                ...newForm[index],
                name: data.name,
                cpf_cnpj: data.cnpj,
                cep: data.address.cep,
                number: data.address.number,
                logradouro: `${data.address.street} - ${data.address.neighborhood}`,
                city: data.address.city,
                uf: data.address.state,
                latitude: data.coordinates?.latitude || "",
                longitude: data.coordinates?.longitude || "",
              };
              return newForm;
            });
          }
        })
        .catch((err) => console.error(err));
    } else if (input.length === 18) {
      const inputLimpo = input.replace(/[^\d]/g, "");
      db.collection("client")
        .where("cnpj", "==", inputLimpo)
        .get()
        .then((result) => {
          var form = [...formFields];
          if (result.empty) {
            try {
              buscaAPISecondario(inputLimpo, form, index);
            } catch (err) {
              console.error(err);
            }
          } else {
            result.docs.forEach((doc) => {
              const data = doc.data();

              form[index]["name"] = data.name;
              form[index]["cpf_cnpj"] = data.cnpj;

              if (
                data.responsible &&
                data.responsible.phoneResp &&
                data.responsible.responsible
              ) {
                form[index]["responsible_phone"] = data.responsible.phoneResp;
                form[index]["responsible_name"] = data.responsible.responsible;
              } else {
                console.log(
                  "Dados de responsável ausentes ou vazios para o documento:",
                  doc.id,
                );
              }

              let address;

              if (
                data.addressDelivery &&
                Object.keys(data.addressDelivery).length > 0
              ) {
                address = data.addressDelivery;
              } else {
                address = data.address;
              }

              form[index]["cep"] = address.cep;
              form[index]["number"] = address.number;
              form[index]["logradouro"] =
                address.street + " - " + address.neighborhood;
              form[index]["city"] = address.city;
              form[index]["uf"] = address.state;

              if (
                data.coordinates &&
                data.coordinates.latitude &&
                data.coordinates.longitude
              ) {
                form[index]["latitude"] = data.coordinates.latitude;
                form[index]["longitude"] = data.coordinates.longitude;
              } else {
                fetch(
                  "https://maps.googleapis.com/maps/api/geocode/json?address=" +
                  form[index]["cep"] +
                  "&key=" +
                  key,
                  { mode: "cors" },
                )
                  .then((res) => res.json())
                  .then((data2) => {
                    if (data2.hasOwnProperty("erro")) {
                      alert("Cep não existente");
                    } else {
                      var address = data2.results[0];

                      form[index]["latitude"] = Number(
                        data.location?.coordinates.latitude
                          ? data.location.coordinates.latitude
                          : address?.geometry.location.lat,
                      );
                      form[index]["longitude"] = Number(
                        data.location?.coordinates.longitude
                          ? data.location.coordinates.longitude
                          : address?.geometry.location.lng,
                      );
                      // alert("Dados preenchidos");
                    }
                  });
              }
            });
            setFormFields(form);
          }
        })
        .catch((err) => console.error(err));
    } else {
      alert("CNPJ invalido");
    }
  }

  /**
   * Função para consultar CEP
   * @param {string} input - CEP a ser consultado
   * @param {number} index - Índice do campo de formulário que deve ser atualizado
   * @returns {void} - Nenhum valor de retorno
   */
  function buscarCepPaying(input, index) {
    if (input.length < 8) return;

    fetch("https://brasilapi.com.br/api/cep/v1/" + input)
      .then((res) => res.json())
      .then((data) => {
        if (data.hasOwnProperty("erro") || data.name === "CepPromiseError") {
          alert("CEP não encontrado");
        } else {
          // Uso do callback (prev) para não apagar o que o usuário acabou de digitar
          setFormFields((prev) => {
            const aux = [...prev];

            aux[index] = {
              ...aux[index],
              logradouro:
                (data.street || "") + " - " + (data.neighborhood || ""),
              city: data.city || "",
              uf: data.state || "",
            };
            return aux;
          });

          // Chama a geolocalização passando o índice correto
          consultStreetByStreet(index);
        }
      })
      .catch((err) => console.error(err));
  }

  /**
   * Função para consultar as coordenadas de um endereço
   * @param {number} index - Índice do campo de formulário que deve ser atualizado
   * @returns {void} - Nenhum valor de retorno
   * @description
   * Realiza uma chamada para a API do Google Maps para obter as coordenadas (latitude e longitude) de um endereço.
   * Se o endereço for válido, atualiza o formulário com as coordenadas e marca o campo como "checked".
   * Caso contrário, abre um alert com uma mensagem de erro.
   */
  const key = "AIzaSyAds1TwGzvflRvD8KHrbRHrnF3DvATFM1k";
  function consultStreetByStreet(index) {
    // Pegamos os valores atuais para a busca
    const item = formFields[index];
    if (!item.number || !item.logradouro || !item.city || !item.uf) {
      setTitle("Por favor!");
      setMsg("Preencher o Endereço, Número, Cidade e Estado...");
      setOpen(true);
      return;
    }

    const enderecoCompleto = `${item.logradouro} ${item.number} ${item.city} ${item.uf}`;

    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${enderecoCompleto}&key=${key}`,
    )
      .then((res) => res.json())
      .then((data2) => {
        if (data2.status === "OK") {
          const coords = data2.results[0].geometry.location;
          // Uso do callback (prev) para não apagar o que o usuário acabou de digitar
          setFormFields((prev) => {
            const newForm = [...prev];
            newForm[index] = {
              ...newForm[index],
              latitude: coords.lat,
              longitude: coords.lng,
              checkItemLocation: true,
            };
            return newForm;
          });
        }
      })
      .catch((err) => console.error(err));
  }

  const handleClose = () => {
    setOpen(false);
    setCarregando(0);
  };

  const handleChangeInitial = (event, value, maskedValue) => {
    event.preventDefault();
    setValueDriverInitial(value);
  };

  const handleChangeFinal = (event, value, maskedValue) => {
    event.preventDefault();
    setValueDriverFinal(value);
  };

  const handleChangeValueNegotiated = (event, value, maskedValue) => {
    event.preventDefault();
    setValueNegotiated(value);
  };

  const handleChangePaymentCondition = (event, value, maskedValue) => {
    const selectedValue = event.target.value;
    setPaymentCondition(selectedValue);
  };

  const handleChangeWeightCargo = (event, value, maskedValue) => {
    event.preventDefault();
    setWeightCargo(value);
  };

  const handleChangeWeightUnit = (event) => {
    const newUnit = event.target.value;
    const oldUnit = weightUnit;

    setWeightUnit(newUnit);
    setWeightCargo((currentValue) =>
      convertWeightValue(currentValue, newUnit, oldUnit),
    );
    setFormFields((prev) =>
      prev.map((form) =>
        hasCargaOperation(form.operation)
          ? {
            ...form,
            cargo_weight_kg: convertWeightValue(
              form.cargo_weight_kg,
              newUnit,
              oldUnit,
            ),
          }
          : form,
      ),
    );
  };

  const handleChangeValueNF = (event, value, maskedValue) => {
    event.preventDefault();
    setValueNF(value);
  };

  const handleChangeValueFreightage = (event, value, maskedValue) => {
    event.preventDefault();
    setValueFreightage(value);
  };

  const handleClickDialog = () => {
    setOpenDialog(false);
  };

  const verifyUiDriver = (event) => {
    addDriverVerify(event.target.value);
    setUidDriver(event.target.value && event.target.value);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    return;
  };

  const addDriverVerify = (id) => {
    if (id !== "Selecione" && id !== "") {
      setCarregando(0);
      setTitle("Notificação para o motorista");
      setMsg(
        "Ao confirmar o salvamento deste frete, o motorista será notificado e o frete ficará disponível em seu aplicativo.",
      );
      setOpen(true);
    }
  };

  const msgHaveContract = () => {
    if (!uidDriver) {
      setCarregando(0);
      setTitle("Atenção!");
      setMsg(
        "Esse status geralmente é mudado automaticamente quando o motorista aceita a carga," +
        "tem certeza que deseja mudar esse status manualmente ?",
      );
      setOpen(true);
    }
  };

  const varifyHavingDriver = () => {
    if (!uidDriver) {
      setCarregando(0);
      setTitle("Ops!");
      setMsg(
        "Para esse tipo de Status precisará selecionar um Motorista disponível da fila no campo Motorista(s)",
      );
      setOpen(true);
    }
  };

  const getStatus = (status) => {
    if (status === "Contratado") {
      return "hired";
    }
    if (status === "Entregue") {
      return "delivered";
    }
    if (status === "Em transito") {
      return "inTransit";
    } else if (
      (status === "Pendente de validação" ||
        status === "Pendente de contratação" ||
        status === "Em Analise do motorista") &&
      uidDriver
    ) {
      return "approved";
    }
  };

  //----------------------------- checked box ------------------------------------

  const handleOnChange = (e, type) => {
    const { name, checked } = e.target;
    const newTypeVehicle = [...tipoVeiculo[type]];
    const index = newTypeVehicle.findIndex((h) => h.name === name);
    if (index > -1) {
      newTypeVehicle[index] = { name, selected: checked };
    }
    setTipoVeiculo((h) => ({ ...h, [type]: newTypeVehicle }));
  };

  const renderCheckboxList = (options, type) =>
    options.map((opt) => (
      <div key={opt.name} className="checkbox-container">
        <input
          disabled={vehicleDisabled}
          type="checkbox"
          name={opt.name}
          onChange={(e) => handleOnChange(e, type)}
          checked={opt.selected}
        />
        {opt.name}
      </div>
    ));

  const categories = {
    Leve: ["FIORINO", "3/4", "TOCO", "VUC"],
    Médio: ["TRUCK", "BI-TRUCK", "BI-TREM"],
    Pesado: ["BITREM", "CARRETA S", "CARRETA LS", "RODOTREM", "VANDERLEIA"],
  };

  const selectedVehicleNames = getSelectedVehicleNames(tipoVeiculo);
  const axleSelectOptions = getVehicleAxleOptions(selectedVehicleNames);

  const renderCategories = () => {
    return Object.keys(categories).map((category) => {
      const filteredOptions = tipoVeiculo.dados.filter((vehicle) =>
        categories[category].includes(vehicle.name),
      );

      return (
        <Card
          key={category}
          className="freight-vehicle-category-card"
          sx={{ border: "none", boxShadow: "none" }}
        >
          <div className="category-column">
            <h6 className="category-title">{category}</h6>

            {renderCheckboxList(filteredOptions, "dados")}
          </div>
        </Card>
      );
    });
  };

  const handleOnChangeBodyWork = (e, type) => {
    const { name, checked } = e.target;
    const newTypeBodyWork = [...typeBodyworkList[type]];
    const index = newTypeBodyWork.findIndex((h) => h.name === name);
    if (index > -1) {
      newTypeBodyWork[index] = { name, selected: checked };
    }
    setTypeBodyworkList((h) => ({ ...h, [type]: newTypeBodyWork }));
  };

  const renderCheckboxListBodyWork = (options, type) =>
    options.map((opt) => (
      <div key={opt.name} className="checkbox-container">
        <input
          disabled={vehicleDisabled}
          type="checkbox"
          name={opt.name}
          onChange={(e) => handleOnChangeBodyWork(e, type)}
          checked={opt.selected}
        />
        {opt.name}
      </div>
    ));

  const categoriesBodyWork = {
    Fechada: ["BAÚ", "BAÚ FRIGORIFICO", "BAÚ REFRIGERADO", "SIDER"],
    Aberta: ["CAÇAMBA", "GRADE BAIXA", "GRANELEIRO", "PLATAFORMA", "PRANCHA"],
    Especial: [
      "BUG PORTA CONTAINER",
      "CAVAQUEIRA",
      "CEGONHEIRO",
      "GAIOLA",
      "HOPPER",
      "MUNCK",
      "SILLO",
      "TANQUE",
    ],
  };

  const renderCategoriesBodyWork = () => {
    return Object.keys(categoriesBodyWork).map((category) => {
      const filteredOptions = typeBodyworkList.dados.filter((vehicle) =>
        categoriesBodyWork[category].includes(vehicle.name),
      );
      return (
        <Card
          key={category}
          className="freight-vehicle-category-card"
          sx={{ border: "none", boxShadow: "none" }}
        >
          <div className="category-column">
            <h6 className="category-title">{category}</h6>
            {renderCheckboxListBodyWork(filteredOptions, "dados")}
          </div>
        </Card>
      );
    });
  };

  const getStoragePathFromDownloadUrl = (downloadUrl = "") => {
    const marker = "/o/";
    const start = String(downloadUrl).indexOf(marker);
    if (start === -1) return "";

    const pathStart = start + marker.length;
    const pathEnd = String(downloadUrl).indexOf("?", pathStart);
    const encodedPath =
      pathEnd === -1
        ? String(downloadUrl).substring(pathStart)
        : String(downloadUrl).substring(pathStart, pathEnd);

    return decodeURIComponent(encodedPath);
  };

  const deleteStorageFileByUrl = async (downloadUrl) => {
    const filePath = getStoragePathFromDownloadUrl(downloadUrl);
    if (!filePath) return;

    const fileRef = ref(storage, filePath);
    await deleteObject(fileRef);
  };

  // ===================== [ handleUpload ]======================
  const handleUpload = (file, isInvoice) => {
    if (!file) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const storageRef = ref(
        storage,
        `freight/${id}/attachments/${Date.now()}-${referenc || "principal"}-${file.name}`,
      );

      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
          );
          setCarregando(progress);
        },
        (error) => {
          alert(error);
          setCarregando(0); // Resetar carregamento em caso de erro
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref)
            .then((downloadURL) => {
              const fileName = file.name;
              const fileType = fileName.split(".").pop().toLowerCase();
              const fileNameWithoutExtension = fileName.includes(".")
                ? fileName.slice(0, fileName.lastIndexOf("."))
                : fileName;

              const attachmentData = {
                id: `${Date.now()}-${Math.floor(Math.random() * 1000000)}`,
                name: fileNameWithoutExtension,
                stoppingPointId: referenc,
                type: fileType,
                url: downloadURL,
              };

              setFormFields((currentFormFields) => {
                const updatedFormFields = currentFormFields.map((field) => {
                  if (field.id === referenc) {
                    const existingAttachments = Array.isArray(field.attachments)
                      ? field.attachments
                      : [];
                    const existingInvoices = Array.isArray(field.invoices)
                      ? field.invoices
                      : [];
                    const existingCanhotos = normalizeCanhotosList(
                      field.canhoto,
                      field.id || referenc || "",
                    );
                    const operationTypeForUpload =
                      currentOperationType || field.operation;
                    const isCargaOperationType = hasCargaOperation(
                      operationTypeForUpload,
                    );
                    const isDescargaOperationType = hasDescargaOperation(
                      operationTypeForUpload,
                    );

                    if (isInvoice) {
                      return {
                        ...field,
                        invoices: [...existingInvoices, attachmentData],
                      };
                    }

                    if (isCargaOperationType && !isDescargaOperationType) {
                      return {
                        ...field,
                        canhoto: "",
                        attachments: [...existingAttachments, attachmentData],
                      };
                    }

                    if (isDescargaOperationType && !isCargaOperationType) {
                      return {
                        ...field,
                        canhoto: mergeCanhotoLists(
                          existingCanhotos,
                          [attachmentData],
                          field.id || referenc || "",
                        ),
                        attachments: [],
                      };
                    }

                    // Encontrou o ponto de parada correto
                    return {
                      ...field,
                      canhoto: mergeCanhotoLists(
                        existingCanhotos,
                        [attachmentData],
                        field.id || referenc || "",
                      ),
                      attachments: [...existingAttachments, attachmentData],
                    };
                  }
                  return field; // Retorna os outros campos sem modificação
                });
                return updatedFormFields; // Retorna o array atualizado
              });



              setCarregando(0);
              resolve(attachmentData);
            })
            .catch((error) => {
              setCarregando(0);
              reject(error);
            });
        },
      );
    });
  };

  const handleDeleteStopDocument = async ({
    kind,
    stopId,
    stopIndex,
    file,
  }) => {
    if (view) return false;
    if (!file?.url) return false;

    try {
      await deleteStorageFileByUrl(file.url);
    } catch (error) {
      // Nao bloqueia a remocao da referencia no banco/estado se o arquivo fisico falhar.
      console.error("Erro ao excluir o arquivo no storage:", error);
    }

    const nextFormFields = formFields.map((field, index) => {
      const matchById = stopId && field.id === stopId;
      const matchByIndex = !stopId && index === stopIndex;
      if (!matchById && !matchByIndex) return field;

      if (kind === "canhoto") {
        const currentCanhotos = normalizeCanhotosList(
          field.canhoto,
          field.id || stopId || "",
        );
        const nextCanhotos = currentCanhotos.filter(
          (item) => item?.url !== file.url,
        );
        return {
          ...field,
          canhoto: nextCanhotos.length ? nextCanhotos : "",
          verify: false,
        };
      }

      if (kind === "attachment") {
        const currentAttachments = Array.isArray(field.attachments)
          ? field.attachments
          : [];
        const nextAttachments = currentAttachments.filter(
          (item) => item?.url !== file.url,
        );
        return {
          ...field,
          attachments: nextAttachments,
        };
      }

      return field;
    });

    const nextFreightCanhotos = normalizeCanhotosList(
      freightOrigin?.canhoto,
    ).filter((item) => {
      if (kind !== "canhoto") return true;
      if (!item?.url || item.url !== file.url) return true;
      if (!stopId) return false;
      return String(item.stoppingPointId || "") !== String(stopId);
    });

    const nextFreightAttachments = normalizeAttachmentsList(
      freightOrigin?.attachments,
    ).filter((item) => {
      if (kind !== "attachment") return true;
      if (!item?.url || item.url !== file.url) return true;
      if (!stopId) return false;
      return String(item.stoppingPointId || "") !== String(stopId);
    });

    setFormFields(nextFormFields);
    setFreightOrigin((prev) => ({
      ...(prev || {}),
      canhoto: nextFreightCanhotos,
      attachments: nextFreightAttachments,
    }));

    try {
      if (id && stopId) {
        const updatedStop = nextFormFields.find((field) => field.id === stopId);
        const stoppingPointPayload =
          kind === "canhoto"
            ? {
              canhoto: updatedStop?.canhoto || "",
              verify: false,
            }
            : {
              attachments: updatedStop?.attachments || [],
            };

        await db
          .collection("freight")
          .doc(id)
          .collection("stopping_points")
          .doc(stopId)
          .update(stoppingPointPayload);
      }

      if (id) {
        const freightPayload =
          kind === "canhoto"
            ? { canhoto: nextFreightCanhotos }
            : { attachments: nextFreightAttachments };

        await db.collection("freight").doc(id).update(freightPayload);
      }
    } catch (error) {
      console.error("Erro ao atualizar exclusão no banco:", error);
      alert("Erro ao atualizar dados no banco.");
      return false;
    }

    return true;
  };

  const handleCloseModal = () => {
    setOpenOrigem(false);
    setCurrentOperationType("");
    setOrigem("");
    setReferenc("");
  };

  const handleCloseUploadInvoices = () => {
    setOpenUploadInvoices(false);
    setCurrentOperationType("");
    setOrigem("");
    setReferenc("");
  };

  const showNfePostImportNotice = () => {
    prevHasNFeRef.current = true;
    setNfeImportNoticeOpen(true);
  };

  const handleCloseNfePostImportNotice = (_event, reason) => {
    if (reason === "clickaway") return;
    setNfeImportNoticeOpen(false);
  };

  const handleShipperCloseModal = () => {
    setOpenShipper(false);
  };

  const getDadaClient = (cnpj, razaosocial) => {
    setPayingCustomer(razaosocial);
    setCnpjPayingCustomer(cnpj);
  };

  /**
   * Função para atualizar os campos do formulário
   * @param {React.ChangeEvent} event - Evento de mudança do campo
   * @param {number} index - Índice do campo no array de campos
   */

  const handleFormChange = (event, index) => {
    const { name, value, type, checked } = event.target;

    // Verifica se o nome do campo e o índice são válidos
    if (!name || index < 0) {
      return;
    }

    // Usa a forma funcional do setState para garantir que trabalhamos com o estado mais recente
    // Isso evita race conditions quando outras funções também atualizam formFields
    setFormFields((prevFormFields) => {
      // Verifica se o índice é válido
      if (index >= prevFormFields.length) {
        return prevFormFields;
      }

      // Cria uma cópia do array de pontos de parada
      const newFormFields = [...prevFormFields];

      // Cria uma cópia do objeto do ponto de parada no índice especificado
      const updatedField = { ...newFormFields[index] };

      // Atualiza o campo modificado
      // Para checkboxes, usa 'checked', caso contrário usa 'value'
      const fieldValue = type === "checkbox" ? checked : value || "";
      updatedField[name] = fieldValue;

      // Atualiza o objeto no array
      newFormFields[index] = updatedField;

      // Retorna o novo array
      return newFormFields;
    });
  };

  const handleStopClientChange = (selected, index) => {
    if (index < 0) return;

    if (!selected || typeof selected === "string") {
      handleFormChange(
        {
          target: {
            name: "name",
            value: typeof selected === "string" ? selected : "",
          },
        },
        index,
      );
      return;
    }

    setFormFields((prevFormFields) => {
      if (index >= prevFormFields.length) return prevFormFields;

      const nextFormFields = [...prevFormFields];
      nextFormFields[index] = {
        ...nextFormFields[index],
        ...buildStopPatchFromClient(selected.client),
      };
      return nextFormFields;
    });
  };

  const deleteItem = (item, index) => {
    setFormFields((prev) => {
      const data = [...prev];
      data.splice(index, 1);
      return data;
    });
  };

  const duplicateForm = (index) => {
    setFormFields((prev) => {
      // Pega o formulário que será duplicado
      const formToDuplicate = prev[index];

      // Verifica se o formulário a ser duplicado existe
      if (!formToDuplicate) {
        console.error("Formulário não encontrado no índice:", index);
        return prev;
      }

      // Cria uma cópia profunda do formulário original
      let newForm = JSON.parse(JSON.stringify(formToDuplicate));

      // Modifica os campos específicos do novo formulário
      newForm.stop_order = formToDuplicate.stop_order + 1;
      newForm.date_operation = "";
      newForm.time_operation = "";
      newForm.observation = "";
      newForm.number_collect = geraNumeroColeta();
      newForm.manualCoordinatesEnabled = false;

      // Adiciona o novo formulário à lista de formulários
      return [...prev, newForm];
    });
  };

  /**
   * Função para verificar se os campos do formulário de pontos de parada
   * estão preenchidos corretamente.
   * Verifica se todos os campos obrigatórios de cada ponto de parada
   * foram preenchidos.
   * @returns {array} Vetor com os nomes dos campos inválidos
   */
  const getInvalidFields = () => {
    const erros = [];

    // 1. Validação de Campos Simples (Pagador, Valores, Veículo, Frete)
    const stopContextForFields = getStopValidationContext();
    const hasLinkedDriver = Boolean(uidDriver);
    const hasNFeOnFreight = freightHasCargaNFeAttached(
      formFields,
      stopContextForFields.freightAttachments,
    );

    const simpleFields = [
      { value: payingCustomer, label: "Cliente Pagador", id: "chose-1" },
      {
        value: cnpjPayingCustomer,
        label: "CNPJ do Pagador",
        id: "cnpjPayingCustomer",
      },
    ];

    if (hasNFeOnFreight) {
      simpleFields.push(
        { value: occupation, label: "Ocupação", id: "occupation" },
        {
          value: freeOfCharge,
          label: "Livre de Carga e Descarga",
          id: "freeOfCharge",
        },
      );

      if (canViewFreightSection) {
        simpleFields.push({ value: seller, label: "Vendedor", id: "seller" });
        if (hasPerStopCargoFreightFields(formFields)) {
          simpleFields.push(
            {
              value: sumCargoStopsNumber(formFields, "cargo_weight_kg"),
              label: "Peso da Carga (total por paradas)",
              id: "weightCargoTotal",
            },
            {
              value: sumCargoStopsNumber(formFields, "cargo_value_nf"),
              label: "Valor NF (total por paradas)",
              id: "valueNFTotal",
            },
          );
        } else {
          simpleFields.push(
            { value: weightCargo, label: "Peso da Carga", id: "weightCargo" },
            { value: valueNF, label: "Valor da NF", id: "valueNF" },
          );
        }
        simpleFields.push({
          value: valueFreightage,
          label: "Valor do Frete",
          id: "valueFreightage",
        });
      }
    }

    // Verifica lista simples
    simpleFields.forEach((field) => {
      if (
        !field.value ||
        field.value === 0 ||
        (typeof field.value === "string" && field.value.trim() === "")
      ) {
        erros.push(field.label);
      }
    });

    if (canViewFreightDriver && hasLinkedDriver) {
      if (
        isViewAllUser &&
        !String(transport?.idTransport || "").trim()
      ) {
        erros.push(
          "Transportadora (obrigatória ao vincular motorista)",
        );
      }
      if (
        !isCarrierManagedFreight &&
        !hideDriverNegotiationForOwnership &&
        (!valueDriverInitial || valueDriverInitial === 0)
      ) {
        erros.push("Valor Sugerido (Obrigatório ao vincular motorista)");
      }
      const isPendingContract =
        code === "01" || status === "Pendente de contratação";
      if (
        !isCarrierManagedFreight &&
        !hideDriverNegotiationForOwnership &&
        isPendingContract &&
        (!valueDriverFinal || valueDriverFinal === 0)
      ) {
        erros.push("Valor Anunciado (Obrigatório em P. Contratação)");
      }
      if (
        !hideDriverNegotiationForOwnership &&
        (!valueNegotiated || valueNegotiated === 0)
      ) {
        erros.push("Valor Negociado (Obrigatório ao vincular motorista)");
      }
      if (!hideDriverNegotiationForOwnership && !paymentCondition) {
        erros.push("Condição de Pagamento (Obrigatório ao vincular motorista)");
      }
    }

    erros.push(
      ...getAllStoppingPointErrors(formFields, stopContextForFields, {
        // Frete gerenciado pela transportadora tem paradas desabilitadas:
        // não cobrar a regra de primeiro ponto de Carga ao vincular motorista.
        hasLinkedDriver: hasLinkedDriver && !isCarrierManagedFreight,
      }),
    );

    if (hasNFeOnFreight) {
      const hasSelectedVehicle = tipoVeiculo?.dados?.some((v) => v.selected);
      if (!hasSelectedVehicle) {
        erros.push("Tipo de Veículo (Selecione pelo menos um)");
      }
      const hasSelectedBodywork = typeBodyworkList?.dados?.some(
        (v) => v.selected,
      );
      if (!hasSelectedBodywork) {
        erros.push("Tipo de Carroceria (Selecione pelo menos um)");
      }
    }

    return erros;
  };

  const getReleaseFreightInvalidFields = () => {
    const erros = [];

    // Mesma regra do save: só exige campos de negociação se o usuário os vê.
    if (canViewFreightDriver) {
      if (uidDriver && (!valueNegotiated || valueNegotiated === 0)) {
        erros.push("Valor Negociado");
      }
      if (
        !isCarrierManagedFreight &&
        (!valueDriverFinal || valueDriverFinal === 0)
      ) {
        erros.push("Valor Anunciado");
      }
    }

    const hasSelectedVehicle = tipoVeiculo?.dados?.some((v) => v.selected);
    if (!hasSelectedVehicle) {
      erros.push("Tipo de Veículo (Selecione pelo menos um)");
    }

    const hasSelectedBodywork = typeBodyworkList?.dados?.some(
      (v) => v.selected,
    );
    if (!hasSelectedBodywork) {
      erros.push("Tipo de Carroceria (Selecione pelo menos um)");
    }

    erros.push(...getAllStoppingPointErrorsForRelease(formFields));

    return erros;
  };

  /**
   * Função para tratar erros de campos obrigatórios
   * e exibir mensagem de erro para o usuário.
   * Se houver campos obrigatórios faltando, mostra
   * uma mensagem de erro com todos os campos faltando
   * de uma vez e para a execução. Caso contrário,
   * chama a função de salvar original.
   */
  const handleSave = () => {
    const camposInvalidos = getInvalidFields();

    if (camposInvalidos.length > 0) {
      // Exibe alerta com todos os campos faltando de uma vez
      setTitle("Campos( obrigatórios faltando");
      showMessage([
        "Alguns campos são de preenchimento obrigatório:",
        ...camposInvalidos,
      ]);
      // setStatus("error");
      setOpen(true);
      setLoading(false);
      return; // Para a execução e não salva
    }

    // Se passou, chama a função de salvar original

    idVerify === null || idVerify === undefined ? save() : update(false);
  };

  const handleReleaseFreight = () => {
    const camposInvalidos = getReleaseFreightInvalidFields();

    if (camposInvalidos.length > 0) {
      setTitle("Campos obrigatórios faltando");
      showMessage([
        "Para liberar o frete, preencha os campos obrigatórios:",
        ...camposInvalidos,
      ]);
      setOpen(true);
      setLoading(false);
      return;
    }

    idVerify === null || idVerify === undefined
      ? save({ releaseFreight: true })
      : update(false, false, { releaseFreight: true });
  };

  const currentFreightStatusCode = resolveStatusCode(
    freightOrigin?.status ?? { code, describe: status },
    resolveStatusDescribe(freightOrigin?.status, code) || status,
  );
  const isFreightPendingValidation = isFreightPendingValidationStatus(
    freightOrigin?.status ?? { code, describe: status },
    status,
  );
  const validateAllSimulationsEnabled =
    getPayingShipperValidateAllSimulations();
  /** Visível em P. Validação (00) quando o pagador exige validação e o usuário tem permissão Liberar frete. */
  const showReleaseFreightButton =
    validateAllSimulationsEnabled &&
    canReleaseFreightByPermission &&
    isFreightPendingValidation &&
    !view;

  const cargoStops = formFields
    .map((form, index) => ({ form, index }))
    .filter(({ form }) => hasCargaOperation(form.operation))
    .sort(
      (a, b) =>
        (a.form.stop_order || a.index + 1) - (b.form.stop_order || b.index + 1),
    );

  const stopValidationContext = getStopValidationContext();
  const hasNFeOnFreight = freightHasCargaNFeAttached(
    formFields,
    stopValidationContext.freightAttachments,
  );
  const hasCargaStopsOnFreight = formFields.some((stop) =>
    hasCargaOperation(stop?.operation),
  );
  const hasLinkedDriver = Boolean(uidDriver);
  const freightFieldOptions = {
    canViewFreightSection,
    canViewFreightDriver,
    uidDriver,
    hasCargaStopsOnFreight,
    freightStatusCode: code,
    freightStatusDescribe: status,
  };
  const stopFieldContext = {
    ...stopValidationContext,
    hasLinkedDriver,
  };
  const orderedFormFields = useMemo(
    () => normalizeStoppingPointOrder(formFields),
    [formFields],
  );
  const handleStopPointDragEnd = ({ source, destination }) => {
    if (!destination || view || isCarrierManagedFreight) return;

    setFormFields((prev) =>
      reorderStoppingPoints(prev, source.index, destination.index),
    );
  };
  const isFreightFieldRequired = (fieldName) =>
    isFreightFormFieldRequired(
      fieldName,
      stopValidationContext,
      freightFieldOptions,
    );
  const hasFreightCalculationError = (message) =>
    Array.isArray(errosFreightCalculationRef.current) &&
    errosFreightCalculationRef.current.includes(message);

  const hasAxlesCalculationError =
    !axles && hasFreightCalculationError("Quantidade de eixos inválida.");

  const hasValueNFCalculationError =
    !valueNF && hasFreightCalculationError("Valor da carga é obrigatório.");

  const hasWeightCalculationError =
    !weightCargo && weightCargo == 0 && hasFreightCalculationError("Peso da carga é obrigatório.");

  const hasStopping_points =
    !formFields.length < 1 &&
    hasFreightCalculationError("Informe ao menos origem e destino.");

  const handleCargoProductChange = (index, field, value) => {
    setFormFields((prev) => {
      const newFormFields = [...prev];

      newFormFields[index] = {
        ...newFormFields[index],
        [field]: value,
      };

      return newFormFields;
    });
  };

  return (
    <div className="min-h-screen  " style={{ backgroundColor: "#F9FAFB" }}>
      <>
        {useSelector((state) => state.usuarioLogado) > 0 ? (
          <NewMiniDrawer
            divOpen={
              <Box
                sx={{
                  display: "block",
                  width: "100%",
                  mx: "1px",
                }}
              >
                <div
                  className="freight-content align-items-center"
                  style={{ paddingTop: "0px" }}
                >
                  {/* Dialog de upload de arquivo  */}
                  <AlertDialogFreight
                    handleClose={handleCloseModal}
                    open={openOrigem}
                    origem={origem}
                    handleUpload={handleUpload}
                    operationType={currentOperationType}
                    uploadProgress={carregando}
                  />

                  {/* Dialog de upload de arquivo  */}
                  <UploadInvoices
                    handleClose={handleCloseUploadInvoices}
                    open={openUploadInvoices}
                    origem={origem}
                    handleUpload={handleUpload}
                    operationType={currentOperationType}
                    uploadProgress={carregando}
                    onUploadSuccess={showNfePostImportNotice}
                  />

                  <Snackbar
                    open={nfeImportNoticeOpen}
                    autoHideDuration={5000}
                    onClose={handleCloseNfePostImportNotice}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  >
                    <Alert
                      severity="info"
                      variant="filled"
                      onClose={handleCloseNfePostImportNotice}
                      sx={{ width: "100%", maxWidth: 520 }}
                    >
                      NF-e ou documento anexado (web ou app). Preencha os campos
                      obrigatórios das paradas (CNPJ, CEP, endereço) e do frete
                      (ocupação, valores do motorista, peso, valor NF e valor do
                      frete) antes de salvar.
                    </Alert>
                  </Snackbar>

                  <ShipperDialog
                    handleClose={handleShipperCloseModal}
                    open={openShipper}
                    dadosClient={getDadaClient}
                  />

                  <div className="container">
                    <div className="row">
                      <div className="col-5">
                        <p className="help-block">
                          {" "}
                          Número Orçamento:{" "}
                          <strong> {numberSerial} </strong>{" "}
                        </p>
                      </div>
                      <div className="col-5"></div>
                      <div className="col-2">
                        <div className="col-md-11 control-label">
                          <p className="help-block">
                            <span className="h11">*</span>
                            <strong> Campo Obrigatório </strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row g-12">
                    <div
                      // class="btn-group"
                      role="group"
                      aria-label="Basic radio toggle button group"
                    >
                      {/* <HorizontalStepper status={code} /> */}

                      <div
                        style={{
                          alignItems: "flex-start",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "16px",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <div style={{ flex: 1, minWidth: "280px" }}>
                          <ModernStepper
                            propsStatus={timelineStatusCode}
                            canceled={isFreightCanceled}
                          />
                        </div>

                        {canShowActionsMenu ? (
                          <>
                            <IconButton
                              aria-label="Abrir menu de acoes"
                              aria-controls={
                                actionsMenuAnchorEl
                                  ? "freight-actions-popover"
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                actionsMenuAnchorEl ? "true" : undefined
                              }
                              onClick={handleOpenActionsMenu}
                              sx={{
                                alignSelf: "flex-start",
                                backgroundColor: theme.colors.highlight,
                                border: `1px solid ${theme.colors.highlight}`,
                                borderRadius: "14px",
                                boxShadow: theme.elevation.base,
                                color: theme.colors.surface,
                                height: "48px",
                                marginTop: "2px",
                                width: "48px",
                                "&:hover": {
                                  backgroundColor: theme.colors.surface,
                                  color: theme.colors.highlight,
                                  boxShadow:
                                    "0 4px 10px rgba(255, 49, 0, 0.22)",
                                },
                              }}
                            >
                              <MenuIcon />
                            </IconButton>
                            <Popover
                              id="freight-actions-popover"
                              open={Boolean(actionsMenuAnchorEl)}
                              anchorEl={actionsMenuAnchorEl}
                              onClose={handleCloseActionsMenu}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              PaperProps={{
                                sx: {
                                  borderRadius: "24px",
                                  boxShadow:
                                    "0px 10px 40px rgba(1, 36, 67, 0.15)",
                                  mt: 1,
                                  p: 1.5,
                                  width: 220,
                                },
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 1,
                                }}
                              >
                                {isFreightCanceled ? (
                                  <Button
                                    fullWidth
                                    startIcon={<LoopIcon />}
                                    onClick={handleOpenReactivateDialogFromMenu}
                                    sx={{
                                      borderRadius: "14px",
                                      color: theme.colors.primary,
                                      fontWeight:
                                        theme.typography.weightSemibold,
                                      justifyContent: "flex-start",
                                      px: 1.5,
                                      py: 1,
                                      textTransform: "none",
                                      "& .MuiButton-startIcon": {
                                        color: theme.colors.highlight,
                                      },
                                      "&:hover": {
                                        backgroundColor:
                                          theme.colors.highlightSoft,
                                        color: theme.colors.highlight,
                                      },
                                    }}
                                  >
                                    Reativar
                                  </Button>
                                ) : null}
                                {canShowCancelButton ? (
                                  <Button
                                    fullWidth
                                    startIcon={<CancelOutlinedIcon />}
                                    onClick={handleOpenCancelDialogFromMenu}
                                    sx={{
                                      borderRadius: "14px",
                                      color: theme.colors.primary,
                                      fontWeight:
                                        theme.typography.weightSemibold,
                                      justifyContent: "flex-start",
                                      px: 1.5,
                                      py: 1,
                                      textTransform: "none",
                                      "& .MuiButton-startIcon": {
                                        color: theme.colors.highlight,
                                      },
                                      "&:hover": {
                                        backgroundColor:
                                          theme.colors.highlightSoft,
                                        color: theme.colors.highlight,
                                      },
                                    }}
                                  >
                                    Cancelar
                                  </Button>
                                ) : null}
                                {pickupOrderUrl ? (
                                  <Button
                                    component="a"
                                    href={pickupOrderUrl.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                    fullWidth
                                    startIcon={<DownloadIcon />}
                                    onClick={handleCloseActionsMenu}
                                    sx={{
                                      borderRadius: "14px",
                                      color: theme.colors.primary,
                                      fontWeight:
                                        theme.typography.weightSemibold,
                                      justifyContent: "flex-start",
                                      px: 1.5,
                                      py: 1,
                                      textTransform: "none",
                                      "& .MuiButton-startIcon": {
                                        color: theme.colors.highlight,
                                      },
                                      "&:hover": {
                                        backgroundColor:
                                          theme.colors.highlightSoft,
                                        color: theme.colors.highlight,
                                      },
                                    }}
                                  >
                                    Baixar ordem de coleta
                                  </Button>
                                ) : null}
                              </Box>
                            </Popover>
                          </>
                        ) : null}
                      </div>
                    </div>

                    <hr className="my-4" />
                  </div>

                  {listShipper.length > 1 && !isCarrierManagedFreight && (
                    <Card
                      sx={{ padding: 2 }}
                      className="form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                      }}
                    >
                      <div className="form-signin mx-auto mb-4 mb-lg-6">
                        {/* <h4 className="mb-3"> <AttachMoneyIcon fontSize="medium" /> Pagador</h4> */}

                        <h4
                          style={{
                            alignItems: "center",
                            color: COLORS.ink,
                            display: "flex",
                            fontWeight: 700,
                            gap: "8px",
                            margin: 0,
                          }}
                        >
                          <Box sx={cardIconSx}>
                            <AttachMoneyIcon
                              fontSize="medium"
                              style={{ color: COLORS.white }}
                            />
                          </Box>{" "}
                          Pagador
                        </h4>

                        <div className="row justify-content-center align-items-center gx-3">
                          <div className="col-4">
                            <label
                              htmlFor="payingCustomerLabel"
                              className="font-test"
                            >
                              Cliente
                              <RequiredMark
                                show={isFreightFieldRequired("payingCustomer")}
                              />
                            </label>

                            <Autocomplete
                              sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "10px",
                                },
                              }}
                              id="chose-1"
                              size="small"
                              disabled={view}
                              value={listECShipper && listECShipper}
                              getOptionLabel={getShipperOptionLabel}
                              filterOptions={filterShipperByDisplayName}
                              options={listShipper}
                              isOptionEqualToValue={(option, value) =>
                                option?.id === value?.id
                              }
                              renderOption={(props, option) => {
                                const { key, ...optionProps } = props;
                                return (
                                  <li key={option?.id || key} {...optionProps}>
                                    {getShipperOptionLabel(option)}
                                  </li>
                                );
                              }}
                              onChange={(event, value) => {
                                handleChangeClient(value);
                              }}
                              noOptionsText="Nenhum Embarcador com esse nome foi encontrado"
                              renderInput={(params) => (
                                <TextField {...params} label="" />
                              )}
                            />
                          </div>

                          <div className="col-md-3">
                            <label
                              htmlFor="cnpjPayingCustomerLabel"
                              className="font-test"
                            >
                              CNPJ
                              <RequiredMark
                                show={isFreightFieldRequired(
                                  "cnpjPayingCustomer",
                                )}
                              />
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              name="cnpjPayingCustomer"
                              onChange={(e) =>
                                setCnpjPayingCustomer(e.target.value)
                              }
                              value={cnpjPayingCustomer && cnpjPayingCustomer}
                              className="form-control"
                              id="cnpjPayingCustomer"
                              style={{ borderRadius: "10px" }}
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  )}

                  {/** PONTOS DE PARADAS */}

                  <div className="row g-12">
                    <div
                      className="form-signin mx-auto mb-4 mb-lg-6 stop-points-shell"
                      style={{
                        ...freightStopPointsThemeVars,
                        background: COLORS.paper,
                        border: `1px solid ${COLORS.line}`,
                        boxShadow: SOFT_SHADOW,
                        borderRadius: "16px",
                        padding: "8px 12px 2px",
                      }}
                    >
                      <Box
                        sx={{
                          alignItems: "center",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 1,
                          justifyContent: "space-between",
                          mb: 1.8,
                          mt: 0.2,
                          px: 0.6,
                        }}
                      >
                        <Box
                          sx={{
                            alignItems: "flex-start",
                            display: "flex",
                            flexDirection: "column",
                            gap: 0.5,
                          }}
                        >
                          <h4
                            style={{
                              alignItems: "center",
                              color: hasStopping_points ? COLORS.danger : COLORS.ink,
                              display: "flex",
                              fontWeight: 700,
                              gap: "8px",
                              margin: 0,
                            }}
                          >
                            <img
                              alt=""
                              aria-hidden="true"
                              className="stop-points-title-icon"
                              src={stopPointMarkerIcon}
                            />
                            Pontos de paradas
                          </h4>

                          {hasStopping_points ? (
                            <label style={{
                              borderColor: COLORS.danger,
                              color: COLORS.danger,
                              fontWeight: 700,
                            }}>
                              Informe ao menos origem e destino, Para calcular o frete.
                            </label>
                          ) : ('')}
                        </Box>

                        <Chip
                          size="small"
                          label={`${formFields.length} parada${formFields.length === 1 ? "" : "s"
                            }`}
                          sx={{
                            fontSize: 16,
                            borderRadius: "8px",
                            background: "#ffffff",
                            border: `1px solid ${COLORS.line}`,
                            boxShadow: SOFT_SHADOW,
                            color: COLORS.ink,
                            fontWeight: 600,
                            "& .MuiChip-label": { px: 1.2 },
                          }}
                        />
                      </Box>

                      <div className="form-signin mx-auto mb-4 mb-lg-6">
                        <DragDropContext onDragEnd={handleStopPointDragEnd}>
                          <Droppable droppableId="stopping-points">
                            {(droppableProvided) => (
                              <div
                                ref={droppableProvided.innerRef}
                                {...droppableProvided.droppableProps}
                              >
                                {orderedFormFields.map((form, index) => {
                                  const indiceReal = formFields.findIndex(
                                    (item) =>
                                      item.number_collect === form.number_collect,
                                  );
                                  const hasCargaStop = hasCargaOperation(
                                    form.operation,
                                  );
                                  const hasDescargaStop = hasDescargaOperation(
                                    form.operation,
                                  );
                                  const stoppingPointStatusLabel =
                                    getStoppingPointStatusLabel(form);
                                  const stoppingPointDocuments =
                                    getStoppingPointDocuments(form);
                                  const showCargaDocuments =
                                    hasCargaOperation(form.operation) &&
                                    stoppingPointDocuments.length > 0;
                                  const isStopRequired = (fieldName) =>
                                    isStopFieldRequired(fieldName, form, {
                                      ...stopFieldContext,
                                      index: indiceReal,
                                    });
                                  const stopLabel = `Parada ${form.stop_order || index + 1
                                    }`;
                                  const stopAttachments = Array.isArray(
                                    form.attachments,
                                  )
                                    ? form.attachments.filter(
                                      (attachment) => attachment && attachment.url,
                                    )
                                    : [];
                                  const stopCanhotos = hasDescargaStop
                                    ? normalizeCanhotosList(
                                      form.canhoto,
                                      form.id || "",
                                    )
                                    : [];
                                  const hasCanhoto =
                                    hasDescargaStop && stopCanhotos.length > 0;
                                  const hasAttachments = stopAttachments.length > 0;
                                  const hasProofFiles = hasCanhoto || hasAttachments;
                                  const stopLockedForEdition =
                                    isStopLockedForEdition(form);
                                  const stopReadOnly =
                                    view ||
                                    stopLockedForEdition ||
                                    isCarrierManagedFreight;
                                  const stopTypeLabel = hasCargaStop
                                    ? "Carga"
                                    : hasDescargaStop
                                      ? "Descarga"
                                      : "Sem tipo";
                                  const proofLabel = hasProofFiles
                                    ? "Com comprovante"
                                    : "Sem comprovante";
                                  const numberCollectLabel = form.number_collect
                                    ? form.number_collect
                                    : "N/A";
                                  return (
                                    <Draggable
                                      key={`${form.id || form.number_collect || index}`}
                                      draggableId={`stop-${form.id || form.number_collect || index}`}
                                      index={index}
                                      isDragDisabled={
                                        index === 0 || view || isCarrierManagedFreight
                                      }
                                    >
                                      {(draggableProvided, draggableSnapshot) => (
                                        <Box
                                          ref={draggableProvided.innerRef}
                                          {...draggableProvided.draggableProps}
                                          component="span"
                                          sx={sxWrap}
                                          className="form-signin"
                                          style={{
                                            ...draggableProvided.draggableProps.style,
                                          }}
                                        >
                                          <Card
                                            className="form-signin mx-auto mb-4 mb-lg-6 align-items-center"
                                            sx={{
                                              ...sxCard(hasProofFiles),
                                              borderColor: draggableSnapshot.isDragging
                                                ? COLORS.danger
                                                : undefined,
                                            }}
                                          >
                                            <Box className="stop-point-card-body">
                                              <Box
                                                className="stop-point-card-meta"
                                                sx={{
                                                  alignItems: "center",
                                                  display: "flex",
                                                  flexWrap: "wrap",
                                                  gap: 1,
                                                  mb: 2.2,
                                                }}
                                              >
                                                <IconButton
                                                  {...draggableProvided.dragHandleProps}
                                                  disabled={
                                                    index === 0 ||
                                                    stopReadOnly ||
                                                    isCarrierManagedFreight
                                                  }
                                                  aria-label={`Arrastar parada ${form.stop_order || index + 1}`}
                                                  size="small"
                                                  sx={{
                                                    background:
                                                      index === 0
                                                        ? "rgba(1,36,66,0.06)"
                                                        : "#ffffff",
                                                    border: `1px solid ${COLORS.line}`,
                                                    boxShadow: SOFT_SHADOW,
                                                    color:
                                                      index === 0
                                                        ? COLORS.inkSoft
                                                        : COLORS.ink,
                                                    cursor:
                                                      index === 0 || stopReadOnly
                                                        ? "not-allowed"
                                                        : "grab",
                                                    height: 32,
                                                    width: 32,
                                                    "&:hover": {
                                                      background: "rgba(255,49,0,0.06)",
                                                      color: COLORS.danger,
                                                    },
                                                  }}
                                                >
                                                  <MenuIcon fontSize="small" />
                                                </IconButton>
                                                <Chip
                                                  size="small"
                                                  icon={
                                                    <LocationOnIcon
                                                      sx={{
                                                        color: `${COLORS.ink} !important`,
                                                        fontSize: "0.9rem",
                                                      }}
                                                    />
                                                  }
                                                  label={`Parada ${form.stop_order || index + 1}`}
                                                  sx={{
                                                    background: "#ffffff",
                                                    border: `1px solid ${COLORS.line}`,
                                                    color: COLORS.ink,
                                                    fontSize: 16,
                                                    fontWeight: 600,
                                                    boxShadow: SOFT_SHADOW,

                                                    "& .MuiChip-label": {
                                                      fontSize: "0.94rem",
                                                    },
                                                  }}
                                                />
                                                <Chip
                                                  size="small"
                                                  label={stopTypeLabel}
                                                  sx={{
                                                    background: hasCargaStop
                                                      ? "rgba(1,36,66,0.08)"
                                                      : hasDescargaStop
                                                        ? "rgba(255,49,0,0.12)"
                                                        : "#ffffff",
                                                    border: `1px solid ${hasDescargaStop
                                                      ? "rgba(255,49,0,0.35)"
                                                      : "rgba(1,36,66,0.2)"
                                                      }`,
                                                    color: hasDescargaStop
                                                      ? COLORS.danger
                                                      : COLORS.ink,
                                                    fontWeight: 600,
                                                    boxShadow: SOFT_SHADOW,
                                                    "& .MuiChip-label": {
                                                      fontSize: "0.94rem",
                                                    },
                                                  }}
                                                />
                                                <Chip
                                                  size="small"
                                                  label={proofLabel}
                                                  sx={{
                                                    background: hasProofFiles
                                                      ? "rgba(255,49,0,0.08)"
                                                      : "rgba(1,36,66,0.06)",
                                                    border: `1px solid ${hasProofFiles
                                                      ? "rgba(255,49,0,0.3)"
                                                      : "rgba(1,36,66,0.2)"
                                                      }`,
                                                    color: hasProofFiles
                                                      ? COLORS.danger
                                                      : COLORS.inkSoft,
                                                    fontWeight: 600,
                                                    boxShadow: SOFT_SHADOW,
                                                    "& .MuiChip-label": {
                                                      fontSize: "0.94rem",
                                                    },
                                                  }}
                                                />
                                                <Chip
                                                  size="small"
                                                  label={`N.º ${numberCollectLabel}`}
                                                  sx={{
                                                    background: "#ffffff",
                                                    border: `1px solid ${COLORS.line}`,
                                                    color: COLORS.ink,
                                                    fontSize: 16,
                                                    fontWeight: 600,
                                                    boxShadow: SOFT_SHADOW,
                                                    "& .MuiChip-label": {
                                                      fontSize: "0.94rem",
                                                    },
                                                  }}
                                                />
                                                {stoppingPointStatusLabel && (
                                                  <Chip
                                                    size="small"
                                                    icon={
                                                      <LocalShippingIcon
                                                        sx={{
                                                          color: `${COLORS.danger} !important`,
                                                          fontSize: "0.95rem",
                                                        }}
                                                      />
                                                    }
                                                    label={stoppingPointStatusLabel}
                                                    sx={{
                                                      background: "rgba(255,49,0,0.06)",
                                                      border: "1px solid rgba(255,49,0,0.22)",
                                                      color: COLORS.ink,
                                                      fontSize: 16,
                                                      fontWeight: 600,
                                                      boxShadow: SOFT_SHADOW,
                                                      "& .MuiChip-label": {
                                                        fontSize: "0.94rem",
                                                      },
                                                    }}
                                                  />
                                                )}
                                              </Box>
                                              <div className="row mb-5">
                                                <Spin spinning={loading} size="Large">
                                                  <fieldset
                                                    disabled={stopReadOnly}
                                                    style={{
                                                      border: 0,
                                                      margin: 0,
                                                      minWidth: 0,
                                                      padding: 0,
                                                    }}
                                                  >
                                                    <div className="stop-point-type-row">
                                                      <div className="stop-point-field stop-point-field--order">
                                                        <label
                                                          htmlFor="ordenacaoLabel"
                                                          className="font-test"
                                                        >
                                                          Ordenação
                                                        </label>
                                                        <input
                                                          disabled={stopReadOnly}
                                                          type="number"
                                                          name="stop_order"
                                                          min={1}
                                                          onChange={(event) =>
                                                            handleFormChange(
                                                              event,
                                                              indiceReal,
                                                            )
                                                          }
                                                          value={
                                                            form.stop_order &&
                                                            form.stop_order
                                                          }
                                                          // disabled={form.concluded && isCopy !== "true"}
                                                          size={"small"}
                                                          className="form-control"
                                                          id="ordenacao"
                                                          placeholder=""
                                                        />
                                                      </div>

                                                      <div className="stop-point-field stop-point-field--type">
                                                        <FormControl component="fieldset">
                                                          <FormLabel id="demo-row-radio-buttons-group-label">
                                                            <label className="font-test">
                                                              Tipo de Parada
                                                              <RequiredMark
                                                                show={isStopRequired(
                                                                  "operation",
                                                                )}
                                                              />
                                                            </label>
                                                          </FormLabel>
                                                          <div className="row">
                                                            <div className="col-6 mb-2">
                                                              <FormControlLabel
                                                                disabled={stopReadOnly}
                                                                value="carga"
                                                                name="carga"
                                                                onChange={(event) => {
                                                                  handleNameButtonImport(
                                                                    "carga",
                                                                  );
                                                                  handleCheckBoxChange(
                                                                    event,
                                                                    indiceReal,
                                                                  );
                                                                }}
                                                                control={
                                                                  <Checkbox
                                                                    checked={hasCargaOperation(
                                                                      form.operation,
                                                                    )}
                                                                    disabled={hasDescargaOperation(
                                                                      form.operation,
                                                                    )}
                                                                  />
                                                                }
                                                                label="Carga"
                                                              />
                                                            </div>
                                                            <div className="col-6 mb-2">
                                                              <FormControlLabel
                                                                disabled={stopReadOnly}
                                                                value="descarga"
                                                                name="descarga"
                                                                onChange={(event) => {
                                                                  handleNameButtonImport(
                                                                    "descarga",
                                                                  );
                                                                  handleCheckBoxChange(
                                                                    event,
                                                                    indiceReal,
                                                                  );
                                                                }}
                                                                control={
                                                                  <Checkbox
                                                                    checked={hasDescargaOperation(
                                                                      form.operation,
                                                                    )}
                                                                    disabled={hasCargaOperation(
                                                                      form.operation,
                                                                    )}
                                                                  />
                                                                }
                                                                label="Descarga"
                                                              />
                                                            </div>
                                                          </div>
                                                        </FormControl>
                                                      </div>

                                                    </div>

                                                    <div className="stop-point-main-grid">
                                                      <div className="stop-point-field stop-point-field--cnpj">
                                                        <label
                                                          htmlFor="cnpjLabel"
                                                          className="font-test"
                                                        >
                                                          CNPJ
                                                          <RequiredMark
                                                            show={isStopRequired(
                                                              "cpf_cnpj",
                                                            )}
                                                          />
                                                        </label>
                                                        <input
                                                          disabled={stopReadOnly}
                                                          type="text"
                                                          name="cpf_cnpj"
                                                          onChange={(event) => {
                                                            handleFormChange(
                                                              event,
                                                              indiceReal,
                                                            );
                                                          }}
                                                          onBlur={(event) => {
                                                            const value =
                                                              event.target.value;
                                                            const onlyNumbers =
                                                              value.replace(/\D/g, "");

                                                            if (
                                                              onlyNumbers.length === 11 ||
                                                              onlyNumbers.length === 14
                                                            ) {
                                                              buscarCNPJBancoClient(
                                                                onlyNumbers,
                                                                indiceReal,
                                                              );
                                                            }
                                                          }}
                                                          value={form.cpf_cnpj || ""}
                                                          className="form-control"
                                                          id="cnpj"
                                                          placeholder=""
                                                        />
                                                      </div>

                                                      <div className="stop-point-field stop-point-field--name">
                                                        <label
                                                          htmlFor="nomeLabel"
                                                          className="font-test"
                                                        >
                                                          Nome
                                                          <RequiredMark
                                                            show={isStopRequired("name")}
                                                          />
                                                        </label>
                                                        <Autocomplete
                                                          freeSolo
                                                          disabled={stopReadOnly}
                                                          size="small"
                                                          options={stopClientOptions}
                                                          value={
                                                            stopClientOptions.find(
                                                              (option) =>
                                                                option.label ===
                                                                form.name ||
                                                                option.document ===
                                                                String(
                                                                  form.cpf_cnpj || "",
                                                                ).replace(/\D/g, ""),
                                                            ) ||
                                                            form.name ||
                                                            ""
                                                          }
                                                          inputValue={form.name || ""}
                                                          getOptionLabel={(option) =>
                                                            typeof option === "string"
                                                              ? option
                                                              : option?.label || ""
                                                          }
                                                          filterOptions={(
                                                            options,
                                                            state,
                                                          ) => {
                                                            const query =
                                                              normalizeClientSearchText(
                                                                state.inputValue,
                                                              );
                                                            if (!query) {
                                                              return options.slice(0, 20);
                                                            }
                                                            return options
                                                              .filter((option) =>
                                                                option.searchText.includes(
                                                                  query,
                                                                ),
                                                              )
                                                              .slice(0, 20);
                                                          }}
                                                          isOptionEqualToValue={(
                                                            option,
                                                            value,
                                                          ) => {
                                                            if (
                                                              !option ||
                                                              !value ||
                                                              typeof value === "string"
                                                            ) {
                                                              return false;
                                                            }
                                                            return option.id === value.id;
                                                          }}
                                                          onChange={(_, selected) =>
                                                            handleStopClientChange(
                                                              selected,
                                                              indiceReal,
                                                            )
                                                          }
                                                          onInputChange={(
                                                            _,
                                                            newInputValue,
                                                            reason,
                                                          ) => {
                                                            if (reason === "reset")
                                                              return;
                                                            handleFormChange(
                                                              {
                                                                target: {
                                                                  name: "name",
                                                                  value:
                                                                    newInputValue || "",
                                                                },
                                                              },
                                                              indiceReal,
                                                            );
                                                          }}
                                                          noOptionsText="Nenhum cliente encontrado"
                                                          sx={{
                                                            width: "100%",
                                                            "& .MuiOutlinedInput-root": {
                                                              borderRadius: "0.375rem",
                                                              minHeight: 38,
                                                            },
                                                            "& .MuiInputBase-input": {
                                                              padding: "7.5px 4px",
                                                            },
                                                          }}
                                                          renderOption={(
                                                            props,
                                                            option,
                                                          ) => {
                                                            const { key, ...liProps } =
                                                              props;
                                                            return (
                                                              <Box
                                                                component="li"
                                                                key={key || option.id}
                                                                {...liProps}
                                                              >
                                                                <div>
                                                                  <strong>
                                                                    {option.label}
                                                                  </strong>
                                                                  {option.document ? (
                                                                    <div>
                                                                      {option.document}
                                                                    </div>
                                                                  ) : null}
                                                                  {option.addressLine ? (
                                                                    <div>
                                                                      {option.addressLine}
                                                                    </div>
                                                                  ) : null}
                                                                </div>
                                                              </Box>
                                                            );
                                                          }}
                                                          renderInput={(params) => (
                                                            <TextField
                                                              {...params}
                                                              id="name"
                                                              name="name"
                                                              placeholder=""
                                                            />
                                                          )}
                                                        />
                                                      </div>

                                                      <div className="stop-point-field stop-point-field--date">
                                                        <label
                                                          htmlFor="datacoletaLabel"
                                                          className="font-test"
                                                        >
                                                          {getStopDateOperationLabel(
                                                            form.operation,
                                                          )}
                                                          <RequiredMark
                                                            show={isStopRequired(
                                                              "date_operation",
                                                            )}
                                                          />
                                                        </label>
                                                        <input
                                                          disabled={stopReadOnly}
                                                          type="date"
                                                          name="date_operation"
                                                          onChange={(event) =>
                                                            handleFormChange(
                                                              event,
                                                              indiceReal,
                                                            )
                                                          }
                                                          value={
                                                            form.date_operation || ""
                                                          }
                                                          className="form-control"
                                                          id="datacoleta"
                                                        />
                                                      </div>

                                                      <div className="stop-point-field stop-point-field--time">
                                                        <label
                                                          htmlFor="horacoletaLabel"
                                                          className="font-test"
                                                        >
                                                          {getStopTimeOperationLabel(
                                                            form.operation,
                                                          )}
                                                          <RequiredMark
                                                            show={isStopRequired(
                                                              "time_operation",
                                                            )}
                                                          />
                                                        </label>

                                                        <InputMask
                                                          disabled={stopReadOnly}
                                                          mask="99:99"
                                                          id="phoneResp"
                                                          className="form-control"
                                                          name="time_operation"
                                                          onChange={(event) =>
                                                            handleFormChange(
                                                              event,
                                                              indiceReal,
                                                            )
                                                          }
                                                          value={
                                                            form.time_operation &&
                                                            form.time_operation
                                                          }
                                                          placeholder="99:99"
                                                        />
                                                      </div>

                                                      <div className="stop-point-actions">
                                                        <IconButton
                                                          size="small"
                                                          disabled={stopReadOnly}
                                                          onClick={() =>
                                                            duplicateForm(indiceReal)
                                                          }
                                                          sx={sxIconBtn("default")}
                                                        >
                                                          <ContentCopyIcon fontSize="small" />
                                                        </IconButton>
                                                      </div>
                                                    </div>

                                                    <div className="stop-point-address-grid">
                                                      <div className="stop-point-field stop-point-field--cep">
                                                        <label
                                                          htmlFor="cepLabel"
                                                          className="font-test"
                                                        >
                                                          CEP
                                                          <RequiredMark
                                                            show={isStopRequired("cep")}
                                                          />
                                                        </label>
                                                        <input
                                                          disabled={stopReadOnly}
                                                          type="text"
                                                          name="cep"
                                                          onChange={(event) => {
                                                            // atualiza pelo que o usuário digita usando o índice real
                                                            handleFormChange(
                                                              event,
                                                              indiceReal,
                                                            );

                                                            // Só dispara a busca se tiver 8 dígitos numéricos
                                                            const rawValue =
                                                              event.target.value.replace(
                                                                /\D/g,
                                                                "",
                                                              );
                                                            if (rawValue.length === 8) {
                                                              buscarCepPaying(
                                                                rawValue,
                                                                indiceReal,
                                                              );
                                                            }
                                                          }}
                                                          value={form.cep || ""}
                                                          maxLength={9}
                                                          className="form-control"
                                                          id="cep"
                                                        />
                                                      </div>

                                                      <div className="stop-point-field stop-point-field--address">
                                                        <label
                                                          htmlFor="addressLabel"
                                                          className="font-test"
                                                        >
                                                          Endereço
                                                          <RequiredMark
                                                            show={isStopRequired(
                                                              "logradouro",
                                                            )}
                                                          />
                                                        </label>
                                                        <input
                                                          disabled={stopReadOnly}
                                                          type="text"
                                                          // disabled={form.concluded && isCopy !== "true"}
                                                          name="logradouro"
                                                          onChange={(event) =>
                                                            handleFormChange(
                                                              event,
                                                              indiceReal,
                                                            )
                                                          }
                                                          value={
                                                            form.logradouro &&
                                                            form.logradouro
                                                          }
                                                          className="form-control"
                                                          id="address"
                                                        />
                                                      </div>

                                                      <div className="stop-point-field stop-point-field--number">
                                                        <label
                                                          htmlFor="numberLabel"
                                                          className="font-test"
                                                        >
                                                          N.º
                                                          <RequiredMark
                                                            show={isStopRequired(
                                                              "number",
                                                            )}
                                                          />
                                                        </label>
                                                        <input
                                                          disabled={stopReadOnly}
                                                          type="text"
                                                          name="number"
                                                          onChange={(event) => {
                                                            handleFormChange(
                                                              event,
                                                              indiceReal,
                                                            );
                                                          }}
                                                          onBlur={() => {
                                                            consultStreetByStreet(
                                                              indiceReal,
                                                            );
                                                          }}
                                                          value={form.number || ""}
                                                          className="form-control"
                                                          id="numberAddress"
                                                        />
                                                      </div>

                                                      <div className="stop-point-field stop-point-field--city">
                                                        <label
                                                          htmlFor="city"
                                                          className="font-test"
                                                        >
                                                          Cidade
                                                          <RequiredMark
                                                            show={isStopRequired("city")}
                                                          />
                                                        </label>
                                                        <input
                                                          disabled={stopReadOnly}
                                                          type="text"
                                                          // disabled={form.concluded && isCopy !== "true"}
                                                          name="city"
                                                          onChange={(event) =>
                                                            handleFormChange(
                                                              event,
                                                              indiceReal,
                                                            )
                                                          }
                                                          value={form.city && form.city}
                                                          className="form-control"
                                                          id="cityAddress"
                                                          placeholder=""
                                                        />
                                                      </div>

                                                      <div className="stop-point-field stop-point-field--state">
                                                        <label
                                                          htmlFor="stateInitialLabel"
                                                          className="font-test"
                                                        >
                                                          Estado
                                                          <RequiredMark
                                                            show={isStopRequired("uf")}
                                                          />
                                                        </label>
                                                        <input
                                                          disabled={stopReadOnly}
                                                          type="text"
                                                          // disabled={form.concluded && isCopy !== "true"}
                                                          name="uf"
                                                          onChange={(event) =>
                                                            handleFormChange(
                                                              event,
                                                              indiceReal,
                                                            )
                                                          }
                                                          value={form.uf && form.uf}
                                                          className="form-control"
                                                          id="stateInitial"
                                                        />
                                                      </div>

                                                      <div className="stop-point-actions">
                                                        <IconButton
                                                          size="small"
                                                          disabled={stopReadOnly}
                                                          onClick={() =>
                                                            deleteItem(form, indiceReal)
                                                          }
                                                          sx={sxIconBtn("danger")}
                                                        >
                                                          <DeleteForeverIcon fontSize="small" />
                                                        </IconButton>
                                                      </div>
                                                    </div>

                                                    {/* ===================================================================================== */}

                                                    <div className="row">
                                                      {canViewFreightCoordinates && (
                                                        <>
                                                          <div className="col-md-3 mb-2">
                                                            {" "}
                                                            <label
                                                              htmlFor="Latitude"
                                                              className="font-test"
                                                            >
                                                              Latitude
                                                            </label>
                                                            <input
                                                              type="text"
                                                              name="latitude"
                                                              disabled={
                                                                !form.manualCoordinatesEnabled
                                                              }
                                                              value={
                                                                form.latitude &&
                                                                form.latitude
                                                              }
                                                              className="form-control"
                                                              id="latitude"
                                                              onChange={(event) =>
                                                                handleFormChange(
                                                                  event,
                                                                  indiceReal,
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                          <div className="col-md-3 mb-4">
                                                            {" "}
                                                            <label
                                                              htmlFor="Longitude"
                                                              className="font-test"
                                                            >
                                                              Longitude
                                                            </label>
                                                            <input
                                                              type="text"
                                                              disabled={
                                                                !form.manualCoordinatesEnabled
                                                              }
                                                              name="longitude"
                                                              value={
                                                                form.longitude &&
                                                                form.longitude
                                                              }
                                                              className="form-control"
                                                              id="longitude"
                                                              onChange={(event) =>
                                                                handleFormChange(
                                                                  event,
                                                                  indiceReal,
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                        </>
                                                      )}
                                                    </div>
                                                  </fieldset>
                                                  {canViewFreightCoordinates && (
                                                    <div className="row">
                                                      <div className="col-md-3 mb-4">
                                                        <div
                                                          className="d-flex align-items-center"
                                                          style={{ height: "0px" }}
                                                        >
                                                          <label
                                                            htmlFor="Geoposição"
                                                            className="font-test "
                                                          >
                                                            Informar Geolocalização
                                                          </label>

                                                          <Checkbox
                                                            id={`geoposicao-${index}`}
                                                            checked={
                                                              !!form.manualCoordinatesEnabled
                                                            }
                                                            onChange={(
                                                              event,
                                                              isChecked,
                                                            ) => {
                                                              const syntheticEvent = {
                                                                target: {
                                                                  name: "manualCoordinatesEnabled",
                                                                  type: "checkbox",
                                                                  checked: isChecked,
                                                                  value: isChecked,
                                                                },
                                                              };
                                                              // Chame a handleFormChange com o evento simulado e o índice
                                                              handleFormChange(
                                                                syntheticEvent,
                                                                indiceReal,
                                                              );
                                                            }}
                                                          />
                                                        </div>
                                                      </div>

                                                      <div className="col-md-3 mb-4">
                                                        <div
                                                          className="d-flex align-items-center"
                                                          style={{ height: "0px" }}
                                                        >
                                                          {" "}
                                                          <a
                                                            style={{ cursor: "pointer" }}
                                                            href={`https://www.google.com/maps/search/?api=1&query=${form.latitude},${form.longitude}`}
                                                            target="_blank"
                                                            rel="noreferrer noopener"
                                                          >
                                                            <label
                                                              style={{
                                                                cursor: "pointer",
                                                              }}
                                                              className="font-test mb-0"
                                                            >
                                                              Visualizar no Mapa
                                                            </label>
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}

                                                  <fieldset
                                                    // disabled={stopReadOnly}
                                                    style={{
                                                      border: 0,
                                                      margin: 0,
                                                      minWidth: 0,
                                                      padding: 0,
                                                    }}
                                                  >
                                                    {/* ===================================================================== */}
                                                    {showCargaDocuments && (
                                                      <div className="col-md-12 mb-3">
                                                        <label className="font-test">
                                                          NF-s Importadas
                                                        </label>
                                                        <div
                                                          style={{
                                                            border: `1px solid ${COLORS.line}`,
                                                            borderRadius: 10,
                                                            background: "#ffffff",
                                                            padding: "10px 12px",
                                                            boxShadow: SOFT_SHADOW,
                                                          }}
                                                        >
                                                          <InvoiceList
                                                            items={stoppingPointDocuments}
                                                            title={`NF-s Importadas - ${stopLabel}`}
                                                            subtitle={null}
                                                            hintText={null}
                                                            showActions={false}
                                                            emptyText="Nenhum documento para exibir."
                                                            getItemKey={(
                                                              documentItem,
                                                              docIndex,
                                                            ) =>
                                                              `${form.id || form.number_collect || indiceReal}-document-${docIndex}`
                                                            }
                                                            renderItem={(
                                                              documentItem,
                                                              docIndex,
                                                            ) => {
                                                              const {
                                                                label: docTypeLabel,
                                                                value: docDisplayValue,
                                                                url: docUrl,
                                                              } = formatStopDocument(
                                                                documentItem,
                                                                docIndex,
                                                              );

                                                              return (
                                                                <div
                                                                  style={{
                                                                    alignItems: "center",
                                                                    display: "flex",
                                                                    flexWrap: "wrap",
                                                                    gap: 8,
                                                                    whiteSpace: "nowrap",
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      background:
                                                                        "rgba(1,36,66,0.1)",
                                                                      borderRadius: 999,
                                                                      border:
                                                                        "1px solid rgba(1,36,66,0.2)",
                                                                      color: "#012442",
                                                                      fontSize: 12,
                                                                      fontWeight: 400,
                                                                      padding: "2px 8px",
                                                                    }}
                                                                  >
                                                                    {docTypeLabel}
                                                                  </span>
                                                                  <span
                                                                    style={{
                                                                      fontFamily:
                                                                        "monospace",
                                                                      color: "#012442",
                                                                      fontWeight: 400,
                                                                    }}
                                                                  >
                                                                    {docUrl ? (
                                                                      <a
                                                                        href={docUrl}
                                                                        target="_blank"
                                                                        rel="noreferrer noopener"
                                                                        style={{
                                                                          color:
                                                                            "#012442",
                                                                          textDecoration:
                                                                            "underline",
                                                                        }}
                                                                      >
                                                                        {docDisplayValue}
                                                                      </a>
                                                                    ) : (
                                                                      docDisplayValue ||
                                                                      "-"
                                                                    )}
                                                                  </span>
                                                                </div>
                                                              );
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    )}
                                                    <div className="row">
                                                      <div className="col-md-12 mb-2">
                                                        <label
                                                          htmlFor="observation"
                                                          className="font-test"
                                                        >
                                                          Observação
                                                        </label>
                                                        <TextArea
                                                          disabled={stopReadOnly}
                                                          name="observation"
                                                          value={
                                                            form.observation &&
                                                            form.observation
                                                          }
                                                          // disabled={form.concluded && isCopy !== "true"}
                                                          onChange={(event) =>
                                                            handleFormChange(
                                                              event,
                                                              indiceReal,
                                                            )
                                                          }
                                                        />
                                                      </div>

                                                      <div className="row justify-content-between align-items-center gx-3 ">
                                                        <>
                                                          {id ? (
                                                            <div className="d-flex align-items-center flex-wrap gap-2">
                                                              {/* <span
                                                        className="font-test gap-2"
                                                        style={{
                                                          color: COLORS.danger,
                                                          fontWeight: 400,
                                                        }}
                                                      >
                                                        Ainda não há comprovante
                                                        de entrega
                                                      </span> */}
                                                              <Button
                                                                // disabled={view}
                                                                variant="outlined"
                                                                sx={{
                                                                  fontSize: 16,
                                                                  borderColor:
                                                                    "rgba(1,36,66,0.3)",
                                                                  color: COLORS.ink,
                                                                  fontWeight:
                                                                    theme.typography
                                                                      .weightSemibold,
                                                                  // textTransform: "none",
                                                                  boxShadow:
                                                                    theme.elevation.base,
                                                                  "&:hover": {
                                                                    borderColor:
                                                                      COLORS.danger,
                                                                    color: COLORS.danger,
                                                                    background:
                                                                      "rgba(255,49,0,0.05)",
                                                                  },
                                                                }}
                                                                onClick={(e) => {
                                                                  setReferenc(null);
                                                                  handleClickOpen(
                                                                    form.id,
                                                                    form.operation[0],
                                                                  );
                                                                  setOrigem("Canhoto");
                                                                }}
                                                              >
                                                                <UploadFileIcon
                                                                  sx={{
                                                                    mr: 1,
                                                                    color:
                                                                      theme.colors
                                                                        .highlight,
                                                                  }}
                                                                />
                                                                {getStopImportButtonLabel(
                                                                  form.operation,
                                                                )}
                                                              </Button>
                                                              {/* // ========================================= */}

                                                              {form.operation[0] ===
                                                                "carga" &&
                                                                form.invoices.length ==
                                                                0 && (
                                                                  <Button
                                                                    disabled={
                                                                      view ||
                                                                      isCarrierManagedFreight
                                                                    }
                                                                    variant="outlined"
                                                                    sx={{
                                                                      backgroundColor:
                                                                        theme.colors
                                                                          .primary,
                                                                      color:
                                                                        theme.colors
                                                                          .surface,
                                                                      fontWeight:
                                                                        theme.typography
                                                                          .weightSemibold,
                                                                      "&:hover": {
                                                                        borderColor:
                                                                          COLORS.danger,
                                                                        color:
                                                                          COLORS.danger,
                                                                        background:
                                                                          "rgba(255,49,0,0.05)",
                                                                      },
                                                                      boxShadow:
                                                                        theme.elevation
                                                                          .base,
                                                                      fontSize: 16,
                                                                    }}
                                                                    onClick={(e) => {
                                                                      setReferenc(null);
                                                                      handleOpenUploadInvoices(
                                                                        form.id,
                                                                        form.operation[0],
                                                                        indiceReal,
                                                                      );
                                                                    }}
                                                                  >
                                                                    <ReceiptIcon
                                                                      sx={{
                                                                        mr: 1,
                                                                        color:
                                                                          theme.colors
                                                                            .highlight,
                                                                      }}
                                                                    />
                                                                    Importar NF-s
                                                                  </Button>
                                                                )}
                                                            </div>
                                                          ) : (
                                                            // <label>"" </label>
                                                            ""
                                                          )}
                                                        </>

                                                        <>
                                                          {hasCanhoto && (
                                                            <div className="mb-2">
                                                              <label className="font-test">
                                                                {stopCanhotos.length > 1
                                                                  ? "Canhotos"
                                                                  : "Canhoto"}
                                                              </label>
                                                              <GalleryDialog
                                                                code={code}
                                                                data={stopCanhotos}
                                                                disabled={!stopReadOnly}
                                                                onDelete={(item) =>
                                                                  handleDeleteStopDocument(
                                                                    {
                                                                      kind: "canhoto",
                                                                      stopId: form.id,
                                                                      stopIndex:
                                                                        indiceReal,
                                                                      file: item,
                                                                    },
                                                                  )
                                                                }
                                                              />
                                                            </div>
                                                          )}

                                                          {hasAttachments && (
                                                            <div>
                                                              <label className="font-test">
                                                                Anexos
                                                              </label>
                                                              <GalleryDialog
                                                                code={code}
                                                                data={stopAttachments}
                                                                disabled={!stopReadOnly}
                                                                onDelete={(item) =>
                                                                  handleDeleteStopDocument(
                                                                    {
                                                                      kind: "attachment",
                                                                      stopId: form.id,
                                                                      stopIndex:
                                                                        indiceReal,
                                                                      file: item,
                                                                    },
                                                                  )
                                                                }
                                                              />
                                                            </div>
                                                          )}
                                                        </>
                                                      </div>
                                                    </div>
                                                  </fieldset>
                                                </Spin>
                                              </div>
                                            </Box>
                                          </Card>
                                        </Box>
                                      )}
                                    </Draggable>
                                  );
                                })}

                                {droppableProvided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                        <div className="row">
                          <div className="col-8"></div>
                          <div className="col-4">
                            <Button
                              variant="contained"
                              disabled={view || isCarrierManagedFreight}
                              onClick={addFields}
                              style={{
                                backgroundColor: "#012442",
                                borderRadius: 12,
                                padding: "10px 14px",
                                fontWeight: 600,
                                textTransform: "none",
                                boxShadow: SOFT_SHADOW,
                              }}
                            >
                              <AddIcon style={{ color: COLORS.danger }} />
                              &nbsp;Adicionar ponto de parada
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Produto */}
                    {(canViewFreightSection || cargoStops.length > 0) && (
                      <Card
                        sx={{ padding: 2 }}
                        className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                        style={{
                          background: "#ffffff",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                          borderRadius: "16px",
                        }}
                      >
                        <h4
                          className="mb-3"
                          style={{
                            alignItems: "center",
                            color: COLORS.ink,
                            display: "flex",
                            fontWeight: 700,
                            gap: "8px",
                            margin: 0,
                          }}
                        >
                          <Box sx={cardIconSx}>
                            <InventoryIcon
                              fontSize="medium"
                              style={{ color: COLORS.white }}
                            />
                          </Box>{" "}
                          Produto
                        </h4>

                        {canViewFreightSection && (
                          <div className="row justify-content-start align-items-center gx-3">
                            <div className="col-md-2 mb-4">
                              <label htmlFor="weightUnit" className="font-test">
                                Unidade de medida
                              </label>
                              <select
                                disabled={vehicleDisabled}
                                className="form-select"
                                id="weightUnit"
                                value={weightUnit}
                                onChange={handleChangeWeightUnit}
                                style={{ borderRadius: "10px" }}
                              >
                                {WEIGHT_UNIT_OPTIONS.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}

                        {canViewFreightSection &&
                          !hasPerStopCargoFreightFields(formFields) && (
                            <div className="row justify-content-start align-items-center gx-3">
                              <div className="col-md-2 mb-4">
                                <label
                                  htmlFor="weightCargo"
                                  className="font-test"
                                  style={
                                    hasWeightCalculationError
                                      ? {
                                        color: COLORS.danger,
                                      }
                                      : undefined
                                  }
                                >
                                  {getWeightLabel("Peso da Carga", weightUnit)}
                                  <RequiredMark
                                    show={isFreightFieldRequired("weightCargo")}
                                  />
                                </label>
                                <IntlCurrencyInput
                                  style={{
                                    borderRadius: "10px",
                                    border: hasWeightCalculationError
                                      ? "1px solid red"
                                      : "1px solid #ced4da",
                                    fontWeight: hasWeightCalculationError ? "bold" : "normal",
                                    color: hasWeightCalculationError ? COLORS.danger : ''

                                  }}
                                  disabled={vehicleDisabled}
                                  currency="BRL"
                                  config={weightConfig}
                                  placeholder="00.00"
                                  onChange={handleChangeWeightCargo}
                                  value={toDisplayNumeric(weightCargo, 0)}
                                  className="form-control"
                                  id="weightCargo"
                                  maxLength={10}
                                />
                              </div>

                              <div className="col-md-2 mb-4">
                                <label htmlFor="valueNF" className="font-test" style={
                                  hasValueNFCalculationError
                                    ? {
                                      color: COLORS.danger,
                                    }
                                    : undefined
                                }>
                                  Valor NF
                                  <RequiredMark
                                    show={isFreightFieldRequired("valueNF")}
                                  />
                                </label>
                                <IntlCurrencyInput
                                  disabled={vehicleDisabled}
                                  currency="BRL"
                                  config={currencyConfig}
                                  placeholder="00.00"
                                  onChange={handleChangeValueNF}
                                  value={toDisplayNumeric(valueNF, "")}
                                  className="form-control"
                                  id="valueNF"
                                  maxLength={15}
                                  style={{
                                    borderRadius: "10px",
                                    border: hasValueNFCalculationError
                                      ? "1px solid red"
                                      : "1px solid #ced4da",
                                    fontWeight: hasValueNFCalculationError ? "bold" : "normal",
                                    color: hasValueNFCalculationError ? COLORS.danger : ''
                                  }}
                                />
                              </div>

                              <div className="col-md-2 mb-4">
                                <ReadonlyField
                                  id="valueFreightage"
                                  label="Valor do Frete"
                                  value={toDisplayNumeric(valueFreightage, "")}
                                  config={currencyConfig}
                                  currency="BRL"
                                  className=""
                                  required={isFreightFieldRequired(
                                    "valueFreightage",
                                  )}
                                />
                                {isFreightValueBelowProductsTotal(
                                  valueFreightage,
                                  product,
                                ) && (
                                    <small className="text-danger">
                                      O valor do frete esta menor que o valor
                                      total dos produtos.
                                    </small>
                                  )}
                              </div>
                            </div>
                          )}

                        {cargoStops.length > 0 && (
                          <div>
                            {cargoStops.map(({ form, index }) => {
                              const stopLabel = `Parada ${form.stop_order || index + 1}`;
                              const isCargoStopRequired = (fieldName) =>
                                isStopFieldRequired(fieldName, form, {
                                  ...stopFieldContext,
                                  index,
                                });

                              return (
                                <div
                                  className="row justify-content-start align-items-center gx-3"
                                  key={`product-${form.id || form.number_collect || index}`}
                                >
                                  <div className="col-md-2 mb-4">
                                    <label className="font-test">
                                      Ponto de Carga
                                    </label>
                                    <div>
                                      <Chip
                                        size="small"
                                        label={stopLabel}
                                        sx={{
                                          background: "#ffffff",
                                          border: `1px solid ${COLORS.line}`,
                                          color: COLORS.ink,
                                          fontWeight: 600,
                                          boxShadow: SOFT_SHADOW,
                                        }}
                                      />
                                    </div>
                                  </div>

                                  {canViewFreightSection && (
                                    <>
                                      <div className="col-md-2 mb-4">
                                        <label
                                          htmlFor={`weight-cargo-stop-${index}`}
                                          className="font-test"
                                        >
                                          {getWeightLabel(
                                            "Peso da Carga",
                                            weightUnit,
                                          )}
                                          <RequiredMark
                                            show={isCargoStopRequired(
                                              "cargo_weight_kg",
                                            )}
                                          />
                                        </label>
                                        <IntlCurrencyInput
                                          style={{ borderRadius: "10px" }}
                                          disabled={vehicleDisabled}
                                          currency="BRL"
                                          config={weightConfig}
                                          placeholder="00.00"
                                          onChange={(event, value) => {
                                            event.preventDefault();
                                            handleCargoProductChange(
                                              index,
                                              "cargo_weight_kg",
                                              value,
                                            );
                                          }}
                                          value={
                                            form.cargo_weight_kg !==
                                              undefined &&
                                              form.cargo_weight_kg !== null &&
                                              form.cargo_weight_kg !== ""
                                              ? form.cargo_weight_kg
                                              : 0
                                          }
                                          className="form-control"
                                          id={`weight-cargo-stop-${index}`}
                                          maxLength={10}
                                        />
                                      </div>
                                      <div className="col-md-2 mb-4">
                                        <label
                                          htmlFor={`value-nf-stop-${index}`}
                                          className="font-test"
                                        >
                                          Valor NF
                                          <RequiredMark
                                            show={isCargoStopRequired(
                                              "cargo_value_nf",
                                            )}
                                          />
                                        </label>
                                        <IntlCurrencyInput
                                          disabled={vehicleDisabled}
                                          currency="BRL"
                                          config={currencyConfig}
                                          placeholder="00.00"
                                          onChange={(event, value) => {
                                            event.preventDefault();
                                            handleCargoProductChange(
                                              index,
                                              "cargo_value_nf",
                                              value,
                                            );
                                          }}
                                          value={
                                            form.cargo_value_nf !== undefined &&
                                              form.cargo_value_nf !== null &&
                                              form.cargo_value_nf !== ""
                                              ? form.cargo_value_nf
                                              : ""
                                          }
                                          className="form-control"
                                          id={`value-nf-stop-${index}`}
                                          maxLength={15}
                                          style={{ borderRadius: "10px" }}
                                        />
                                      </div>
                                    </>
                                  )}

                                  <div
                                    className={`mb-4 ${canViewFreightSection
                                      ? "col-md-2"
                                      : "col-md-3"
                                      }`}
                                  >
                                    <label
                                      htmlFor={`type-${index}`}
                                      className="font-test"
                                    >
                                      Tipo de Mercadoria
                                      <RequiredMark
                                        show={isCargoStopRequired("type")}
                                      />
                                    </label>
                                    <select
                                      disabled={view || isCarrierManagedFreight}
                                      className="form-select"
                                      id={`type-${index}`}
                                      onChange={(e) =>
                                        handleCargoProductChange(
                                          index,
                                          "type",
                                          e.target.value || "",
                                        )
                                      }
                                      value={form.type || ""}
                                      aria-label=""
                                    >
                                      <option value="">Selecione</option>
                                      {MERCHANDISE_TYPE_OPTIONS.map(
                                        (option) => (
                                          <option
                                            key={option.value}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </div>

                                  <div
                                    className={`mb-4 ${canViewFreightSection
                                      ? "col-md-4"
                                      : "col-md-5"
                                      }`}
                                  >
                                    <label
                                      htmlFor={`descricao-${index}`}
                                      className="font-test"
                                    >
                                      Descrição de Mercadoria
                                      <RequiredMark
                                        show={isCargoStopRequired("descricao")}
                                      />
                                    </label>
                                    <input
                                      disabled={view || isCarrierManagedFreight}
                                      type="text"
                                      name="descricao"
                                      className="form-control"
                                      id={`descricao-${index}`}
                                      value={form.descricao || ""}
                                      onChange={(e) =>
                                        handleCargoProductChange(
                                          index,
                                          "descricao",
                                          e.target.value || "",
                                        )
                                      }
                                      placeholder="Descrição da mercadoria"
                                      style={{ borderRadius: "10px" }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                            {canViewFreightSection &&
                              cargoStops.length > 0 &&
                              hasPerStopCargoFreightFields(formFields) && (
                                <div className="row justify-content-start align-items-end gx-3 mt-1">
                                  <div className="col-md-2 mb-4">
                                    <ReadonlyField
                                      id="weightCargoTotal"
                                      label={getWeightLabel(
                                        "Peso total",
                                        weightUnit,
                                      )}
                                      value={sumCargoStopsNumber(
                                        formFields,
                                        "cargo_weight_kg",
                                      )}
                                      config={weightConfig}
                                      currency="BRL"
                                      className=""
                                      required={isFreightFieldRequired(
                                        "valueFreightage",
                                      )}
                                    />
                                  </div>

                                  <ReadonlyField
                                    id="valueNFTotal"
                                    label="Valor NF total"
                                    value={sumCargoStopsNumber(
                                      formFields,
                                      "cargo_value_nf",
                                    )}
                                    config={currencyConfig}
                                    isInvalidstyle={hasValueNFCalculationError}

                                  />

                                  <div className="col-md-2 mb-4">
                                    <ReadonlyField
                                      id="valueFreightage"
                                      label="Valor do Frete"
                                      value={toDisplayNumeric(
                                        valueFreightage,
                                        "",
                                      )}
                                      config={currencyConfig}
                                      currency="BRL"
                                      className=""
                                    />
                                    {isFreightValueBelowProductsTotal(
                                      valueFreightage,
                                      product,
                                    ) && (
                                        <small className="text-danger">
                                          O valor do frete esta menor que o valor
                                          total dos produtos.
                                        </small>
                                      )}
                                  </div>
                                </div>
                              )}
                          </div>
                        )}
                      </Card>
                    )}

                    {/* Veículo */}
                    <Card
                      sx={{ padding: 2 }}
                      className="freight-vehicle-card form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                      style={{
                        ...freightVehicleThemeVars,
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                        width: "100%",
                      }}
                    >
                      <h4
                        className="mb-3"
                        style={{
                          alignItems: "center",
                          color: COLORS.ink,
                          display: "flex",
                          fontWeight: 700,
                          gap: "8px",
                          margin: 0,
                        }}
                      >
                        <Box sx={cardIconSx}>
                          <LocalShippingIcon
                            fontSize="medium"
                            style={{ color: COLORS.white }}
                          />
                        </Box>
                        Veículo
                      </h4>

                      <div className="freight-vehicle-choice-grid">
                        <section className="freight-vehicle-choice-panel">
                          <strong>
                            <label
                              htmlFor="vehicle-label"
                              className="freight-vehicle-choice-label"
                            >
                              <Chip
                                label="Tipo de Veículo"
                                sx={{
                                  backgroundColor:
                                    "var(--freight-vehicle-primary)",
                                  color: "white",
                                  fontWeight: "bold",
                                  border:
                                    "1px solid var(--freight-vehicle-highlight)",
                                  minWidth: 150,
                                  height: 35,
                                  whiteSpace: "normal",
                                  justifyContent: "center",
                                  borderRadius:
                                    "var(--freight-vehicle-radius-md)",

                                  "& .MuiChip-label": {
                                    fontSize: "0.9rem",
                                    paddingLeft: "8px",
                                    paddingRight: "8px",
                                    textAlign: "center",
                                  },
                                }}
                              />
                              <RequiredMark
                                show={isFreightFieldRequired("vehicle")}
                              />
                            </label>
                          </strong>

                          <div className="freight-vehicle-options-grid">
                            {renderCategories()}
                          </div>
                        </section>

                        <section className="freight-vehicle-choice-panel">
                          <strong>
                            <label
                              htmlFor="bodywork-label"
                              className="freight-vehicle-choice-label"
                            >
                              <Chip
                                label="Tipo de Carroceria"
                                sx={{
                                  backgroundColor:
                                    "var(--freight-vehicle-primary)",
                                  color: "white",
                                  fontWeight: "bold",
                                  border:
                                    "1px solid var(--freight-vehicle-highlight)",
                                  minWidth: 170,
                                  height: 35,
                                  whiteSpace: "normal",
                                  justifyContent: "center",
                                  borderRadius:
                                    "var(--freight-vehicle-radius-md)",

                                  "& .MuiChip-label": {
                                    fontSize: "0.9rem",
                                    paddingLeft: "8px",
                                    paddingRight: "8px",
                                    textAlign: "center",
                                  },
                                }}
                              />
                              <RequiredMark
                                show={isFreightFieldRequired("bodywork")}
                              />
                            </label>
                          </strong>

                          <div className="freight-vehicle-options-grid">
                            {renderCategoriesBodyWork()}
                          </div>
                        </section>
                      </div>

                      <div className="freight-vehicle-control-grid">
                        <div className="freight-vehicle-control-item freight-vehicle-control-item--action">
                          {code < 5 && (<TotalGeneralButton
                            htmlType="button"
                            className="freight-vehicle-calculate-button"
                            onClick={handleCalculateFreight}
                            disabled={vehicleDisabled}
                          >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Typography
                                variant="subtitle1"
                                sx={{
                                  color: "inherit",
                                  fontWeight: "bold",
                                  lineHeight: 1.2,
                                }}
                              >
                                Calcular Frete
                              </Typography>
                            </Box>
                          </TotalGeneralButton>)}
                        </div>

                        <div className="freight-vehicle-control-item">
                          <label
                            htmlFor="axles"
                            className="freight-vehicle-control-label"
                            style={
                              hasAxlesCalculationError
                                ? {
                                  color: COLORS.danger,
                                }
                                : undefined
                            }
                          >
                            Quantidade de eixos
                            <RequiredMark
                              show={isFreightFieldRequired("axles")}
                            />
                          </label>

                          <select
                            id="axles"
                            disabled={vehicleDisabled}
                            className="form-select freight-vehicle-occupation-select"
                            onChange={(e) => setAxles(e.target.value)}
                            value={axles || ""}
                            style={
                              hasAxlesCalculationError
                                ? {
                                  borderColor: COLORS.danger,
                                  color: COLORS.danger,
                                  fontWeight: 700,
                                }
                                : undefined
                            }
                          >
                            <option value="">Selecione</option>
                            {axleSelectOptions.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Campo Ocupação */}
                        <div className="freight-vehicle-control-item">
                          <label
                            htmlFor="occupation"
                            className="freight-vehicle-control-label"
                          >
                            Ocupação
                            <RequiredMark
                              show={isFreightFieldRequired("occupation")}
                            />
                          </label>

                          <select
                            disabled={vehicleDisabled}
                            className="form-select freight-vehicle-occupation-select"
                            onChange={(e) => setOccupation(e.target.value)}
                            value={occupation || ""}
                          >
                            <option value="">Selecione</option>
                            <option value="Fracionado">Fracionado</option>
                            <option value="Dedicado">Dedicado</option>
                          </select>
                        </div>

                        {/* Campo Livre de Carga e Descarga */}
                        <div className="freight-vehicle-control-item freight-vehicle-control-item--center">
                          <div className="free-charge-wrapper">
                            <label
                              htmlFor="freeOfCharge"
                              className="free-charge-title"
                            >
                              Livre de Carga e Descarga
                              <RequiredMark
                                show={isFreightFieldRequired("freeOfCharge")}
                              />
                            </label>

                            <div className="free-charge-group">
                              <input
                                disabled={vehicleDisabled}
                                type="radio"
                                onChange={(e) =>
                                  setFreeOfCharge(e.target.value)
                                }
                                checked={freeOfCharge === "SIM"}
                                value="SIM"
                                className="free-charge-radio"
                                name="freeOfCharge"
                                id="btnFreeYes"
                                autoComplete="off"
                              />
                              <label
                                htmlFor="btnFreeYes"
                                className="free-charge-btn free-charge-yes"
                              >
                                SIM
                              </label>

                              <input
                                disabled={vehicleDisabled}
                                type="radio"
                                onChange={(e) =>
                                  setFreeOfCharge(e.target.value)
                                }
                                checked={freeOfCharge === "NAO"}
                                value="NAO"
                                className="free-charge-radio"
                                name="freeOfCharge"
                                id="btnFreeNo"
                                autoComplete="off"
                              />
                              <label
                                htmlFor="btnFreeNo"
                                className="free-charge-btn free-charge-no"
                              >
                                NÃO
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>

                    {/* Precificação */}
                    {user?.permissoes?.freightPricing?.isView && (
                        <Card
                          sx={{ padding: 2, paddingLeft: 0 }}
                          className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#344d66] rounded-lg p-3 "
                          style={{
                            background: "#ffffff",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                            borderRadius: "16px",
                          }}
                        >
                          <h4
                            className="mb-3"
                            style={{
                              alignItems: "center",
                              color: COLORS.ink,
                              display: "flex",
                              fontWeight: 700,
                              gap: "8px",
                              margin: 0,
                            }}
                          >
                            <Box sx={cardIconSx}>
                              <InventoryIcon
                                fontSize="medium"
                                style={{ color: COLORS.white }}
                              />
                            </Box>
                            {/* <InventoryIcon style={{ color: COLORS.danger }} />{" "} */}
                            Precificação
                          </h4>
                          <div>
                            <ProductTable
                              product={product}
                              onChange={handleProductsChange}
                              disabled={view}
                              lockLoadedRows={pricingCalculated}
                              suggestPriceDisabled={
                                view || isCarrierManagedFreight
                              }
                              unitPricePrecision={2}
                              generalTotalOverride={
                                fromSimulation ? valueFreightage : undefined
                              }
                              calculateGrossFreightProposedByShipper={
                                calculateGrossFreightProposedByShipper
                              }
                              code={code}
                              weightUnit={weightUnit}
                              weightCargo={weightCargo}
                            />
                          </div>
                        </Card>
                      )}

                    <>
                      <FreightDriverNegotiationCard
                        view={view}
                        user={user}
                        verifyPayment={verifyPayment}
                        valueDriverInitial={valueDriverInitial}
                        valueDriverFinal={valueDriverFinal}
                        valueNegotiated={valueNegotiated}
                        paymentCondition={paymentCondition}
                        driverChose={driverChose}
                        driversInFila={driversInFila}
                        uidDriver={uidDriver}
                        transportOptions={transportOptions}
                        transportValue={selectedTransportOption}
                        onTransportSelect={handleTransportSelect}
                        getTransportOptionLabel={getShipperOptionLabel}
                        filterTransportOptions={filterShipperByDisplayName}
                        requireTransport={
                          isViewAllUser && Boolean(uidDriver)
                        }
                        transportDisabled={
                          view || isCarrierManagedFreight || isViewAllUser
                        }
                        formatName={formatName}
                        onDriverInitialChange={handleChangeInitial}
                        onDriverFinalChange={handleChangeFinal}
                        onNegotiatedChange={handleChangeValueNegotiated}
                        onPaymentConditionChange={handleChangePaymentCondition}
                        onDriverSelect={handleDriver}
                        hideSuggestedAndAnnouncedValues={
                          hideDriverNegotiationForOwnership
                        }
                        hideNegotiatedAndPaymentCondition={
                          hideDriverNegotiationForOwnership
                        }
                        requireValueDriverInitial={
                          !isCarrierManagedFreight &&
                          !hideDriverNegotiationForOwnership &&
                          isFreightFieldRequired("valueDriverInitial")
                        }
                        requireValueDriverFinal={
                          !isCarrierManagedFreight &&
                          !hideDriverNegotiationForOwnership &&
                          isFreightFieldRequired("valueDriverFinal")
                        }
                        requireValueNegotiated={
                          !hideDriverNegotiationForOwnership &&
                          isFreightFieldRequired("valueNegotiated")
                        }
                        requirePaymentCondition={
                          !hideDriverNegotiationForOwnership &&
                          isFreightFieldRequired("paymentCondition")
                        }
                        priceANTT={priceANTT}
                      />
                    </>
                    {/* )} */}

                    {/* Grupos do embarcador (ordem drag-and-drop; groupOrder em shipper e frete) */}
                    {shipperGroups.length > 1 && (
                      <Card
                        sx={{ padding: 2, paddingLeft: 0 }}
                        className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#344d66] rounded-lg p-3 "
                        style={{
                          background: "#ffffff",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                          borderRadius: "16px",
                        }}
                      >
                        <h4
                          className="mb-3"
                          style={{
                            alignItems: "center",
                            color: COLORS.ink,
                            display: "flex",
                            fontWeight: 700,
                            gap: "8px",
                            margin: 0,
                          }}
                        >
                          <Box sx={cardIconSx}>
                            <GroupsIcon
                              fontSize="medium"
                              style={{ color: COLORS.white }}
                            />
                          </Box>
                          Grupos
                        </h4>

                        <div
                          className="row justify-content-between align-items-start gx-3"
                          style={{ marginLeft: "-15px" }}
                        >
                          <div className="col-12">
                            {shipperGroups.length === 0 ? (
                              <small className="text-muted">
                                Nenhum grupo disponível para este embarcador.
                              </small>
                            ) : (
                              <>
                                <DragDropContext
                                  onDragEnd={handleDragEndGroups}
                                >
                                  <Droppable droppableId="groups">
                                    {(provided) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                      >
                                        {shipperGroups.map((group, index) => (
                                          <Draggable
                                            key={group.idGroup}
                                            draggableId={group.idGroup}
                                            index={index}
                                            isDragDisabled={view}
                                          >
                                            {(provided) => (
                                              <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className="d-flex justify-content-between align-items-center mb-2"
                                                style={{
                                                  width: 300,
                                                  minHeight: 56,
                                                  padding: "12px 14px",
                                                  borderRadius: "12px",
                                                  background:
                                                    index === 0
                                                      ? "rgba(255,49,0,0.08)"
                                                      : "#FFFFFF",
                                                  border:
                                                    index === 0
                                                      ? "1px solid rgba(255,49,0,0.30)"
                                                      : "1px solid rgba(1,36,66,0.10)",
                                                  boxShadow:
                                                    "0px 3px 3px rgba(0,14,51,0.10), 0px 1px 2px rgba(0,14,51,0.08)",
                                                  cursor: view
                                                    ? "not-allowed"
                                                    : "grab",
                                                  transition: "all 0.2s ease",
                                                  ...provided.draggableProps
                                                    .style,
                                                }}
                                              >
                                                <div
                                                  className="d-flex align-items-center gap-2"
                                                  style={{ minWidth: 0 }}
                                                >
                                                  <span
                                                    style={{
                                                      minWidth: 28,
                                                      width: 28,
                                                      height: 28,
                                                      borderRadius: "999px",
                                                      background:
                                                        index === 0
                                                          ? "#FF3100"
                                                          : "#012442",
                                                      color: "#F9FAFB",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      fontWeight: 600,
                                                      fontSize: 12,
                                                      boxShadow:
                                                        "0px 3px 3px rgba(0,14,51,0.18), 0px 1px 2px rgba(0,14,51,0.12)",
                                                      flexShrink: 0,
                                                    }}
                                                  >
                                                    {index + 1}
                                                  </span>

                                                  <span
                                                    style={{
                                                      whiteSpace: "nowrap",
                                                      overflow: "hidden",
                                                      textOverflow: "ellipsis",
                                                      maxWidth: 260,
                                                      color: "#012442",
                                                      fontWeight: 400,
                                                      fontSize: "14px",
                                                      lineHeight: 1.4,
                                                    }}
                                                    title={getGroupName(group)}
                                                  >
                                                    {getGroupName(group)}
                                                  </span>
                                                </div>
                                              </div>
                                            )}
                                          </Draggable>
                                        ))}

                                        {provided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                </DragDropContext>
                              </>
                            )}
                          </div>
                        </div>
                      </Card>
                    )}

                    {/* FRETE */}
                    {user?.permissoes?.freightFreight?.isView && (
                      <Card
                        sx={{ padding: 2 }}
                        className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                        style={{
                          background: "#ffffff",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                          borderRadius: "16px",
                        }}
                      >
                        <h4
                          className="mb-3"
                          style={{
                            alignItems: "center",
                            color: COLORS.ink,
                            display: "flex",
                            fontWeight: 700,
                            gap: "8px",
                            margin: 0,
                          }}
                        >
                          {" "}
                          <Box sx={cardIconSx}>
                            <FireTruckOutlinedIcon
                              fontSize="medium"
                              style={{ color: COLORS.white }}
                            />
                          </Box>{" "}
                          Frete
                        </h4>

                        <div className="row align-items-center gx-3">
                          <div className="col-3">
                            <label htmlFor="seller" className="font-test">
                              Vendedor
                              <RequiredMark
                                show={isFreightFieldRequired("seller")}
                              />
                            </label>

                            <Autocomplete
                              sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "10px",
                                },
                              }}
                              disabled={view}
                              id="seller-select"
                              size="small"
                              options={sellersList.filter(
                                (seller) => seller.isSeller === true,
                              )}
                              getOptionLabel={(option) =>
                                typeof option === "string"
                                  ? option
                                  : formatName(option.name)
                              }
                              value={
                                sellersList.find(
                                  (s) => sellerId && s.id === sellerId,
                                ) ||
                                sellersList.find((s) => s.name === seller) ||
                                seller ||
                                null
                              }
                              onChange={(event, newValue) => {
                                if (!newValue) {
                                  setSeller("");
                                  setSellerId("");
                                  return;
                                }
                                if (typeof newValue === "string") {
                                  setSeller(newValue);
                                  return;
                                }
                                setSeller(newValue.name || "");
                                setSellerId(newValue.id || "");
                              }}
                              onInputChange={(event, newInputValue, reason) => {
                                if (reason === "reset") return;
                                setSeller(newInputValue);
                                if (!newInputValue) {
                                  setSellerId("");
                                }
                              }}
                              freeSolo
                              noOptionsText="Nenhum vendedor encontrado"
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label=""
                                  placeholder="Selecione o vendedor"
                                  id="seller"
                                />
                              )}
                              isOptionEqualToValue={(option, value) =>
                                Boolean(option?.id && value?.id)
                                  ? option.id === value.id
                                  : option?.name === value?.name
                              }
                              forcePopupIcon={true}
                              popupIcon={<KeyboardArrowDownIcon />}
                            />
                          </div>

                          <div className="col-3">
                            <label htmlFor="operational" className="font-test">
                              Operacional
                            </label>
                            <input
                              style={{
                                borderRadius: "10px",
                              }}
                              disabled={true}
                              type="text"
                              onChange={(e) => setOperational(e.target.value)}
                              value={operational && operational}
                              className="form-control"
                              id="operational"
                              placeholder=""
                            />
                          </div>

                          <div className="col-2">
                            <label
                              htmlFor="phoneRespContractFreigtage"
                              className="font-test"
                            >
                              Resp. contratação frete
                            </label>
                            <InputMask
                              style={{
                                borderRadius: "10px",
                              }}
                              disabled={view}
                              mask="(99) 99999-9999"
                              className="form-control"
                              onChange={(e) =>
                                setPhoneRespContractFreigtage(e.target.value)
                              }
                              value={
                                phoneRespContractFreigtage &&
                                phoneRespContractFreigtage
                              }
                              placeholder="(99) 99999-9999"
                            />
                          </div>
                        </div>
                      </Card>
                    )}

                    {/* Dados da entrega */}
                    <Card
                      sx={{ padding: 2 }}
                      className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                      }}
                    >
                      <div className="form-signin mx-auto">
                        <div className="col-12">
                          <h4
                            className="mb-3"
                            style={{
                              alignItems: "center",
                              color: COLORS.ink,
                              display: "flex",
                              fontWeight: 700,
                              gap: "8px",
                              margin: 0,
                            }}
                          >
                            {" "}
                            <Box sx={cardIconSx}>
                              <StorageOutlinedIcon
                                fontSize="medium"
                                style={{ color: COLORS.white }}
                              />
                            </Box>{" "}
                            Dados da entrega
                          </h4>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <label htmlFor="observation" className="font-test">
                              Observações Motorista
                            </label>
                            <textarea
                              disabled={view}
                              className="form-control"
                              onChange={(e) => setObservation(e.target.value)}
                              value={observation || ""}
                              id="observation"
                              rows="3"
                              maxLength={600}
                              style={{
                                borderRadius: "10px",
                              }}
                            />
                            <div
                              className="text-end text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              {observation?.length || 0}/600
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-signin mx-auto">
                        <div className="row">
                          <div className="col-12">
                            <label
                              htmlFor="internalObservations"
                              className="font-test"
                            >
                              Observações internas
                            </label>
                            <textarea
                              disabled={view}
                              className="form-control"
                              onChange={(e) =>
                                setInternalObservations(e.target.value)
                              }
                              value={
                                internalObservations && internalObservations
                              }
                              id="internalObservations"
                              rows="3"
                              maxLength={600}
                              style={{
                                borderRadius: "10px",
                              }}
                            />
                            <div
                              className="text-end text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              {internalObservations?.length || 0}/600
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>

                  <div className="container">
                    <div className="row">
                      <div className="col-4"></div>
                      <div className="col-4"></div>
                      <div
                        className="col-4"
                        style={{
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        <div
                          className="btn-class-cadastrar"
                          style={{ flex: 1 }}
                        >
                          <Link to={"/freightlistCopy"}>
                            <BackButton />
                          </Link>
                        </div>

                        {id &&
                          (code === "04" || code === "05" || code === "06") ? (
                          <div
                            className="btn-class-cadastrar"
                            style={{ flex: 1 }}
                          >
                            {carregando ? (
                              <div
                                className="spinner-border text-danger"
                                role="status"
                              >
                                <span className="visually-hidden ">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <button
                                disabled={view || isCarrierSaveLocked}
                                type="submit"
                                onClick={(e) => update(true, false)}
                                className="w-100 btn btn-primary btn-cadastrar"
                              >
                                {"Finalizar"}
                              </button>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {showReleaseFreightButton ? (
                          <div
                            className="btn-class-cadastrar"
                            style={{ flex: 1 }}
                          >
                            {carregando ? (
                              <div
                                className="spinner-border text-danger"
                                role="status"
                              >
                                <span className="visually-hidden ">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <button
                                disabled={view || carregando}
                                type="button"
                                onClick={() => handleReleaseFreight()}
                                className="w-100 btn btn-success btn-cadastrar"
                              >
                                {"Liberar Frete"}
                              </button>
                            )}
                          </div>
                        ) : null}

                        <div
                          className="btn-class-cadastrar"
                          style={{ flex: 1 }}
                        >
                          {carregando ? (
                            <div
                              className="spinner-border text-danger"
                              role="status"
                            >
                              <span className="visually-hidden ">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <button
                              disabled={
                                view || carregando || isCarrierSaveLocked
                              }
                              type="submit"
                              onClick={(e) => handleSave()}
                              className="w-100 btn btn-primary btn-cadastrar"
                            >
                              {"Salvar"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <FreightCalculationLoadingModal
                      open={freightCalculationLoading}
                    />
                  </div>

                  <div>
                    <ModernAlertDialog
                      open={open}
                      handleClose={handleClose}
                      title={title}
                      msg={msg}
                    />
                  </div>

                  <div>
                    <CancelFreightDialog
                      open={openCancelDialog}
                      loading={carregando === 1}
                      onClose={() => setOpenCancelDialog(false)}
                      onConfirm={handleCancelFreight}
                    />
                  </div>

                  <div>
                    <CancelFreightDialog
                      open={openReactivateDialog}
                      loading={carregando === 1}
                      onClose={() => setOpenReactivateDialog(false)}
                      onConfirm={handleReactivateFreight}
                      title="Reativar frete"
                      confirmOnly
                    />
                  </div>

                  <div>
                    <Dialog
                      open={openDialog}
                      keepMounted
                      onClose={handleCloseDialog}
                      aria-describedby="alert-dialog-slide-description"
                    >
                      <DialogTitle>{title}</DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                          {msg}
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleCloseDialog}>Cancelar</Button>
                        <Button onClick={handleClickDialog}>OK</Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </div>
              </Box>
            }
          />
        ) : (
          <Navigate to="/login" />
        )}

        <FreightEditedSuccessModal
          open={openSuccessModal}
          handleClose={() => handleModalResult(true)}
          onResult={handleModalResult}
          dataMsg={openFreightEditedSuccessModal}
        />
      </>
    </div>
  );
}

export default FreightCopy;
